var map = {
	"./book-preview.png": "zpjC",
	"./book1.jpg": "6FYu",
	"./character1.png": "tiYY",
	"./character2.png": "X4ol",
	"./child_to_parent/band_0.png": "W+NM",
	"./child_to_parent/band_1.png": "Lt4X",
	"./child_to_parent/band_10_daughter.png": "vP8K",
	"./child_to_parent/band_10_son.png": "FZqt",
	"./child_to_parent/band_11_daughter.png": "Tu8D",
	"./child_to_parent/band_11_son.png": "givU",
	"./child_to_parent/band_12_daughter.png": "07M8",
	"./child_to_parent/band_12_son.png": "roop",
	"./child_to_parent/band_13_daughter.png": "KQ7t",
	"./child_to_parent/band_13_son.png": "jqxi",
	"./child_to_parent/band_14_daughter.png": "rqJY",
	"./child_to_parent/band_14_son.png": "RMD9",
	"./child_to_parent/band_15_daughter.png": "8hRw",
	"./child_to_parent/band_15_son.png": "u283",
	"./child_to_parent/band_16_daughter.png": "aYW3",
	"./child_to_parent/band_16_son.png": "5VvW",
	"./child_to_parent/band_17_daughter.png": "J1kA",
	"./child_to_parent/band_17_son.png": "Lonk",
	"./child_to_parent/band_2.png": "9m2M",
	"./child_to_parent/band_3.png": "KMBa",
	"./child_to_parent/band_4.png": "lPoN",
	"./child_to_parent/band_5.png": "7Wq4",
	"./child_to_parent/band_6.png": "bpUk",
	"./child_to_parent/band_7.png": "Cp3P",
	"./child_to_parent/band_8_daughter.png": "L0LT",
	"./child_to_parent/band_8_son.png": "/wqX",
	"./child_to_parent/band_9_daughter.png": "wb4z",
	"./child_to_parent/band_9_son.png": "+seM",
	"./child_to_parent/bg_panflet_daughter.png": "Mgfa",
	"./child_to_parent/bg_panflet_son.png": "YTGU",
	"./child_to_parent/font_anzu_daughter.png": "oWbf",
	"./child_to_parent/font_banana_son.png": "+s8M",
	"./child_to_parent/font_beautiful_daughter.png": "FIbV",
	"./child_to_parent/font_darts_daughter.png": "mEzk",
	"./child_to_parent/font_darts_son.png": "vN9s",
	"./child_to_parent/font_genshin_daughter.png": "0TTT",
	"./child_to_parent/font_genshin_son.png": "DmHZ",
	"./child_to_parent/font_hui_daughter.png": "08gO",
	"./child_to_parent/font_hui_son.png": "MbZB",
	"./child_to_parent/font_kacho_son.png": "CQUD",
	"./child_to_parent/font_malecharacter_son.png": "nfwL",
	"./child_to_parent/font_uzura_daughter.png": "k6II",
	"./custom/aoyama/dad/layer1/01_face.png": "XWB5",
	"./custom/aoyama/dad/layer1/02_face.png": "VxcQ",
	"./custom/aoyama/dad/layer1/03_face.png": "ccPC",
	"./custom/aoyama/dad/layer1/04_face.png": "6BG8",
	"./custom/aoyama/dad/layer1/05_face.png": "Urhs",
	"./custom/aoyama/dad/layer1/06_face.png": "vZUz",
	"./custom/aoyama/dad/layer1/07_face.png": "pIRH",
	"./custom/aoyama/dad/layer1/08_face.png": "WYSN",
	"./custom/aoyama/dad/layer1/09_face.png": "26Hp",
	"./custom/aoyama/dad/layer2/00_mole.png": "SpVQ",
	"./custom/aoyama/dad/layer2/01_mole.png": "Ad5c",
	"./custom/aoyama/dad/layer2/02_mole.png": "vPv+",
	"./custom/aoyama/dad/layer2/03_mole.png": "0FAc",
	"./custom/aoyama/dad/layer2/04_mole.png": "G6Xz",
	"./custom/aoyama/dad/layer2/05_mole.png": "It2u",
	"./custom/aoyama/dad/layer2/06_mole.png": "lYhg",
	"./custom/aoyama/dad/layer2/07_mole.png": "obG4",
	"./custom/aoyama/dad/layer2/08_mole.png": "oM3W",
	"./custom/aoyama/dad/layer2/09_mole.png": "fl8d",
	"./custom/aoyama/dad/layer2/10_mole.png": "HsEm",
	"./custom/aoyama/dad/layer3/00_hige.png": "zI6J",
	"./custom/aoyama/dad/layer3/01_hige_black.png": "UqE8",
	"./custom/aoyama/dad/layer3/01_hige_white.png": "fJRd",
	"./custom/aoyama/dad/layer3/02_hige_black.png": "iTGo",
	"./custom/aoyama/dad/layer3/02_hige_white.png": "MqMq",
	"./custom/aoyama/dad/layer3/03_hige_black.png": "jHVI",
	"./custom/aoyama/dad/layer3/03_hige_white.png": "4rPS",
	"./custom/aoyama/dad/layer3/04_hige_black.png": "ZN1p",
	"./custom/aoyama/dad/layer3/04_hige_white.png": "Ueqk",
	"./custom/aoyama/dad/layer3/05_hige_black.png": "pQHx",
	"./custom/aoyama/dad/layer3/05_hige_white.png": "3zzE",
	"./custom/aoyama/dad/layer3/06_hige_black.png": "6ru7",
	"./custom/aoyama/dad/layer3/06_hige_white.png": "y4Qm",
	"./custom/aoyama/dad/layer3/07_hige_black.png": "I5m/",
	"./custom/aoyama/dad/layer3/07_hige_white.png": "qup2",
	"./custom/aoyama/dad/layer3/08_hige_black.png": "T4dH",
	"./custom/aoyama/dad/layer3/08_hige_white.png": "Ju6s",
	"./custom/aoyama/dad/layer3/09_hige_black.png": "ORnS",
	"./custom/aoyama/dad/layer3/09_hige_white.png": "jwIN",
	"./custom/aoyama/dad/layer3/10_hige_black.png": "eFFp",
	"./custom/aoyama/dad/layer3/10_hige_white.png": "MV4W",
	"./custom/aoyama/dad/layer3/11_hige_black.png": "Zwdt",
	"./custom/aoyama/dad/layer3/11_hige_white.png": "WF1O",
	"./custom/aoyama/dad/layer4/00_glasses.png": "lpT/",
	"./custom/aoyama/dad/layer4/01_glasses_black.png": "WlVa",
	"./custom/aoyama/dad/layer4/01_glasses_brown.png": "TPKA",
	"./custom/aoyama/dad/layer4/01_glasses_red.png": "oYke",
	"./custom/aoyama/dad/layer4/02_glasses_black.png": "BiOd",
	"./custom/aoyama/dad/layer4/02_glasses_brown.png": "6+iM",
	"./custom/aoyama/dad/layer4/02_glasses_red.png": "15sE",
	"./custom/aoyama/dad/layer4/03_glasses_black.png": "7a6/",
	"./custom/aoyama/dad/layer4/03_glasses_brown.png": "+0kY",
	"./custom/aoyama/dad/layer4/03_glasses_red.png": "AuSq",
	"./custom/aoyama/dad/layer4/04_glasses_black.png": "6S9M",
	"./custom/aoyama/dad/layer4/04_glasses_brown.png": "fB4w",
	"./custom/aoyama/dad/layer4/04_glasses_red.png": "zr1c",
	"./custom/aoyama/dad/layer4/05_glasses_black.png": "QiA5",
	"./custom/aoyama/dad/layer4/05_glasses_brown.png": "e8u/",
	"./custom/aoyama/dad/layer4/05_glasses_red.png": "+RjI",
	"./custom/aoyama/dad/layer5/00_hair.png": "Gdhk",
	"./custom/aoyama/dad/layer5/01_long_beige.png": "2Mwm",
	"./custom/aoyama/dad/layer5/01_long_black.png": "0pwF",
	"./custom/aoyama/dad/layer5/01_long_brown.png": "GrLg",
	"./custom/aoyama/dad/layer5/01_long_gold.png": "ge0Q",
	"./custom/aoyama/dad/layer5/01_long_gray.png": "Grck",
	"./custom/aoyama/dad/layer5/01_medium_beige.png": "Y89H",
	"./custom/aoyama/dad/layer5/01_medium_black.png": "RWfh",
	"./custom/aoyama/dad/layer5/01_medium_brown.png": "PNy9",
	"./custom/aoyama/dad/layer5/01_medium_gold.png": "aFPV",
	"./custom/aoyama/dad/layer5/01_medium_gray.png": "wNVQ",
	"./custom/aoyama/dad/layer5/01_short_beige.png": "KfU8",
	"./custom/aoyama/dad/layer5/01_short_black.png": "EKwk",
	"./custom/aoyama/dad/layer5/01_short_brown.png": "yQQv",
	"./custom/aoyama/dad/layer5/01_short_gold.png": "poms",
	"./custom/aoyama/dad/layer5/01_short_gray.png": "kzgs",
	"./custom/aoyama/dad/layer5/01_veryshort_beige.png": "c+FZ",
	"./custom/aoyama/dad/layer5/01_veryshort_black.png": "pp9M",
	"./custom/aoyama/dad/layer5/01_veryshort_brown.png": "CD0H",
	"./custom/aoyama/dad/layer5/01_veryshort_gold.png": "ebKS",
	"./custom/aoyama/dad/layer5/01_veryshort_gray.png": "wWsn",
	"./custom/aoyama/dad/layer5/02_long_beige.png": "xLBY",
	"./custom/aoyama/dad/layer5/02_long_black.png": "Wgl+",
	"./custom/aoyama/dad/layer5/02_long_brown.png": "xtQp",
	"./custom/aoyama/dad/layer5/02_long_gold.png": "zcDQ",
	"./custom/aoyama/dad/layer5/02_long_gray.png": "HEhw",
	"./custom/aoyama/dad/layer5/02_medium_beige.png": "ilov",
	"./custom/aoyama/dad/layer5/02_medium_black.png": "a5CS",
	"./custom/aoyama/dad/layer5/02_medium_brown.png": "vK65",
	"./custom/aoyama/dad/layer5/02_medium_gold.png": "7ddA",
	"./custom/aoyama/dad/layer5/02_medium_gray.png": "uAtt",
	"./custom/aoyama/dad/layer5/02_short_beige.png": "7nSK",
	"./custom/aoyama/dad/layer5/02_short_black.png": "VpGy",
	"./custom/aoyama/dad/layer5/02_short_brown.png": "NSIk",
	"./custom/aoyama/dad/layer5/02_short_gold.png": "nkyg",
	"./custom/aoyama/dad/layer5/02_short_gray.png": "r0lI",
	"./custom/aoyama/dad/layer5/02_veryshort_beige.png": "xg2q",
	"./custom/aoyama/dad/layer5/02_veryshort_black.png": "hIJN",
	"./custom/aoyama/dad/layer5/02_veryshort_brown.png": "5PRr",
	"./custom/aoyama/dad/layer5/02_veryshort_gold.png": "0m4Z",
	"./custom/aoyama/dad/layer5/02_veryshort_gray.png": "P5WR",
	"./custom/aoyama/dad/layer5/03_long_beige.png": "EYAv",
	"./custom/aoyama/dad/layer5/03_long_black.png": "RXfY",
	"./custom/aoyama/dad/layer5/03_long_brown.png": "UbCo",
	"./custom/aoyama/dad/layer5/03_long_gold.png": "tUae",
	"./custom/aoyama/dad/layer5/03_long_gray.png": "X1TK",
	"./custom/aoyama/dad/layer5/03_medium_beige.png": "2bsV",
	"./custom/aoyama/dad/layer5/03_medium_black.png": "YGcS",
	"./custom/aoyama/dad/layer5/03_medium_brown.png": "Mvou",
	"./custom/aoyama/dad/layer5/03_medium_gold.png": "2lK8",
	"./custom/aoyama/dad/layer5/03_medium_gray.png": "6l0L",
	"./custom/aoyama/dad/layer5/03_short_beige.png": "e4qs",
	"./custom/aoyama/dad/layer5/03_short_black.png": "kLUR",
	"./custom/aoyama/dad/layer5/03_short_brown.png": "Wxp3",
	"./custom/aoyama/dad/layer5/03_short_gold.png": "0RpM",
	"./custom/aoyama/dad/layer5/03_short_gray.png": "npF5",
	"./custom/aoyama/dad/layer5/03_veryshort_beige.png": "xZ7W",
	"./custom/aoyama/dad/layer5/03_veryshort_black.png": "dfUu",
	"./custom/aoyama/dad/layer5/03_veryshort_brown.png": "+eI4",
	"./custom/aoyama/dad/layer5/03_veryshort_gold.png": "TZz8",
	"./custom/aoyama/dad/layer5/03_veryshort_gray.png": "LtIN",
	"./custom/aoyama/dad/layer5/04_long_beige.png": "eVAn",
	"./custom/aoyama/dad/layer5/04_long_black.png": "JbBw",
	"./custom/aoyama/dad/layer5/04_long_brown.png": "OpCm",
	"./custom/aoyama/dad/layer5/04_long_gold.png": "tb25",
	"./custom/aoyama/dad/layer5/04_long_gray.png": "rmqT",
	"./custom/aoyama/dad/layer5/04_medium_beige.png": "PuNX",
	"./custom/aoyama/dad/layer5/04_medium_black.png": "KmLR",
	"./custom/aoyama/dad/layer5/04_medium_brown.png": "iNss",
	"./custom/aoyama/dad/layer5/04_medium_gold.png": "JFjF",
	"./custom/aoyama/dad/layer5/04_medium_gray.png": "XyBW",
	"./custom/aoyama/dad/layer5/04_short_beige.png": "im5q",
	"./custom/aoyama/dad/layer5/04_short_black.png": "XKdi",
	"./custom/aoyama/dad/layer5/04_short_brown.png": "y8UJ",
	"./custom/aoyama/dad/layer5/04_short_gold.png": "QNWl",
	"./custom/aoyama/dad/layer5/04_short_gray.png": "UZAD",
	"./custom/aoyama/dad/layer5/04_veryshort_beige.png": "hPAd",
	"./custom/aoyama/dad/layer5/04_veryshort_black.png": "DX0C",
	"./custom/aoyama/dad/layer5/04_veryshort_brown.png": "nfUg",
	"./custom/aoyama/dad/layer5/04_veryshort_gold.png": "yxQJ",
	"./custom/aoyama/dad/layer5/04_veryshort_gray.png": "c1f1",
	"./custom/aoyama/dad/layer5/05_medium_beige.png": "ugDD",
	"./custom/aoyama/dad/layer5/05_medium_black.png": "J+1a",
	"./custom/aoyama/dad/layer5/05_medium_brown.png": "0+k1",
	"./custom/aoyama/dad/layer5/05_medium_gold.png": "uiCR",
	"./custom/aoyama/dad/layer5/05_medium_gray.png": "eDjz",
	"./custom/aoyama/dad/layer5/05_short_beige.png": "+bZA",
	"./custom/aoyama/dad/layer5/05_short_black.png": "aAuU",
	"./custom/aoyama/dad/layer5/05_short_brown.png": "P4b/",
	"./custom/aoyama/dad/layer5/05_short_gold.png": "oXE7",
	"./custom/aoyama/dad/layer5/05_short_gray.png": "5EGr",
	"./custom/aoyama/dad/layer5/05_veryshort_beige.png": "HnWs",
	"./custom/aoyama/dad/layer5/05_veryshort_black.png": "6P2b",
	"./custom/aoyama/dad/layer5/05_veryshort_brown.png": "KUlP",
	"./custom/aoyama/dad/layer5/05_veryshort_gold.png": "7U0U",
	"./custom/aoyama/dad/layer5/05_veryshort_gray.png": "3BVY",
	"./custom/aoyama/dad/layer5/06_short_beige.png": "C/7P",
	"./custom/aoyama/dad/layer5/06_short_black.png": "oS1J",
	"./custom/aoyama/dad/layer5/06_short_brown.png": "ULM1",
	"./custom/aoyama/dad/layer5/06_short_gold.png": "YJtv",
	"./custom/aoyama/dad/layer5/06_short_gray.png": "qX0U",
	"./custom/aoyama/daughter/layer1/01_face.png": "ZSge",
	"./custom/aoyama/daughter/layer1/02_face.png": "SZ0x",
	"./custom/aoyama/daughter/layer1/03_face.png": "RaKc",
	"./custom/aoyama/daughter/layer1/04_face.png": "Dvap",
	"./custom/aoyama/daughter/layer1/05_face.png": "aOWY",
	"./custom/aoyama/daughter/layer1/06_face.png": "y5LT",
	"./custom/aoyama/daughter/layer1/07_face.png": "arIF",
	"./custom/aoyama/daughter/layer1/08_face.png": "KF4y",
	"./custom/aoyama/daughter/layer1/09_face.png": "9ngt",
	"./custom/aoyama/daughter/layer2/00_mole.png": "4VMN",
	"./custom/aoyama/daughter/layer2/01_mole.png": "uwHR",
	"./custom/aoyama/daughter/layer2/02_mole.png": "DsTG",
	"./custom/aoyama/daughter/layer2/03_mole.png": "KsXu",
	"./custom/aoyama/daughter/layer2/04_mole.png": "SjUP",
	"./custom/aoyama/daughter/layer2/05_mole.png": "KtsH",
	"./custom/aoyama/daughter/layer2/06_mole.png": "D2EN",
	"./custom/aoyama/daughter/layer2/07_mole.png": "HDdz",
	"./custom/aoyama/daughter/layer2/08_mole.png": "N858",
	"./custom/aoyama/daughter/layer2/09_mole.png": "g5ZX",
	"./custom/aoyama/daughter/layer2/10_mole.png": "jm8a",
	"./custom/aoyama/daughter/layer3/00_cheeks.png": "/XQH",
	"./custom/aoyama/daughter/layer3/01_cheeks.png": "XnY5",
	"./custom/aoyama/daughter/layer4/00_glasses.png": "//oi",
	"./custom/aoyama/daughter/layer4/01_glasses_black.png": "zAo2",
	"./custom/aoyama/daughter/layer4/01_glasses_brown.png": "eueX",
	"./custom/aoyama/daughter/layer4/01_glasses_red.png": "XmB9",
	"./custom/aoyama/daughter/layer4/02_glasses_black.png": "5Ajc",
	"./custom/aoyama/daughter/layer4/02_glasses_brown.png": "B9P8",
	"./custom/aoyama/daughter/layer4/02_glasses_red.png": "EVzk",
	"./custom/aoyama/daughter/layer4/03_glasses_black.png": "q7si",
	"./custom/aoyama/daughter/layer4/03_glasses_brown.png": "jbMP",
	"./custom/aoyama/daughter/layer4/03_glasses_red.png": "ztVR",
	"./custom/aoyama/daughter/layer4/04_glasses_black.png": "nttS",
	"./custom/aoyama/daughter/layer4/04_glasses_brown.png": "Fh0N",
	"./custom/aoyama/daughter/layer4/04_glasses_red.png": "dMXs",
	"./custom/aoyama/daughter/layer4/05_glasses_black.png": "3zxJ",
	"./custom/aoyama/daughter/layer4/05_glasses_brown.png": "Leek",
	"./custom/aoyama/daughter/layer4/05_glasses_red.png": "lDNW",
	"./custom/aoyama/daughter/layer5/00_hair.png": "n4AJ",
	"./custom/aoyama/daughter/layer5/01_bob_beige.png": "wy6s",
	"./custom/aoyama/daughter/layer5/01_bob_black.png": "ymM5",
	"./custom/aoyama/daughter/layer5/01_bob_brown.png": "7FFU",
	"./custom/aoyama/daughter/layer5/01_bob_gold.png": "YsMX",
	"./custom/aoyama/daughter/layer5/01_bob_gray.png": "pgc5",
	"./custom/aoyama/daughter/layer5/01_long_beige.png": "CI4+",
	"./custom/aoyama/daughter/layer5/01_long_black.png": "05Ie",
	"./custom/aoyama/daughter/layer5/01_long_brown.png": "GwD7",
	"./custom/aoyama/daughter/layer5/01_long_gold.png": "QYQl",
	"./custom/aoyama/daughter/layer5/01_long_gray.png": "Wpuh",
	"./custom/aoyama/daughter/layer5/01_short_beige.png": "gn+V",
	"./custom/aoyama/daughter/layer5/01_short_black.png": "KTRc",
	"./custom/aoyama/daughter/layer5/01_short_brown.png": "Lijt",
	"./custom/aoyama/daughter/layer5/01_short_gold.png": "xOM2",
	"./custom/aoyama/daughter/layer5/01_short_gray.png": "3JVU",
	"./custom/aoyama/daughter/layer5/02_bob_beige.png": "wVTV",
	"./custom/aoyama/daughter/layer5/02_bob_black.png": "dY9C",
	"./custom/aoyama/daughter/layer5/02_bob_brown.png": "bAsp",
	"./custom/aoyama/daughter/layer5/02_bob_gold.png": "FPHS",
	"./custom/aoyama/daughter/layer5/02_bob_gray.png": "BV3v",
	"./custom/aoyama/daughter/layer5/02_long_beige.png": "r3/Y",
	"./custom/aoyama/daughter/layer5/02_long_black.png": "KFQh",
	"./custom/aoyama/daughter/layer5/02_long_brown.png": "ACma",
	"./custom/aoyama/daughter/layer5/02_long_gold.png": "2N6F",
	"./custom/aoyama/daughter/layer5/02_long_gray.png": "izx2",
	"./custom/aoyama/daughter/layer5/02_short_beige.png": "lmPQ",
	"./custom/aoyama/daughter/layer5/02_short_black.png": "Fv94",
	"./custom/aoyama/daughter/layer5/02_short_brown.png": "7pl0",
	"./custom/aoyama/daughter/layer5/02_short_gold.png": "4Rpr",
	"./custom/aoyama/daughter/layer5/02_short_gray.png": "wby+",
	"./custom/aoyama/daughter/layer5/03_bob_beige.png": "NRE5",
	"./custom/aoyama/daughter/layer5/03_bob_black.png": "ssVf",
	"./custom/aoyama/daughter/layer5/03_bob_brown.png": "5aqv",
	"./custom/aoyama/daughter/layer5/03_bob_gold.png": "Z7sI",
	"./custom/aoyama/daughter/layer5/03_bob_gray.png": "BO7v",
	"./custom/aoyama/daughter/layer5/03_long_beige.png": "rYG7",
	"./custom/aoyama/daughter/layer5/03_long_black.png": "5Op1",
	"./custom/aoyama/daughter/layer5/03_long_brown.png": "4QF3",
	"./custom/aoyama/daughter/layer5/03_long_gold.png": "RPhS",
	"./custom/aoyama/daughter/layer5/03_long_gray.png": "kYEM",
	"./custom/aoyama/daughter/layer5/03_short_beige.png": "DUkh",
	"./custom/aoyama/daughter/layer5/03_short_black.png": "oT2i",
	"./custom/aoyama/daughter/layer5/03_short_brown.png": "k8qq",
	"./custom/aoyama/daughter/layer5/03_short_gold.png": "J6pL",
	"./custom/aoyama/daughter/layer5/03_short_gray.png": "O5IG",
	"./custom/aoyama/daughter/layer5/04_bob_beige.png": "WKOJ",
	"./custom/aoyama/daughter/layer5/04_bob_black.png": "ILtn",
	"./custom/aoyama/daughter/layer5/04_bob_brown.png": "PgWp",
	"./custom/aoyama/daughter/layer5/04_bob_gold.png": "avlK",
	"./custom/aoyama/daughter/layer5/04_bob_gray.png": "swlA",
	"./custom/aoyama/daughter/layer5/04_long_beige.png": "11Y1",
	"./custom/aoyama/daughter/layer5/04_long_black.png": "sMn/",
	"./custom/aoyama/daughter/layer5/04_long_brown.png": "EqLd",
	"./custom/aoyama/daughter/layer5/04_long_gold.png": "PggZ",
	"./custom/aoyama/daughter/layer5/04_long_gray.png": "8qU1",
	"./custom/aoyama/daughter/layer5/04_short_beige.png": "Dtm/",
	"./custom/aoyama/daughter/layer5/04_short_black.png": "OV+P",
	"./custom/aoyama/daughter/layer5/04_short_brown.png": "TF5P",
	"./custom/aoyama/daughter/layer5/04_short_gold.png": "BKik",
	"./custom/aoyama/daughter/layer5/04_short_gray.png": "lrx/",
	"./custom/aoyama/daughter/layer5/05_bob_beige.png": "CJh3",
	"./custom/aoyama/daughter/layer5/05_bob_black.png": "tKAJ",
	"./custom/aoyama/daughter/layer5/05_bob_brown.png": "ooeF",
	"./custom/aoyama/daughter/layer5/05_bob_gold.png": "G7ic",
	"./custom/aoyama/daughter/layer5/05_bob_gray.png": "+u9l",
	"./custom/aoyama/daughter/layer5/05_long_beige.png": "xx32",
	"./custom/aoyama/daughter/layer5/05_long_black.png": "QqFA",
	"./custom/aoyama/daughter/layer5/05_long_brown.png": "xzqt",
	"./custom/aoyama/daughter/layer5/05_long_gold.png": "yW08",
	"./custom/aoyama/daughter/layer5/05_long_gray.png": "9NyE",
	"./custom/aoyama/daughter/layer5/05_short_beige.png": "wWds",
	"./custom/aoyama/daughter/layer5/05_short_black.png": "3OUn",
	"./custom/aoyama/daughter/layer5/05_short_brown.png": "YCI0",
	"./custom/aoyama/daughter/layer5/05_short_gold.png": "+Gk9",
	"./custom/aoyama/daughter/layer5/05_short_gray.png": "qH6y",
	"./custom/aoyama/daughter/layer5/06_bob_beige.png": "me+8",
	"./custom/aoyama/daughter/layer5/06_bob_black.png": "njnt",
	"./custom/aoyama/daughter/layer5/06_bob_brown.png": "sip9",
	"./custom/aoyama/daughter/layer5/06_bob_gold.png": "T9sn",
	"./custom/aoyama/daughter/layer5/06_bob_gray.png": "HA8M",
	"./custom/aoyama/daughter/layer5/06_long_beige.png": "wiqq",
	"./custom/aoyama/daughter/layer5/06_long_black.png": "FZec",
	"./custom/aoyama/daughter/layer5/06_long_brown.png": "bZzw",
	"./custom/aoyama/daughter/layer5/06_long_gold.png": "y+tg",
	"./custom/aoyama/daughter/layer5/06_long_gray.png": "287A",
	"./custom/aoyama/daughter/layer5/07_bob_beige.png": "H8S8",
	"./custom/aoyama/daughter/layer5/07_bob_black.png": "zwX1",
	"./custom/aoyama/daughter/layer5/07_bob_brown.png": "SlUk",
	"./custom/aoyama/daughter/layer5/07_bob_gold.png": "6Tc9",
	"./custom/aoyama/daughter/layer5/07_bob_gray.png": "XJqt",
	"./custom/aoyama/daughter/layer5/07_long_beige.png": "nS7W",
	"./custom/aoyama/daughter/layer5/07_long_black.png": "V2PG",
	"./custom/aoyama/daughter/layer5/07_long_brown.png": "opvW",
	"./custom/aoyama/daughter/layer5/07_long_gold.png": "MAQr",
	"./custom/aoyama/daughter/layer5/07_long_gray.png": "VAZi",
	"./custom/aoyama/mom/layer1/01_face.png": "5DTj",
	"./custom/aoyama/mom/layer1/02_face.png": "ueNL",
	"./custom/aoyama/mom/layer1/03_face.png": "5Ya+",
	"./custom/aoyama/mom/layer1/04_face.png": "Goyx",
	"./custom/aoyama/mom/layer1/05_face.png": "Hi5U",
	"./custom/aoyama/mom/layer1/06_face.png": "ItZ5",
	"./custom/aoyama/mom/layer1/07_face.png": "3k6c",
	"./custom/aoyama/mom/layer1/08_face.png": "ElSP",
	"./custom/aoyama/mom/layer1/09_face.png": "kate",
	"./custom/aoyama/mom/layer2/00_mole.png": "V8mz",
	"./custom/aoyama/mom/layer2/01_mole.png": "lPT+",
	"./custom/aoyama/mom/layer2/02_mole.png": "YoaK",
	"./custom/aoyama/mom/layer2/03_mole.png": "9gZb",
	"./custom/aoyama/mom/layer2/04_mole.png": "tWwh",
	"./custom/aoyama/mom/layer2/05_mole.png": "ICBO",
	"./custom/aoyama/mom/layer2/06_mole.png": "fUB7",
	"./custom/aoyama/mom/layer2/07_mole.png": "HPpk",
	"./custom/aoyama/mom/layer2/08_mole.png": "Sqgg",
	"./custom/aoyama/mom/layer2/09_mole.png": "oIRS",
	"./custom/aoyama/mom/layer2/10_mole.png": "Ep6G",
	"./custom/aoyama/mom/layer3/00_cheeks.png": "rTBq",
	"./custom/aoyama/mom/layer3/01_cheeks.png": "GQ8m",
	"./custom/aoyama/mom/layer4/00_glasses.png": "NcZs",
	"./custom/aoyama/mom/layer4/01_glasses_black.png": "T7zX",
	"./custom/aoyama/mom/layer4/01_glasses_brown.png": "KCQU",
	"./custom/aoyama/mom/layer4/01_glasses_red.png": "ChuU",
	"./custom/aoyama/mom/layer4/02_glasses_black.png": "Pkhn",
	"./custom/aoyama/mom/layer4/02_glasses_brown.png": "8m5i",
	"./custom/aoyama/mom/layer4/02_glasses_red.png": "845k",
	"./custom/aoyama/mom/layer4/03_glasses_black.png": "oVlT",
	"./custom/aoyama/mom/layer4/03_glasses_brown.png": "9lky",
	"./custom/aoyama/mom/layer4/03_glasses_red.png": "KazW",
	"./custom/aoyama/mom/layer4/04_glasses_black.png": "b29H",
	"./custom/aoyama/mom/layer4/04_glasses_brown.png": "lNHH",
	"./custom/aoyama/mom/layer4/04_glasses_red.png": "xGnJ",
	"./custom/aoyama/mom/layer4/05_glasses_black.png": "qC6g",
	"./custom/aoyama/mom/layer4/05_glasses_brown.png": "kDJC",
	"./custom/aoyama/mom/layer4/05_glasses_red.png": "i8be",
	"./custom/aoyama/mom/layer5/00_hair.png": "bfEt",
	"./custom/aoyama/mom/layer5/01_bob_beige.png": "mdkd",
	"./custom/aoyama/mom/layer5/01_bob_black.png": "vF8T",
	"./custom/aoyama/mom/layer5/01_bob_brown.png": "tTOO",
	"./custom/aoyama/mom/layer5/01_bob_gold.png": "RfD5",
	"./custom/aoyama/mom/layer5/01_bob_gray.png": "/Eg/",
	"./custom/aoyama/mom/layer5/01_long_beige.png": "zNc4",
	"./custom/aoyama/mom/layer5/01_long_black.png": "fRjL",
	"./custom/aoyama/mom/layer5/01_long_brown.png": "yTGx",
	"./custom/aoyama/mom/layer5/01_long_gold.png": "ZUJ0",
	"./custom/aoyama/mom/layer5/01_long_gray.png": "Y9I5",
	"./custom/aoyama/mom/layer5/01_short_beige.png": "GmmA",
	"./custom/aoyama/mom/layer5/01_short_black.png": "0HfM",
	"./custom/aoyama/mom/layer5/01_short_brown.png": "GhQv",
	"./custom/aoyama/mom/layer5/01_short_gold.png": "FGd0",
	"./custom/aoyama/mom/layer5/01_short_gray.png": "tLgs",
	"./custom/aoyama/mom/layer5/02_bob_beige.png": "GPyk",
	"./custom/aoyama/mom/layer5/02_bob_black.png": "ZNyg",
	"./custom/aoyama/mom/layer5/02_bob_brown.png": "Fngo",
	"./custom/aoyama/mom/layer5/02_bob_gold.png": "v8t4",
	"./custom/aoyama/mom/layer5/02_bob_gray.png": "Rsf0",
	"./custom/aoyama/mom/layer5/02_long_beige.png": "ITJ2",
	"./custom/aoyama/mom/layer5/02_long_black.png": "KZ10",
	"./custom/aoyama/mom/layer5/02_long_brown.png": "X2UC",
	"./custom/aoyama/mom/layer5/02_long_gold.png": "NJkw",
	"./custom/aoyama/mom/layer5/02_long_gray.png": "+PPP",
	"./custom/aoyama/mom/layer5/02_short_beige.png": "voC8",
	"./custom/aoyama/mom/layer5/02_short_black.png": "B99E",
	"./custom/aoyama/mom/layer5/02_short_brown.png": "IQNu",
	"./custom/aoyama/mom/layer5/02_short_gold.png": "dJVw",
	"./custom/aoyama/mom/layer5/02_short_gray.png": "msf4",
	"./custom/aoyama/mom/layer5/03_bob_beige.png": "wTav",
	"./custom/aoyama/mom/layer5/03_bob_black.png": "xfaB",
	"./custom/aoyama/mom/layer5/03_bob_brown.png": "/FUJ",
	"./custom/aoyama/mom/layer5/03_bob_gold.png": "CF2O",
	"./custom/aoyama/mom/layer5/03_bob_gray.png": "MOfU",
	"./custom/aoyama/mom/layer5/03_long_beige.png": "9cKf",
	"./custom/aoyama/mom/layer5/03_long_black.png": "sv6P",
	"./custom/aoyama/mom/layer5/03_long_brown.png": "m4sP",
	"./custom/aoyama/mom/layer5/03_long_gold.png": "hwCv",
	"./custom/aoyama/mom/layer5/03_long_gray.png": "n/0v",
	"./custom/aoyama/mom/layer5/03_short_beige.png": "kOgu",
	"./custom/aoyama/mom/layer5/03_short_black.png": "9/hX",
	"./custom/aoyama/mom/layer5/03_short_brown.png": "HRs6",
	"./custom/aoyama/mom/layer5/03_short_gold.png": "ViGG",
	"./custom/aoyama/mom/layer5/03_short_gray.png": "0ARk",
	"./custom/aoyama/mom/layer5/04_bob_beige.png": "I8nQ",
	"./custom/aoyama/mom/layer5/04_bob_black.png": "w3nJ",
	"./custom/aoyama/mom/layer5/04_bob_brown.png": "siXh",
	"./custom/aoyama/mom/layer5/04_bob_gold.png": "fiwy",
	"./custom/aoyama/mom/layer5/04_bob_gray.png": "+L8M",
	"./custom/aoyama/mom/layer5/04_long_beige.png": "Kjjk",
	"./custom/aoyama/mom/layer5/04_long_black.png": "WVYG",
	"./custom/aoyama/mom/layer5/04_long_brown.png": "Ox2w",
	"./custom/aoyama/mom/layer5/04_long_gold.png": "goMJ",
	"./custom/aoyama/mom/layer5/04_long_gray.png": "/y/R",
	"./custom/aoyama/mom/layer5/04_short_beige.png": "LrmD",
	"./custom/aoyama/mom/layer5/04_short_black.png": "iPf+",
	"./custom/aoyama/mom/layer5/04_short_brown.png": "UVk6",
	"./custom/aoyama/mom/layer5/04_short_gold.png": "yETk",
	"./custom/aoyama/mom/layer5/04_short_gray.png": "mZV2",
	"./custom/aoyama/mom/layer5/05_bob_beige.png": "xEX4",
	"./custom/aoyama/mom/layer5/05_bob_black.png": "Agmn",
	"./custom/aoyama/mom/layer5/05_bob_brown.png": "phmQ",
	"./custom/aoyama/mom/layer5/05_bob_gold.png": "JYgh",
	"./custom/aoyama/mom/layer5/05_bob_gray.png": "MqGc",
	"./custom/aoyama/mom/layer5/05_long_beige.png": "GD0G",
	"./custom/aoyama/mom/layer5/05_long_black.png": "ATtV",
	"./custom/aoyama/mom/layer5/05_long_brown.png": "ebB6",
	"./custom/aoyama/mom/layer5/05_long_gold.png": "g+Nc",
	"./custom/aoyama/mom/layer5/05_long_gray.png": "i+iR",
	"./custom/aoyama/mom/layer5/05_short_beige.png": "hsli",
	"./custom/aoyama/mom/layer5/05_short_black.png": "ZDBD",
	"./custom/aoyama/mom/layer5/05_short_brown.png": "fcp+",
	"./custom/aoyama/mom/layer5/05_short_gold.png": "IdZ4",
	"./custom/aoyama/mom/layer5/05_short_gray.png": "67SZ",
	"./custom/aoyama/mom/layer5/06_bob_beige.png": "pzD7",
	"./custom/aoyama/mom/layer5/06_bob_black.png": "a/cE",
	"./custom/aoyama/mom/layer5/06_bob_brown.png": "427k",
	"./custom/aoyama/mom/layer5/06_bob_gold.png": "X29M",
	"./custom/aoyama/mom/layer5/06_bob_gray.png": "fVi/",
	"./custom/aoyama/mom/layer5/06_long_beige.png": "MnTi",
	"./custom/aoyama/mom/layer5/06_long_black.png": "uWQx",
	"./custom/aoyama/mom/layer5/06_long_brown.png": "zNgj",
	"./custom/aoyama/mom/layer5/06_long_gold.png": "HMhY",
	"./custom/aoyama/mom/layer5/06_long_gray.png": "tU9O",
	"./custom/aoyama/mom/layer5/07_bob_beige.png": "qIvn",
	"./custom/aoyama/mom/layer5/07_bob_black.png": "HTPF",
	"./custom/aoyama/mom/layer5/07_bob_brown.png": "iOko",
	"./custom/aoyama/mom/layer5/07_bob_gold.png": "7gkM",
	"./custom/aoyama/mom/layer5/07_bob_gray.png": "+4P8",
	"./custom/aoyama/mom/layer5/07_long_beige.png": "oP9f",
	"./custom/aoyama/mom/layer5/07_long_black.png": "hlcm",
	"./custom/aoyama/mom/layer5/07_long_brown.png": "3Rx+",
	"./custom/aoyama/mom/layer5/07_long_gold.png": "7Rih",
	"./custom/aoyama/mom/layer5/07_long_gray.png": "NC6S",
	"./custom/aoyama/mom/layer5/08_bob_beige.png": "VT77",
	"./custom/aoyama/mom/layer5/08_bob_black.png": "eMuh",
	"./custom/aoyama/mom/layer5/08_bob_brown.png": "iUqQ",
	"./custom/aoyama/mom/layer5/08_bob_gold.png": "n2z2",
	"./custom/aoyama/mom/layer5/08_bob_gray.png": "+zR7",
	"./custom/aoyama/mom/layer5/08_long_beige.png": "leAj",
	"./custom/aoyama/mom/layer5/08_long_black.png": "Jo1J",
	"./custom/aoyama/mom/layer5/08_long_brown.png": "CY/G",
	"./custom/aoyama/mom/layer5/08_long_gold.png": "aFtM",
	"./custom/aoyama/mom/layer5/08_long_gray.png": "mKQq",
	"./custom/kanai/female/layer1/01_face.png": "YYto",
	"./custom/kanai/female/layer1/02_face.png": "nLRn",
	"./custom/kanai/female/layer1/03_face.png": "ikkE",
	"./custom/kanai/female/layer1/04_face.png": "sqng",
	"./custom/kanai/female/layer1/05_face.png": "iU3p",
	"./custom/kanai/female/layer1/06_face.png": "Y3o0",
	"./custom/kanai/female/layer1/07_face.png": "FaDF",
	"./custom/kanai/female/layer1/08_face.png": "wU0S",
	"./custom/kanai/female/layer1/09_face.png": "cCGN",
	"./custom/kanai/female/layer2/01_mole.png": "uBVn",
	"./custom/kanai/female/layer2/02_mole.png": "rZf0",
	"./custom/kanai/female/layer2/03_mole.png": "1ROR",
	"./custom/kanai/female/layer2/04_mole.png": "JrrX",
	"./custom/kanai/female/layer2/05_mole.png": "Utpk",
	"./custom/kanai/female/layer2/06_mole.png": "FbYh",
	"./custom/kanai/female/layer2/07_mole.png": "zhsT",
	"./custom/kanai/female/layer2/08_mole.png": "uU38",
	"./custom/kanai/female/layer2/09_mole.png": "urGi",
	"./custom/kanai/female/layer2/10_mole.png": "R/as",
	"./custom/kanai/female/layer2/11_mole.png": "2ybo",
	"./custom/kanai/female/layer3/01_cheeks.png": "GOe8",
	"./custom/kanai/female/layer3/02_cheeks.png": "5aoO",
	"./custom/kanai/female/layer3/03_cheeks.png": "EZpq",
	"./custom/kanai/female/layer4/01_glasses.png": "pIVX",
	"./custom/kanai/female/layer4/01_glasses_black.png": "nBFS",
	"./custom/kanai/female/layer4/01_glasses_brown.png": "iHqS",
	"./custom/kanai/female/layer4/01_glasses_red.png": "0WoF",
	"./custom/kanai/female/layer4/02_glasses_black.png": "Xd9e",
	"./custom/kanai/female/layer4/02_glasses_brown.png": "yI2j",
	"./custom/kanai/female/layer4/02_glasses_red.png": "D1/M",
	"./custom/kanai/female/layer4/03_glasses_black.png": "WS2q",
	"./custom/kanai/female/layer4/03_glasses_brown.png": "9osv",
	"./custom/kanai/female/layer4/03_glasses_red.png": "aH1b",
	"./custom/kanai/female/layer4/04_glasses_black.png": "uG0T",
	"./custom/kanai/female/layer4/04_glasses_brown.png": "lhQE",
	"./custom/kanai/female/layer4/04_glasses_red.png": "BCTj",
	"./custom/kanai/female/layer4/05_glasses_black.png": "K8C8",
	"./custom/kanai/female/layer4/05_glasses_brown.png": "6wO2",
	"./custom/kanai/female/layer4/05_glasses_red.png": "PARz",
	"./custom/kanai/female/layer5/00_hair.png": "KanU",
	"./custom/kanai/female/layer5/01_bob_black.png": "qst5",
	"./custom/kanai/female/layer5/01_bob_brown.png": "B2ju",
	"./custom/kanai/female/layer5/01_bob_gold.png": "WedS",
	"./custom/kanai/female/layer5/01_bob_grey.png": "akQz",
	"./custom/kanai/female/layer5/01_long_black.png": "Kn9r",
	"./custom/kanai/female/layer5/01_long_brown.png": "OCEo",
	"./custom/kanai/female/layer5/01_long_gold.png": "PI9G",
	"./custom/kanai/female/layer5/01_long_grey.png": "Hllj",
	"./custom/kanai/female/layer5/01_short_black.png": "4Od5",
	"./custom/kanai/female/layer5/01_short_brown.png": "6o96",
	"./custom/kanai/female/layer5/01_short_gold.png": "gRxA",
	"./custom/kanai/female/layer5/01_short_grey.png": "rEiG",
	"./custom/kanai/female/layer5/01_veryshort_black.png": "sjSQ",
	"./custom/kanai/female/layer5/01_veryshort_brown.png": "4RYn",
	"./custom/kanai/female/layer5/01_veryshort_gold.png": "rmGX",
	"./custom/kanai/female/layer5/01_veryshort_grey.png": "ONIk",
	"./custom/kanai/female/layer5/02_bob_black.png": "98ZQ",
	"./custom/kanai/female/layer5/02_bob_brown.png": "ev0F",
	"./custom/kanai/female/layer5/02_bob_gold.png": "2o/M",
	"./custom/kanai/female/layer5/02_bob_grey.png": "nc7L",
	"./custom/kanai/female/layer5/02_long_black.png": "YlGX",
	"./custom/kanai/female/layer5/02_long_brown.png": "jf/r",
	"./custom/kanai/female/layer5/02_long_gold.png": "5Xix",
	"./custom/kanai/female/layer5/02_long_grey.png": "xMr8",
	"./custom/kanai/female/layer5/02_short_black.png": "RIYy",
	"./custom/kanai/female/layer5/02_short_brown.png": "LKko",
	"./custom/kanai/female/layer5/02_short_gold.png": "ASrr",
	"./custom/kanai/female/layer5/02_short_grey.png": "KS6C",
	"./custom/kanai/female/layer5/02_veryshort_black.png": "q37f",
	"./custom/kanai/female/layer5/02_veryshort_brown.png": "RCKp",
	"./custom/kanai/female/layer5/02_veryshort_gold.png": "FksQ",
	"./custom/kanai/female/layer5/02_veryshort_grey.png": "GMSa",
	"./custom/kanai/female/layer5/03_bob_black.png": "itwF",
	"./custom/kanai/female/layer5/03_bob_brown.png": "ENq+",
	"./custom/kanai/female/layer5/03_bob_gold.png": "zmP6",
	"./custom/kanai/female/layer5/03_bob_grey.png": "fw/C",
	"./custom/kanai/female/layer5/03_long_black.png": "Qblf",
	"./custom/kanai/female/layer5/03_long_brown.png": "mtz0",
	"./custom/kanai/female/layer5/03_long_gold.png": "CD6U",
	"./custom/kanai/female/layer5/03_long_grey.png": "9p7C",
	"./custom/kanai/female/layer5/03_short_black.png": "50o7",
	"./custom/kanai/female/layer5/03_short_brown.png": "dlQ+",
	"./custom/kanai/female/layer5/03_short_gold.png": "lkff",
	"./custom/kanai/female/layer5/03_short_grey.png": "w3BL",
	"./custom/kanai/female/layer5/04_bob_black.png": "uhGa",
	"./custom/kanai/female/layer5/04_bob_brown.png": "VJex",
	"./custom/kanai/female/layer5/04_bob_gold.png": "c/07",
	"./custom/kanai/female/layer5/04_bob_grey.png": "keVG",
	"./custom/kanai/female/layer5/04_long_black.png": "CjrP",
	"./custom/kanai/female/layer5/04_long_brown.png": "kgO8",
	"./custom/kanai/female/layer5/04_long_gold.png": "2Xzg",
	"./custom/kanai/female/layer5/04_long_grey.png": "CPJI",
	"./custom/kanai/female/layer5/05_bob_black.png": "kMHu",
	"./custom/kanai/female/layer5/05_bob_brown.png": "8CsP",
	"./custom/kanai/female/layer5/05_bob_gold.png": "LWR9",
	"./custom/kanai/female/layer5/05_bob_grey.png": "g02R",
	"./custom/kanai/female/layer5/05_long_black.png": "6T6+",
	"./custom/kanai/female/layer5/05_long_brown.png": "/L/v",
	"./custom/kanai/female/layer5/05_long_gold.png": "1Ybz",
	"./custom/kanai/female/layer5/05_long_grey.png": "pHgT",
	"./custom/kanai/female/layer5/06_bob_black.png": "Junb",
	"./custom/kanai/female/layer5/06_bob_brown.png": "VqmF",
	"./custom/kanai/female/layer5/06_bob_gold.png": "EFrW",
	"./custom/kanai/female/layer5/06_bob_grey.png": "64Qs",
	"./custom/kanai/female/layer5/06_long_black.png": "W6OC",
	"./custom/kanai/female/layer5/06_long_brown.png": "oo01",
	"./custom/kanai/female/layer5/06_long_gold.png": "/w58",
	"./custom/kanai/female/layer5/06_long_grey.png": "+QcI",
	"./custom/kanai/female/layer5/07_bob_black.png": "cWW7",
	"./custom/kanai/female/layer5/07_bob_brown.png": "cQbD",
	"./custom/kanai/female/layer5/07_bob_gold.png": "iy8k",
	"./custom/kanai/female/layer5/07_bob_grey.png": "3xnX",
	"./custom/kanai/female/layer5/07_long_black.png": "5VNa",
	"./custom/kanai/female/layer5/07_long_brown.png": "mzQN",
	"./custom/kanai/female/layer5/07_long_gold.png": "58s5",
	"./custom/kanai/female/layer5/07_long_grey.png": "4EtU",
	"./custom/kanai/male/layer1/01_face.png": "L9N2",
	"./custom/kanai/male/layer1/02_face.png": "Tuke",
	"./custom/kanai/male/layer1/03_face.png": "NaVW",
	"./custom/kanai/male/layer1/04_face.png": "xmmH",
	"./custom/kanai/male/layer1/05_face.png": "fNCx",
	"./custom/kanai/male/layer1/06_face.png": "slvn",
	"./custom/kanai/male/layer1/07_face.png": "9tWY",
	"./custom/kanai/male/layer1/08_face.png": "Rimo",
	"./custom/kanai/male/layer1/09_face.png": "IMY7",
	"./custom/kanai/male/layer2/00_mole.png": "61+A",
	"./custom/kanai/male/layer2/01_mole.png": "30JN",
	"./custom/kanai/male/layer2/02_mole.png": "6UGC",
	"./custom/kanai/male/layer2/03_mole.png": "KOtB",
	"./custom/kanai/male/layer2/04_mole.png": "2ALF",
	"./custom/kanai/male/layer2/05_mole.png": "yHAI",
	"./custom/kanai/male/layer2/06_mole.png": "hMbM",
	"./custom/kanai/male/layer2/07_mole.png": "IoWj",
	"./custom/kanai/male/layer2/08_mole.png": "1/Qh",
	"./custom/kanai/male/layer2/09_mole.png": "r2gG",
	"./custom/kanai/male/layer2/10_mole.png": "C5zI",
	"./custom/kanai/male/layer3/01_cheeks.png": "3U23",
	"./custom/kanai/male/layer3/01_mustache_black.png": "YwN5",
	"./custom/kanai/male/layer3/01_mustache_grey.png": "sFGx",
	"./custom/kanai/male/layer3/02_mustache_black.png": "efm8",
	"./custom/kanai/male/layer3/02_mustache_grey.png": "nemH",
	"./custom/kanai/male/layer3/03_mustache_black.png": "gVpE",
	"./custom/kanai/male/layer3/03_mustache_grey.png": "QY9H",
	"./custom/kanai/male/layer3/04_mustache_black.png": "l50P",
	"./custom/kanai/male/layer3/04_mustache_grey.png": "5EPe",
	"./custom/kanai/male/layer3/05_mustache_black.png": "Yi0D",
	"./custom/kanai/male/layer3/05_mustache_grey.png": "Xm7V",
	"./custom/kanai/male/layer3/06_mustache_black.png": "HXsY",
	"./custom/kanai/male/layer3/06_mustache_grey.png": "i9pG",
	"./custom/kanai/male/layer3/07_mustache_black.png": "tYTr",
	"./custom/kanai/male/layer3/07_mustache_grey.png": "KAkA",
	"./custom/kanai/male/layer3/08_mustache_black.png": "9ra0",
	"./custom/kanai/male/layer3/08_mustache_grey.png": "98+q",
	"./custom/kanai/male/layer4/01_glasses.png": "nYVf",
	"./custom/kanai/male/layer4/01_glasses_black.png": "EiBn",
	"./custom/kanai/male/layer4/01_glasses_brown.png": "TKYW",
	"./custom/kanai/male/layer4/01_glasses_red.png": "rRcV",
	"./custom/kanai/male/layer4/02_glasses_black.png": "Ik5i",
	"./custom/kanai/male/layer4/02_glasses_brown.png": "3jOJ",
	"./custom/kanai/male/layer4/02_glasses_red.png": "YsJs",
	"./custom/kanai/male/layer4/03_glasses_black.png": "2KTM",
	"./custom/kanai/male/layer4/03_glasses_brown.png": "fx6E",
	"./custom/kanai/male/layer4/03_glasses_red.png": "aXsI",
	"./custom/kanai/male/layer4/04_glasses_black.png": "Xif+",
	"./custom/kanai/male/layer4/04_glasses_brown.png": "+a9K",
	"./custom/kanai/male/layer4/04_glasses_red.png": "iw7F",
	"./custom/kanai/male/layer4/05_glasses_black.png": "rg2S",
	"./custom/kanai/male/layer4/05_glasses_brown.png": "a8Zf",
	"./custom/kanai/male/layer4/05_glasses_red.png": "1jAe",
	"./custom/kanai/male/layer5/00_hair.png": "dKxT",
	"./custom/kanai/male/layer5/01_long_black.png": "gSwX",
	"./custom/kanai/male/layer5/01_long_brown.png": "oYLI",
	"./custom/kanai/male/layer5/01_long_gold.png": "kM4r",
	"./custom/kanai/male/layer5/01_long_grey.png": "d6xf",
	"./custom/kanai/male/layer5/01_medium_black.png": "mH+4",
	"./custom/kanai/male/layer5/01_medium_brown.png": "Tmqw",
	"./custom/kanai/male/layer5/01_medium_gold.png": "tzHp",
	"./custom/kanai/male/layer5/01_medium_grey.png": "l3r4",
	"./custom/kanai/male/layer5/01_short_black.png": "FZj/",
	"./custom/kanai/male/layer5/01_short_brown.png": "u8Zg",
	"./custom/kanai/male/layer5/01_short_gold.png": "AblM",
	"./custom/kanai/male/layer5/01_short_grey.png": "NryA",
	"./custom/kanai/male/layer5/01_veryshort_black.png": "YZYe",
	"./custom/kanai/male/layer5/01_veryshort_brown.png": "/gRN",
	"./custom/kanai/male/layer5/01_veryshort_gold.png": "blL1",
	"./custom/kanai/male/layer5/01_veryshort_grey.png": "6o0l",
	"./custom/kanai/male/layer5/02_long_black.png": "hwhA",
	"./custom/kanai/male/layer5/02_long_brown.png": "ItkZ",
	"./custom/kanai/male/layer5/02_long_gold.png": "QS5+",
	"./custom/kanai/male/layer5/02_long_grey.png": "Qj48",
	"./custom/kanai/male/layer5/02_medium_black.png": "E+KD",
	"./custom/kanai/male/layer5/02_medium_brown.png": "67rN",
	"./custom/kanai/male/layer5/02_medium_gold.png": "0Szn",
	"./custom/kanai/male/layer5/02_medium_grey.png": "Mudh",
	"./custom/kanai/male/layer5/02_short_black.png": "LmTI",
	"./custom/kanai/male/layer5/02_short_brown.png": "rEoe",
	"./custom/kanai/male/layer5/02_short_gold.png": "20bS",
	"./custom/kanai/male/layer5/02_short_grey.png": "m0HS",
	"./custom/kanai/male/layer5/02_veryshort_black.png": "/Ntn",
	"./custom/kanai/male/layer5/02_veryshort_brown.png": "uHwo",
	"./custom/kanai/male/layer5/02_veryshort_gold.png": "DWI6",
	"./custom/kanai/male/layer5/02_veryshort_grey.png": "mX6i",
	"./custom/kanai/male/layer5/03_long_black.png": "X3A1",
	"./custom/kanai/male/layer5/03_long_brown.png": "A23w",
	"./custom/kanai/male/layer5/03_long_gold.png": "xSiY",
	"./custom/kanai/male/layer5/03_long_grey.png": "xYAk",
	"./custom/kanai/male/layer5/03_medium_black.png": "llga",
	"./custom/kanai/male/layer5/03_medium_brown.png": "SkpH",
	"./custom/kanai/male/layer5/03_medium_gold.png": "lngb",
	"./custom/kanai/male/layer5/03_medium_grey.png": "MF/z",
	"./custom/kanai/male/layer5/03_short_black.png": "v7e9",
	"./custom/kanai/male/layer5/03_short_brown.png": "TSBF",
	"./custom/kanai/male/layer5/03_short_gold.png": "8WEL",
	"./custom/kanai/male/layer5/03_short_grey.png": "S0Lu",
	"./custom/kanai/male/layer5/03_veryshort_black.png": "eePi",
	"./custom/kanai/male/layer5/03_veryshort_brown.png": "yUpp",
	"./custom/kanai/male/layer5/03_veryshort_gold.png": "+XVm",
	"./custom/kanai/male/layer5/03_veryshort_grey.png": "BqAO",
	"./custom/kanai/male/layer5/04_long_black.png": "lstp",
	"./custom/kanai/male/layer5/04_long_brown.png": "Qb1P",
	"./custom/kanai/male/layer5/04_long_gold.png": "uggn",
	"./custom/kanai/male/layer5/04_long_grey.png": "+/e9",
	"./custom/kanai/male/layer5/04_medium_black.png": "SbC3",
	"./custom/kanai/male/layer5/04_medium_brown.png": "2NIS",
	"./custom/kanai/male/layer5/04_medium_gold.png": "wlLa",
	"./custom/kanai/male/layer5/04_medium_grey.png": "IHM4",
	"./custom/kanai/male/layer5/04_short_black.png": "KpcS",
	"./custom/kanai/male/layer5/04_short_brown.png": "VKwh",
	"./custom/kanai/male/layer5/04_short_gold.png": "OpSs",
	"./custom/kanai/male/layer5/04_short_grey.png": "AiVO",
	"./custom/kanai/male/layer5/04_veryshort_black.png": "zn0b",
	"./custom/kanai/male/layer5/04_veryshort_brown.png": "K/Qr",
	"./custom/kanai/male/layer5/04_veryshort_gold.png": "1Ga/",
	"./custom/kanai/male/layer5/04_veryshort_grey.png": "Jzy2",
	"./custom/kanai/male/layer5/05_medium_black.png": "Hz5F",
	"./custom/kanai/male/layer5/05_medium_brown.png": "n1Zm",
	"./custom/kanai/male/layer5/05_medium_gold.png": "i3/f",
	"./custom/kanai/male/layer5/05_medium_grey.png": "KH8j",
	"./custom/momoro/boy/layer1/01_face.png": "TGuP",
	"./custom/momoro/boy/layer1/02_face.png": "Fc4A",
	"./custom/momoro/boy/layer1/03_face.png": "031c",
	"./custom/momoro/boy/layer1/04_face.png": "Y+rG",
	"./custom/momoro/boy/layer1/05_face.png": "MTLl",
	"./custom/momoro/boy/layer1/06_face.png": "nUtc",
	"./custom/momoro/boy/layer1/07_face.png": "iJRq",
	"./custom/momoro/boy/layer1/08_face.png": "VV2n",
	"./custom/momoro/boy/layer1/09_face.png": "JP0d",
	"./custom/momoro/boy/layer2/00_cheek.png": "/3d2",
	"./custom/momoro/boy/layer2/01_cheek.png": "NtVq",
	"./custom/momoro/boy/layer2/02_freckles.png": "IULi",
	"./custom/momoro/boy/layer3/00_mole.png": "MewM",
	"./custom/momoro/boy/layer3/01_mole.png": "cDWO",
	"./custom/momoro/boy/layer3/02_mole.png": "iBkG",
	"./custom/momoro/boy/layer3/03_mole.png": "zYAp",
	"./custom/momoro/boy/layer3/04_mole.png": "HslB",
	"./custom/momoro/boy/layer3/05_mole.png": "s8ci",
	"./custom/momoro/boy/layer3/06_mole.png": "Cybr",
	"./custom/momoro/boy/layer3/07_mole.png": "LdbQ",
	"./custom/momoro/boy/layer3/08_mole.png": "MCk5",
	"./custom/momoro/boy/layer3/09_mole.png": "6jLD",
	"./custom/momoro/boy/layer3/10_mole.png": "rXy5",
	"./custom/momoro/boy/layer4/00_glasses.png": "GeQg",
	"./custom/momoro/boy/layer4/01_glasses_black.png": "wsDR",
	"./custom/momoro/boy/layer4/01_glasses_brown.png": "LA9L",
	"./custom/momoro/boy/layer4/01_glasses_red.png": "hSSN",
	"./custom/momoro/boy/layer4/02_glasses_black.png": "zhpq",
	"./custom/momoro/boy/layer4/02_glasses_brown.png": "Zzcv",
	"./custom/momoro/boy/layer4/02_glasses_red.png": "fwX8",
	"./custom/momoro/boy/layer4/03_glasses_black.png": "eCX9",
	"./custom/momoro/boy/layer4/03_glasses_brown.png": "eT+K",
	"./custom/momoro/boy/layer4/03_glasses_red.png": "9HUe",
	"./custom/momoro/boy/layer4/04_glasses_black.png": "eT9L",
	"./custom/momoro/boy/layer4/04_glasses_brown.png": "PjuN",
	"./custom/momoro/boy/layer4/04_glasses_red.png": "oP/e",
	"./custom/momoro/boy/layer5/00_hair.png": "LU87",
	"./custom/momoro/boy/layer5/01_baby.png": "OfW4",
	"./custom/momoro/boy/layer5/01_mid_black.png": "mlod",
	"./custom/momoro/boy/layer5/01_mid_brown.png": "LA2P",
	"./custom/momoro/boy/layer5/01_mid_yellow.png": "eBw3",
	"./custom/momoro/boy/layer5/01_short_black.png": "uCUe",
	"./custom/momoro/boy/layer5/01_short_brown.png": "q/zT",
	"./custom/momoro/boy/layer5/01_short_yellow.png": "dB1S",
	"./custom/momoro/boy/layer5/01_very_short_black.png": "53jY",
	"./custom/momoro/boy/layer5/01_very_short_brown.png": "C/td",
	"./custom/momoro/boy/layer5/01_very_short_yellow.png": "aADM",
	"./custom/momoro/boy/layer5/02_baby.png": "WX3W",
	"./custom/momoro/boy/layer5/02_mid_black.png": "s029",
	"./custom/momoro/boy/layer5/02_mid_brown.png": "/LmG",
	"./custom/momoro/boy/layer5/02_mid_yellow.png": "aCMT",
	"./custom/momoro/boy/layer5/02_short_black.png": "NBNf",
	"./custom/momoro/boy/layer5/02_short_brown.png": "Vo8i",
	"./custom/momoro/boy/layer5/02_short_yellow.png": "+8gU",
	"./custom/momoro/boy/layer5/02_very_short_black.png": "bcy8",
	"./custom/momoro/boy/layer5/02_very_short_brown.png": "SPrr",
	"./custom/momoro/boy/layer5/02_very_short_yellow.png": "Mg/g",
	"./custom/momoro/boy/layer5/03_mid_black.png": "rfxa",
	"./custom/momoro/boy/layer5/03_mid_brown.png": "5rZ2",
	"./custom/momoro/boy/layer5/03_mid_yellow.png": "bxzz",
	"./custom/momoro/boy/layer5/03_short_black.png": "Sf4A",
	"./custom/momoro/boy/layer5/03_short_brown.png": "yC8r",
	"./custom/momoro/boy/layer5/03_short_yellow.png": "KzCE",
	"./custom/momoro/boy/layer5/03_very_short_black.png": "voq0",
	"./custom/momoro/boy/layer5/03_very_short_brown.png": "S12y",
	"./custom/momoro/boy/layer5/03_very_short_yellow.png": "qLGB",
	"./custom/momoro/boy/layer5/04_mid_black.png": "x05l",
	"./custom/momoro/boy/layer5/04_mid_brown.png": "J+fu",
	"./custom/momoro/boy/layer5/04_mid_yellow.png": "LT2B",
	"./custom/momoro/boy/layer5/04_short_black.png": "JbP/",
	"./custom/momoro/boy/layer5/04_short_brown.png": "MnhR",
	"./custom/momoro/boy/layer5/04_short_yellow.png": "D7/T",
	"./custom/momoro/boy/layer5/05_mid_black.png": "qlUm",
	"./custom/momoro/boy/layer5/05_mid_brown.png": "x575",
	"./custom/momoro/boy/layer5/05_mid_yellow.png": "gpMo",
	"./custom/momoro/boy/layer5/05_short_black.png": "LqVk",
	"./custom/momoro/boy/layer5/05_short_brown.png": "/EWC",
	"./custom/momoro/boy/layer5/05_short_yellow.png": "F6XX",
	"./custom/momoro/boy/layer5/06_mid_black.png": "TQrn",
	"./custom/momoro/boy/layer5/06_mid_brown.png": "7pgd",
	"./custom/momoro/boy/layer5/06_mid_yellow.png": "fQPp",
	"./custom/momoro/boy/layer5/06_short_black.png": "sSPL",
	"./custom/momoro/boy/layer5/06_short_brown.png": "9A6R",
	"./custom/momoro/boy/layer5/06_short_yellow.png": "kQOZ",
	"./custom/momoro/girl/layer1/01_face.png": "ohQX",
	"./custom/momoro/girl/layer1/02_face.png": "DUq+",
	"./custom/momoro/girl/layer1/03_face.png": "KDoW",
	"./custom/momoro/girl/layer1/04_face.png": "uChh",
	"./custom/momoro/girl/layer1/05_face.png": "YN+k",
	"./custom/momoro/girl/layer1/06_face.png": "WkVH",
	"./custom/momoro/girl/layer1/07_face.png": "hDd+",
	"./custom/momoro/girl/layer1/08_face.png": "Lygt",
	"./custom/momoro/girl/layer1/09_face.png": "q9nH",
	"./custom/momoro/girl/layer2/00_cheek.png": "NrAh",
	"./custom/momoro/girl/layer2/01_cheek.png": "mwCL",
	"./custom/momoro/girl/layer2/01_freckles.png": "kMta",
	"./custom/momoro/girl/layer3/00_mole.png": "lBYY",
	"./custom/momoro/girl/layer3/01_mole.png": "SPKB",
	"./custom/momoro/girl/layer3/02_mole.png": "LSem",
	"./custom/momoro/girl/layer3/03_mole.png": "uuzH",
	"./custom/momoro/girl/layer3/04_mole.png": "b71A",
	"./custom/momoro/girl/layer3/05_mole.png": "4A6r",
	"./custom/momoro/girl/layer3/06_mole.png": "oE/M",
	"./custom/momoro/girl/layer3/07_mole.png": "bVjt",
	"./custom/momoro/girl/layer3/08_mole.png": "cxQ6",
	"./custom/momoro/girl/layer3/09_mole.png": "4uwH",
	"./custom/momoro/girl/layer3/10_mole.png": "aiYQ",
	"./custom/momoro/girl/layer4/00_glasses.png": "kxUK",
	"./custom/momoro/girl/layer4/01_glasses_black.png": "zKnX",
	"./custom/momoro/girl/layer4/01_glasses_brown.png": "OYbh",
	"./custom/momoro/girl/layer4/01_glasses_red.png": "uukj",
	"./custom/momoro/girl/layer4/02_glasses_black.png": "21gm",
	"./custom/momoro/girl/layer4/02_glasses_brown.png": "iFKf",
	"./custom/momoro/girl/layer4/02_glasses_red.png": "II5j",
	"./custom/momoro/girl/layer4/03_glasses_black.png": "akbl",
	"./custom/momoro/girl/layer4/03_glasses_brown.png": "b5aT",
	"./custom/momoro/girl/layer4/03_glasses_red.png": "DTq/",
	"./custom/momoro/girl/layer4/04_glasses_black.png": "1tf/",
	"./custom/momoro/girl/layer4/04_glasses_brown.png": "Ukjt",
	"./custom/momoro/girl/layer4/04_glasses_red.png": "+Wnb",
	"./custom/momoro/girl/layer5/00_hair.png": "lG+Y",
	"./custom/momoro/girl/layer5/01_baby.png": "kstm",
	"./custom/momoro/girl/layer5/01_bob_black.png": "jLJ/",
	"./custom/momoro/girl/layer5/01_bob_brown.png": "EdWe",
	"./custom/momoro/girl/layer5/01_bob_yellow.png": "9RTV",
	"./custom/momoro/girl/layer5/01_long_black.png": "EhYU",
	"./custom/momoro/girl/layer5/01_long_brown.png": "nsOB",
	"./custom/momoro/girl/layer5/01_long_yellow.png": "iC5d",
	"./custom/momoro/girl/layer5/01_very_short_black.png": "J0yL",
	"./custom/momoro/girl/layer5/01_very_short_brown.png": "mGc0",
	"./custom/momoro/girl/layer5/01_very_short_yellow.png": "VjO7",
	"./custom/momoro/girl/layer5/02_baby.png": "cOM1",
	"./custom/momoro/girl/layer5/02_bob_black.png": "uAm4",
	"./custom/momoro/girl/layer5/02_bob_brown.png": "TpK1",
	"./custom/momoro/girl/layer5/02_bob_yellow.png": "m4Nq",
	"./custom/momoro/girl/layer5/02_long_black.png": "0eWy",
	"./custom/momoro/girl/layer5/02_long_brown.png": "WC1H",
	"./custom/momoro/girl/layer5/02_long_yellow.png": "tjhD",
	"./custom/momoro/girl/layer5/02_very_short_black.png": "fzBC",
	"./custom/momoro/girl/layer5/02_very_short_brown.png": "VLJ5",
	"./custom/momoro/girl/layer5/02_very_short_yellow.png": "L8q0",
	"./custom/momoro/girl/layer5/03_bob_black.png": "DBx8",
	"./custom/momoro/girl/layer5/03_bob_brown.png": "siVR",
	"./custom/momoro/girl/layer5/03_bob_yellow.png": "UWVb",
	"./custom/momoro/girl/layer5/03_long_black.png": "mBjT",
	"./custom/momoro/girl/layer5/03_long_brown.png": "tYPA",
	"./custom/momoro/girl/layer5/03_long_yellow.png": "WRn1",
	"./custom/momoro/girl/layer5/03_very_short_black.png": "byAU",
	"./custom/momoro/girl/layer5/03_very_short_brown.png": "5/Zx",
	"./custom/momoro/girl/layer5/03_very_short_yellow.png": "Cb7q",
	"./custom/momoro/girl/layer5/04_long_black.png": "17Z2",
	"./custom/momoro/girl/layer5/04_long_brown.png": "Ec9h",
	"./custom/momoro/girl/layer5/04_long_yellow.png": "k2XG",
	"./custom/momoro/girl/layer5/05_long_black.png": "NKbU",
	"./custom/momoro/girl/layer5/05_long_brown.png": "x1yi",
	"./custom/momoro/girl/layer5/05_long_yellow.png": "P2BV",
	"./custom/momoro/girl/layer5/06_long_black.png": "pW+D",
	"./custom/momoro/girl/layer5/06_long_brown.png": "5NdE",
	"./custom/momoro/girl/layer5/06_long_yellow.png": "lIlU",
	"./custom/momoro/girl/layer5/07_long_black.png": "6UM/",
	"./custom/momoro/girl/layer5/07_long_brown.png": "jTnC",
	"./custom/momoro/girl/layer5/07_long_yellow.png": "hU7l",
	"./custom/momoro/girl/layer5/08_long_black.png": "vu/A",
	"./custom/momoro/girl/layer5/08_long_brown.png": "EFnS",
	"./custom/momoro/girl/layer5/08_long_yellow.png": "Hq2h",
	"./custom/momoro/girl/layer5/09_long_black.png": "BDGa",
	"./custom/momoro/girl/layer5/09_long_brown.png": "9+z4",
	"./custom/momoro/girl/layer5/09_long_yellow.png": "GkEO",
	"./custom/momoro/mama/layer1/01_face.png": "cZ6t",
	"./custom/momoro/mama/layer1/02_face.png": "6xOc",
	"./custom/momoro/mama/layer1/03_face.png": "scLL",
	"./custom/momoro/mama/layer1/04_face.png": "xGDg",
	"./custom/momoro/mama/layer1/05_face.png": "3p1B",
	"./custom/momoro/mama/layer1/06_face.png": "s5Gq",
	"./custom/momoro/mama/layer1/07_face.png": "tTUs",
	"./custom/momoro/mama/layer1/08_face.png": "LjrO",
	"./custom/momoro/mama/layer1/09_face.png": "A7vX",
	"./custom/momoro/mama/layer2/00_cheek.png": "7BUs",
	"./custom/momoro/mama/layer2/01_cheek.png": "JzFb",
	"./custom/momoro/mama/layer2/02_freckles.png": "pIAd",
	"./custom/momoro/mama/layer2/03_freckles.png": "7TVv",
	"./custom/momoro/mama/layer3/00_mole.png": "PXco",
	"./custom/momoro/mama/layer3/01_mole.png": "vLAD",
	"./custom/momoro/mama/layer3/02_mole.png": "W5r7",
	"./custom/momoro/mama/layer3/03_mole.png": "KtEj",
	"./custom/momoro/mama/layer3/04_mole.png": "LK3L",
	"./custom/momoro/mama/layer3/05_mole.png": "hE6r",
	"./custom/momoro/mama/layer3/06_mole.png": "U7An",
	"./custom/momoro/mama/layer3/07_mole.png": "mQ/x",
	"./custom/momoro/mama/layer3/08_mole.png": "g7UA",
	"./custom/momoro/mama/layer3/09_mole.png": "wf6X",
	"./custom/momoro/mama/layer3/10_mole.png": "bWYI",
	"./custom/momoro/mama/layer4/00_glasses.png": "pIJN",
	"./custom/momoro/mama/layer4/01_glasses_black.png": "E4A/",
	"./custom/momoro/mama/layer4/01_glasses_brown.png": "m7ds",
	"./custom/momoro/mama/layer4/01_glasses_red.png": "pPCE",
	"./custom/momoro/mama/layer4/02_glasses_black.png": "pNmr",
	"./custom/momoro/mama/layer4/02_glasses_brown.png": "Yuu6",
	"./custom/momoro/mama/layer4/02_glasses_red.png": "EvT4",
	"./custom/momoro/mama/layer4/03_glasses_black.png": "OnvH",
	"./custom/momoro/mama/layer4/03_glasses_brown.png": "ysXG",
	"./custom/momoro/mama/layer4/03_glasses_red.png": "r9SO",
	"./custom/momoro/mama/layer4/04_glasses_black.png": "uPRv",
	"./custom/momoro/mama/layer4/04_glasses_brown.png": "bdZU",
	"./custom/momoro/mama/layer4/04_glasses_red.png": "tHOG",
	"./custom/momoro/mama/layer4/05_glasses_black.png": "Nzhc",
	"./custom/momoro/mama/layer4/05_glasses_brown.png": "MoTH",
	"./custom/momoro/mama/layer4/05_glasses_red.png": "Wmeg",
	"./custom/momoro/mama/layer5/00_hair.png": "Tbai",
	"./custom/momoro/mama/layer5/01_bob_black.png": "SjsH",
	"./custom/momoro/mama/layer5/01_bob_brown.png": "Xecn",
	"./custom/momoro/mama/layer5/01_bob_grey.png": "uoX6",
	"./custom/momoro/mama/layer5/01_bob_yellow.png": "BoUw",
	"./custom/momoro/mama/layer5/01_long_black.png": "+V6I",
	"./custom/momoro/mama/layer5/01_long_brown.png": "GadC",
	"./custom/momoro/mama/layer5/01_long_grey.png": "JU/G",
	"./custom/momoro/mama/layer5/01_long_yellow.png": "xzos",
	"./custom/momoro/mama/layer5/01_short_black.png": "xUW+",
	"./custom/momoro/mama/layer5/01_short_brown.png": "HG9A",
	"./custom/momoro/mama/layer5/01_short_grey.png": "3hjm",
	"./custom/momoro/mama/layer5/01_short_yellow.png": "L2NI",
	"./custom/momoro/mama/layer5/01_very_short_black.png": "13iu",
	"./custom/momoro/mama/layer5/01_very_short_brown.png": "OqFr",
	"./custom/momoro/mama/layer5/01_very_short_grey.png": "AOhT",
	"./custom/momoro/mama/layer5/01_very_short_yellow.png": "G/46",
	"./custom/momoro/mama/layer5/02_bob_black.png": "zI9h",
	"./custom/momoro/mama/layer5/02_bob_brown.png": "N1An",
	"./custom/momoro/mama/layer5/02_bob_grey.png": "z6Jh",
	"./custom/momoro/mama/layer5/02_bob_yellow.png": "mfNi",
	"./custom/momoro/mama/layer5/02_long_black.png": "Nywz",
	"./custom/momoro/mama/layer5/02_long_brown.png": "IonG",
	"./custom/momoro/mama/layer5/02_long_grey.png": "WTwX",
	"./custom/momoro/mama/layer5/02_long_yellow.png": "kOiv",
	"./custom/momoro/mama/layer5/02_short_black.png": "ZJtw",
	"./custom/momoro/mama/layer5/02_short_brown.png": "c6vB",
	"./custom/momoro/mama/layer5/02_short_grey.png": "0hSJ",
	"./custom/momoro/mama/layer5/02_short_yellow.png": "N05u",
	"./custom/momoro/mama/layer5/02_very_short_black.png": "k8oL",
	"./custom/momoro/mama/layer5/02_very_short_brown.png": "EISy",
	"./custom/momoro/mama/layer5/02_very_short_grey.png": "xVV8",
	"./custom/momoro/mama/layer5/02_very_short_yellow.png": "+Xgy",
	"./custom/momoro/mama/layer5/03_bob_black.png": "x6nL",
	"./custom/momoro/mama/layer5/03_bob_brown.png": "AYLj",
	"./custom/momoro/mama/layer5/03_bob_grey.png": "dEER",
	"./custom/momoro/mama/layer5/03_bob_yellow.png": "SbZc",
	"./custom/momoro/mama/layer5/03_long_black.png": "ridm",
	"./custom/momoro/mama/layer5/03_long_brown.png": "2nzE",
	"./custom/momoro/mama/layer5/03_long_grey.png": "Nol4",
	"./custom/momoro/mama/layer5/03_long_yellow.png": "yr1l",
	"./custom/momoro/mama/layer5/03_short_black.png": "44D8",
	"./custom/momoro/mama/layer5/03_short_brown.png": "jm2d",
	"./custom/momoro/mama/layer5/03_short_grey.png": "IKEh",
	"./custom/momoro/mama/layer5/03_short_yellow.png": "FevU",
	"./custom/momoro/mama/layer5/04_bob_black.png": "agC1",
	"./custom/momoro/mama/layer5/04_bob_brown.png": "4vZw",
	"./custom/momoro/mama/layer5/04_bob_grey.png": "JFTe",
	"./custom/momoro/mama/layer5/04_bob_yellow.png": "wDey",
	"./custom/momoro/mama/layer5/04_long_black.png": "CdA4",
	"./custom/momoro/mama/layer5/04_long_brown.png": "8L2E",
	"./custom/momoro/mama/layer5/04_long_grey.png": "/WeH",
	"./custom/momoro/mama/layer5/04_long_yellow.png": "Kzjm",
	"./custom/momoro/mama/layer5/05_bob_black.png": "ooRF",
	"./custom/momoro/mama/layer5/05_bob_brown.png": "QcNR",
	"./custom/momoro/mama/layer5/05_bob_grey.png": "+em7",
	"./custom/momoro/mama/layer5/05_bob_yellow.png": "7T3y",
	"./custom/momoro/mama/layer5/05_long_black.png": "4TOq",
	"./custom/momoro/mama/layer5/05_long_brown.png": "+s1c",
	"./custom/momoro/mama/layer5/05_long_grey.png": "1haZ",
	"./custom/momoro/mama/layer5/05_long_yellow.png": "X8ca",
	"./custom/momoro/mama/layer5/06_bob_black.png": "p++A",
	"./custom/momoro/mama/layer5/06_bob_brown.png": "MKSc",
	"./custom/momoro/mama/layer5/06_bob_grey.png": "a/c8",
	"./custom/momoro/mama/layer5/06_bob_yellow.png": "joNi",
	"./custom/momoro/mama/layer5/06_long_black.png": "Hjcj",
	"./custom/momoro/mama/layer5/06_long_brown.png": "N/uw",
	"./custom/momoro/mama/layer5/06_long_grey.png": "rhG1",
	"./custom/momoro/mama/layer5/06_long_yellow.png": "tCba",
	"./custom/momoro/mama/layer5/07_bob_black.png": "UMRw",
	"./custom/momoro/mama/layer5/07_bob_brown.png": "NgYI",
	"./custom/momoro/mama/layer5/07_bob_grey.png": "Wxlf",
	"./custom/momoro/mama/layer5/07_bob_yellow.png": "AG0V",
	"./custom/momoro/mama/layer5/07_long_black.png": "6+Bw",
	"./custom/momoro/mama/layer5/07_long_brown.png": "8Omp",
	"./custom/momoro/mama/layer5/07_long_grey.png": "HJ6q",
	"./custom/momoro/mama/layer5/07_long_yellow.png": "IpZK",
	"./custom/momoro/papa/layer1/01_face.png": "Xhx+",
	"./custom/momoro/papa/layer1/02_face.png": "6Wlv",
	"./custom/momoro/papa/layer1/03_face.png": "PkJZ",
	"./custom/momoro/papa/layer1/04_face.png": "cWLF",
	"./custom/momoro/papa/layer1/05_face.png": "fUXs",
	"./custom/momoro/papa/layer1/06_face.png": "t0Vg",
	"./custom/momoro/papa/layer1/07_face.png": "VB17",
	"./custom/momoro/papa/layer1/08_face.png": "UyuU",
	"./custom/momoro/papa/layer1/09_face.png": "mjTC",
	"./custom/momoro/papa/layer2/00_mole.png": "60i9",
	"./custom/momoro/papa/layer2/01_mole.png": "kNpl",
	"./custom/momoro/papa/layer2/02_mole.png": "zyOp",
	"./custom/momoro/papa/layer2/03_mole.png": "NWfL",
	"./custom/momoro/papa/layer2/04_mole.png": "5NFU",
	"./custom/momoro/papa/layer2/05_mole.png": "0q0z",
	"./custom/momoro/papa/layer2/06_mole.png": "Y9xu",
	"./custom/momoro/papa/layer2/07_mole.png": "eA8h",
	"./custom/momoro/papa/layer2/08_mole.png": "LFxM",
	"./custom/momoro/papa/layer2/09_mole.png": "8zDG",
	"./custom/momoro/papa/layer2/10_mole.png": "mhNR",
	"./custom/momoro/papa/layer3/00_cheek.png": "ToT5",
	"./custom/momoro/papa/layer3/01_mustache_brown.png": "6/41",
	"./custom/momoro/papa/layer3/01_mustache_grey.png": "xogM",
	"./custom/momoro/papa/layer3/02_mustache_brown.png": "XOih",
	"./custom/momoro/papa/layer3/02_mustache_grey.png": "41QZ",
	"./custom/momoro/papa/layer3/03_mustache_brown.png": "JUQX",
	"./custom/momoro/papa/layer3/03_mustache_grey.png": "gCqw",
	"./custom/momoro/papa/layer3/04_mustache_brown.png": "8x13",
	"./custom/momoro/papa/layer3/04_mustache_grey.png": "uxp0",
	"./custom/momoro/papa/layer3/05_mustache_brown.png": "jpmB",
	"./custom/momoro/papa/layer3/05_mustache_grey.png": "DfjH",
	"./custom/momoro/papa/layer3/06_mustache_brown.png": "WG/j",
	"./custom/momoro/papa/layer3/06_mustache_grey.png": "hydA",
	"./custom/momoro/papa/layer3/07_mustache_brown.png": "lzgI",
	"./custom/momoro/papa/layer3/07_mustache_grey.png": "jKTP",
	"./custom/momoro/papa/layer3/08_mustache_brown.png": "SYGH",
	"./custom/momoro/papa/layer3/08_mustache_grey.png": "Diqy",
	"./custom/momoro/papa/layer3/09_mustache_brown.png": "Wrql",
	"./custom/momoro/papa/layer3/09_mustache_grey.png": "64Qq",
	"./custom/momoro/papa/layer4/00_glasses.png": "LGAb",
	"./custom/momoro/papa/layer4/01_glasses_black.png": "Ewb+",
	"./custom/momoro/papa/layer4/01_glasses_brown.png": "pK00",
	"./custom/momoro/papa/layer4/01_glasses_red.png": "8TwT",
	"./custom/momoro/papa/layer4/02_glasses_black.png": "+rlf",
	"./custom/momoro/papa/layer4/02_glasses_brown.png": "GGvB",
	"./custom/momoro/papa/layer4/02_glasses_red.png": "Rf51",
	"./custom/momoro/papa/layer4/03_glasses_black.png": "wrX4",
	"./custom/momoro/papa/layer4/03_glasses_brown.png": "gT4v",
	"./custom/momoro/papa/layer4/03_glasses_red.png": "IJ84",
	"./custom/momoro/papa/layer4/04_glasses_black.png": "NUm6",
	"./custom/momoro/papa/layer4/04_glasses_brown.png": "sL84",
	"./custom/momoro/papa/layer4/04_glasses_red.png": "c+EU",
	"./custom/momoro/papa/layer4/05_glasses_black.png": "iau2",
	"./custom/momoro/papa/layer4/05_glasses_brown.png": "Fudf",
	"./custom/momoro/papa/layer4/05_glasses_red.png": "2gnL",
	"./custom/momoro/papa/layer5/00_hair.png": "zQNp",
	"./custom/momoro/papa/layer5/01_long_black.png": "Hj/D",
	"./custom/momoro/papa/layer5/01_long_brown.png": "BbDW",
	"./custom/momoro/papa/layer5/01_long_gray.png": "a6VL",
	"./custom/momoro/papa/layer5/01_long_grey.png": "svk7",
	"./custom/momoro/papa/layer5/01_long_yellow.png": "IiB/",
	"./custom/momoro/papa/layer5/01_mid_black.png": "eDaY",
	"./custom/momoro/papa/layer5/01_mid_brown.png": "vhon",
	"./custom/momoro/papa/layer5/01_mid_grey.png": "JdCp",
	"./custom/momoro/papa/layer5/01_mid_yellow.png": "TGcN",
	"./custom/momoro/papa/layer5/01_short_black.png": "thJJ",
	"./custom/momoro/papa/layer5/01_short_brown.png": "iLDr",
	"./custom/momoro/papa/layer5/01_short_grey.png": "AhYJ",
	"./custom/momoro/papa/layer5/01_short_yellow.png": "542+",
	"./custom/momoro/papa/layer5/01_very_short_black.png": "Yd9b",
	"./custom/momoro/papa/layer5/01_very_short_brown.png": "EkxZ",
	"./custom/momoro/papa/layer5/01_very_short_grey.png": "HnpP",
	"./custom/momoro/papa/layer5/01_very_short_yellow.png": "8l8I",
	"./custom/momoro/papa/layer5/02_long_black.png": "J2x3",
	"./custom/momoro/papa/layer5/02_long_brown.png": "fp13",
	"./custom/momoro/papa/layer5/02_long_gray.png": "9aK1",
	"./custom/momoro/papa/layer5/02_long_grey.png": "rwZo",
	"./custom/momoro/papa/layer5/02_long_yellow.png": "Egrc",
	"./custom/momoro/papa/layer5/02_mid_black.png": "Q5kV",
	"./custom/momoro/papa/layer5/02_mid_brown.png": "yk3h",
	"./custom/momoro/papa/layer5/02_mid_grey.png": "47qr",
	"./custom/momoro/papa/layer5/02_mid_yellow.png": "BJgN",
	"./custom/momoro/papa/layer5/02_short_black.png": "Anub",
	"./custom/momoro/papa/layer5/02_short_brown.png": "0B28",
	"./custom/momoro/papa/layer5/02_short_grey.png": "tHL+",
	"./custom/momoro/papa/layer5/02_short_yellow.png": "dTzo",
	"./custom/momoro/papa/layer5/02_very_short_black.png": "OFnT",
	"./custom/momoro/papa/layer5/02_very_short_brown.png": "lUrn",
	"./custom/momoro/papa/layer5/02_very_short_grey.png": "674t",
	"./custom/momoro/papa/layer5/02_very_short_yellow.png": "kE4H",
	"./custom/momoro/papa/layer5/03_long_black.png": "Eq0h",
	"./custom/momoro/papa/layer5/03_long_brown.png": "iHuH",
	"./custom/momoro/papa/layer5/03_long_gray.png": "9QZ7",
	"./custom/momoro/papa/layer5/03_long_grey.png": "pv78",
	"./custom/momoro/papa/layer5/03_long_yellow.png": "J98M",
	"./custom/momoro/papa/layer5/03_mid_black.png": "KxQ7",
	"./custom/momoro/papa/layer5/03_mid_brown.png": "ec8p",
	"./custom/momoro/papa/layer5/03_mid_grey.png": "Rjdx",
	"./custom/momoro/papa/layer5/03_mid_yellow.png": "NifX",
	"./custom/momoro/papa/layer5/03_short_black.png": "egyn",
	"./custom/momoro/papa/layer5/03_short_brown.png": "h6/U",
	"./custom/momoro/papa/layer5/03_short_grey.png": "Qer0",
	"./custom/momoro/papa/layer5/03_short_yellow.png": "FYxJ",
	"./custom/momoro/papa/layer5/03_very_short_black.png": "kWAv",
	"./custom/momoro/papa/layer5/03_very_short_brown.png": "gPje",
	"./custom/momoro/papa/layer5/03_very_short_grey.png": "DGMd",
	"./custom/momoro/papa/layer5/03_very_short_yellow.png": "7twA",
	"./custom/momoro/papa/layer5/04_long_black.png": "EV3z",
	"./custom/momoro/papa/layer5/04_long_brown.png": "na0q",
	"./custom/momoro/papa/layer5/04_long_grey.png": "y9J3",
	"./custom/momoro/papa/layer5/04_long_yellow.png": "pMrR",
	"./custom/momoro/papa/layer5/04_mid_black.png": "OYkI",
	"./custom/momoro/papa/layer5/04_mid_brown.png": "sPEy",
	"./custom/momoro/papa/layer5/04_mid_grey.png": "e1qx",
	"./custom/momoro/papa/layer5/04_mid_yellow.png": "ypBU",
	"./custom/momoro/papa/layer5/04_short_black.png": "iX74",
	"./custom/momoro/papa/layer5/04_short_brown.png": "0Uuo",
	"./custom/momoro/papa/layer5/04_short_grey.png": "xhsh",
	"./custom/momoro/papa/layer5/04_short_yellow.png": "od31",
	"./custom/momoro/papa/layer5/04_very_short_black.png": "MLZa",
	"./custom/momoro/papa/layer5/04_very_short_brown.png": "8UwZ",
	"./custom/momoro/papa/layer5/04_very_short_grey.png": "OWMR",
	"./custom/momoro/papa/layer5/04_very_short_yellow.png": "RYW8",
	"./custom/momoro/papa/layer5/05_short_black.png": "rfNW",
	"./custom/momoro/papa/layer5/05_short_brown.png": "e2MG",
	"./custom/momoro/papa/layer5/05_short_grey.png": "uMD4",
	"./custom/momoro/papa/layer5/05_short_yellow.png": "upsi",
	"./custom/nakagawa/boy/layer1/01_face.png": "44Oz",
	"./custom/nakagawa/boy/layer1/02_face.png": "Py0j",
	"./custom/nakagawa/boy/layer1/03_face.png": "rD8Q",
	"./custom/nakagawa/boy/layer1/04_face.png": "0sl5",
	"./custom/nakagawa/boy/layer1/05_face.png": "keX+",
	"./custom/nakagawa/boy/layer1/06_face.png": "JXV4",
	"./custom/nakagawa/boy/layer1/07_face.png": "0P9g",
	"./custom/nakagawa/boy/layer1/08_face.png": "6MlM",
	"./custom/nakagawa/boy/layer1/09_face.png": "VVgm",
	"./custom/nakagawa/boy/layer2/00_mole.png": "UedL",
	"./custom/nakagawa/boy/layer2/01_mole.png": "vRjS",
	"./custom/nakagawa/boy/layer2/02_mole.png": "zZvo",
	"./custom/nakagawa/boy/layer2/03_mole.png": "9Slg",
	"./custom/nakagawa/boy/layer2/04_mole.png": "jiWA",
	"./custom/nakagawa/boy/layer2/05_mole.png": "8zB7",
	"./custom/nakagawa/boy/layer2/06_mole.png": "HbCj",
	"./custom/nakagawa/boy/layer2/07_mole.png": "u4iS",
	"./custom/nakagawa/boy/layer2/08_mole.png": "NC7s",
	"./custom/nakagawa/boy/layer2/09_mole.png": "1TXS",
	"./custom/nakagawa/boy/layer2/10_mole.png": "awes",
	"./custom/nakagawa/boy/layer3/00_cheek.png": "JMfb",
	"./custom/nakagawa/boy/layer3/01_cheek.png": "ElCJ",
	"./custom/nakagawa/boy/layer3/02_sobakasu.png": "sEfe",
	"./custom/nakagawa/boy/layer4/00_glasses.png": "qhZa",
	"./custom/nakagawa/boy/layer4/01_glasses_black.png": "gpKM",
	"./custom/nakagawa/boy/layer4/01_glasses_blue.png": "YYIM",
	"./custom/nakagawa/boy/layer4/01_glasses_red.png": "DWRq",
	"./custom/nakagawa/boy/layer4/02_glasses_black.png": "CV0v",
	"./custom/nakagawa/boy/layer4/02_glasses_blue.png": "GxmO",
	"./custom/nakagawa/boy/layer4/02_glasses_red.png": "oX3J",
	"./custom/nakagawa/boy/layer4/03_glasses_black.png": "Oihn",
	"./custom/nakagawa/boy/layer4/03_glasses_blue.png": "+jVc",
	"./custom/nakagawa/boy/layer4/03_glasses_red.png": "tocN",
	"./custom/nakagawa/boy/layer4/04_glasses_black.png": "l59K",
	"./custom/nakagawa/boy/layer4/04_glasses_blue.png": "r4xQ",
	"./custom/nakagawa/boy/layer4/04_glasses_red.png": "G+sz",
	"./custom/nakagawa/boy/layer5/00_hair.png": "QW5Z",
	"./custom/nakagawa/boy/layer5/01_baby.png": "TrZ5",
	"./custom/nakagawa/boy/layer5/01_long_black.png": "ICO0",
	"./custom/nakagawa/boy/layer5/01_long_brown.png": "BqOp",
	"./custom/nakagawa/boy/layer5/01_long_yellow.png": "8rAr",
	"./custom/nakagawa/boy/layer5/01_mid_black.png": "o686",
	"./custom/nakagawa/boy/layer5/01_mid_brown.png": "jkss",
	"./custom/nakagawa/boy/layer5/01_mid_yellow.png": "mjmc",
	"./custom/nakagawa/boy/layer5/01_short_black.png": "rmil",
	"./custom/nakagawa/boy/layer5/01_short_brown.png": "AbGi",
	"./custom/nakagawa/boy/layer5/01_short_yellow.png": "U4qQ",
	"./custom/nakagawa/boy/layer5/01_very_short_black.png": "yjEg",
	"./custom/nakagawa/boy/layer5/01_very_short_brown.png": "wTEL",
	"./custom/nakagawa/boy/layer5/01_very_short_yellow.png": "c1De",
	"./custom/nakagawa/boy/layer5/02_long_black.png": "EMcr",
	"./custom/nakagawa/boy/layer5/02_long_brown.png": "OiAc",
	"./custom/nakagawa/boy/layer5/02_long_yellow.png": "ltiq",
	"./custom/nakagawa/boy/layer5/02_mid_black.png": "pa4B",
	"./custom/nakagawa/boy/layer5/02_mid_brown.png": "5atn",
	"./custom/nakagawa/boy/layer5/02_mid_yellow.png": "JurC",
	"./custom/nakagawa/boy/layer5/02_short_black.png": "i0hf",
	"./custom/nakagawa/boy/layer5/02_short_brown.png": "xjSp",
	"./custom/nakagawa/boy/layer5/02_short_yellow.png": "IgdI",
	"./custom/nakagawa/boy/layer5/02_very_short_black.png": "S7b5",
	"./custom/nakagawa/boy/layer5/02_very_short_brown.png": "vV69",
	"./custom/nakagawa/boy/layer5/02_very_short_yellow.png": "P38f",
	"./custom/nakagawa/boy/layer5/03_mid_black.png": "nKNt",
	"./custom/nakagawa/boy/layer5/03_mid_brown.png": "1gOD",
	"./custom/nakagawa/boy/layer5/03_mid_yellow.png": "B4oR",
	"./custom/nakagawa/boy/layer5/03_short_black.png": "d+6Q",
	"./custom/nakagawa/boy/layer5/03_short_brown.png": "6FOU",
	"./custom/nakagawa/boy/layer5/03_short_yellow.png": "eliY",
	"./custom/nakagawa/boy/layer5/03_very_short_black.png": "jAyZ",
	"./custom/nakagawa/boy/layer5/03_very_short_brown.png": "DmsZ",
	"./custom/nakagawa/boy/layer5/03_very_short_yellow.png": "lfaV",
	"./custom/nakagawa/boy/layer5/04_mid_black.png": "wNeZ",
	"./custom/nakagawa/boy/layer5/04_mid_brown.png": "x5uG",
	"./custom/nakagawa/boy/layer5/04_mid_yellow.png": "dHWI",
	"./custom/nakagawa/boy/layer5/04_short_black.png": "vS0Y",
	"./custom/nakagawa/boy/layer5/04_short_brown.png": "fx6n",
	"./custom/nakagawa/boy/layer5/04_short_yellow.png": "S/FQ",
	"./custom/nakagawa/boy/layer5/04_very_short_black.png": "JHrx",
	"./custom/nakagawa/boy/layer5/04_very_short_brown.png": "9lc1",
	"./custom/nakagawa/boy/layer5/04_very_short_yellow.png": "1Ae/",
	"./custom/nakagawa/boy/layer5/05_mid_black.png": "L8YI",
	"./custom/nakagawa/boy/layer5/05_mid_brown.png": "pchz",
	"./custom/nakagawa/boy/layer5/05_mid_yellow.png": "ULUR",
	"./custom/nakagawa/boy/layer5/05_short_black.png": "N5rw",
	"./custom/nakagawa/boy/layer5/05_short_brown.png": "pxqg",
	"./custom/nakagawa/boy/layer5/05_short_yellow.png": "15ck",
	"./custom/nakagawa/female/layer1/01_face.png": "0sjT",
	"./custom/nakagawa/female/layer1/02_face.png": "ZGti",
	"./custom/nakagawa/female/layer1/03_face.png": "fe8c",
	"./custom/nakagawa/female/layer1/04_face.png": "E0kp",
	"./custom/nakagawa/female/layer1/05_face.png": "0WCL",
	"./custom/nakagawa/female/layer1/06_face.png": "Fx7X",
	"./custom/nakagawa/female/layer1/07_face.png": "Tt+u",
	"./custom/nakagawa/female/layer1/08_face.png": "XGlE",
	"./custom/nakagawa/female/layer1/09_face.png": "4CcX",
	"./custom/nakagawa/female/layer2/00_mole.png": "PQuW",
	"./custom/nakagawa/female/layer2/01_mole.png": "c9Rj",
	"./custom/nakagawa/female/layer2/02_mole.png": "hJQH",
	"./custom/nakagawa/female/layer2/03_mole.png": "eDG4",
	"./custom/nakagawa/female/layer2/04_mole.png": "aCg7",
	"./custom/nakagawa/female/layer2/05_mole.png": "IMcz",
	"./custom/nakagawa/female/layer2/06_mole.png": "J1J/",
	"./custom/nakagawa/female/layer2/07_mole.png": "f2Q/",
	"./custom/nakagawa/female/layer2/08_mole.png": "rL/F",
	"./custom/nakagawa/female/layer2/09_mole.png": "Whlj",
	"./custom/nakagawa/female/layer2/10_mole.png": "wEaX",
	"./custom/nakagawa/female/layer3/00_cheeks.png": "B+Jl",
	"./custom/nakagawa/female/layer3/01_cheeks.png": "Xl/L",
	"./custom/nakagawa/female/layer3/02_cheeks.png": "/EAs",
	"./custom/nakagawa/female/layer4/00_glasses.png": "qJl3",
	"./custom/nakagawa/female/layer4/01_glasses_black.png": "JOGy",
	"./custom/nakagawa/female/layer4/01_glasses_blue.png": "2g07",
	"./custom/nakagawa/female/layer4/01_glasses_red.png": "jQuv",
	"./custom/nakagawa/female/layer4/02_glasses_black.png": "Ah/x",
	"./custom/nakagawa/female/layer4/02_glasses_blue.png": "UNb6",
	"./custom/nakagawa/female/layer4/02_glasses_red.png": "Sbqg",
	"./custom/nakagawa/female/layer4/03_glasses_black.png": "VG+f",
	"./custom/nakagawa/female/layer4/03_glasses_blue.png": "Mtwl",
	"./custom/nakagawa/female/layer4/03_glasses_red.png": "+TkO",
	"./custom/nakagawa/female/layer4/04_glasses_black.png": "RABj",
	"./custom/nakagawa/female/layer4/04_glasses_blue.png": "B45j",
	"./custom/nakagawa/female/layer4/04_glasses_red.png": "G2lL",
	"./custom/nakagawa/female/layer4/05_glasses_black.png": "X49g",
	"./custom/nakagawa/female/layer4/05_glasses_blue.png": "SNKf",
	"./custom/nakagawa/female/layer4/05_glasses_red.png": "szah",
	"./custom/nakagawa/female/layer5/00_hair.png": "Yknw",
	"./custom/nakagawa/female/layer5/01_hair_black.png": "Ds4L",
	"./custom/nakagawa/female/layer5/01_hair_brown.png": "8Xcr",
	"./custom/nakagawa/female/layer5/01_hair_gold.png": "LhXz",
	"./custom/nakagawa/female/layer5/01_hair_silver.png": "EZUB",
	"./custom/nakagawa/female/layer5/02_hair_black.png": "u6d6",
	"./custom/nakagawa/female/layer5/02_hair_brown.png": "bz4S",
	"./custom/nakagawa/female/layer5/02_hair_gold.png": "Joas",
	"./custom/nakagawa/female/layer5/02_hair_silver.png": "kTQp",
	"./custom/nakagawa/female/layer5/03_hair_black.png": "IMyR",
	"./custom/nakagawa/female/layer5/03_hair_brown.png": "H2et",
	"./custom/nakagawa/female/layer5/03_hair_gold.png": "IAGT",
	"./custom/nakagawa/female/layer5/03_hair_silver.png": "jJVW",
	"./custom/nakagawa/female/layer5/04_hair_black.png": "4NYf",
	"./custom/nakagawa/female/layer5/04_hair_brown.png": "D/1X",
	"./custom/nakagawa/female/layer5/04_hair_gold.png": "K+mR",
	"./custom/nakagawa/female/layer5/04_hair_silver.png": "4+Cy",
	"./custom/nakagawa/female/layer5/05_hair_black.png": "QKiu",
	"./custom/nakagawa/female/layer5/05_hair_brown.png": "4uTO",
	"./custom/nakagawa/female/layer5/05_hair_gold.png": "1TuR",
	"./custom/nakagawa/female/layer5/05_hair_silver.png": "4sK3",
	"./custom/nakagawa/female/layer5/06_hair_black.png": "hzh+",
	"./custom/nakagawa/female/layer5/06_hair_brown.png": "d/dl",
	"./custom/nakagawa/female/layer5/06_hair_gold.png": "D890",
	"./custom/nakagawa/female/layer5/06_hair_silver.png": "wIEP",
	"./custom/nakagawa/female/layer5/07_hair_black.png": "s6HU",
	"./custom/nakagawa/female/layer5/07_hair_brown.png": "idfK",
	"./custom/nakagawa/female/layer5/07_hair_gold.png": "xEea",
	"./custom/nakagawa/female/layer5/07_hair_silver.png": "q014",
	"./custom/nakagawa/female/layer5/08_hair_black.png": "3HhR",
	"./custom/nakagawa/female/layer5/08_hair_brown.png": "po83",
	"./custom/nakagawa/female/layer5/08_hair_gold.png": "u44o",
	"./custom/nakagawa/female/layer5/08_hair_silver.png": "orCa",
	"./custom/nakagawa/female/layer5/09_hair_black.png": "++uA",
	"./custom/nakagawa/female/layer5/09_hair_brown.png": "LFrn",
	"./custom/nakagawa/female/layer5/09_hair_gold.png": "Ub4d",
	"./custom/nakagawa/female/layer5/09_hair_silver.png": "T7IZ",
	"./custom/nakagawa/female/layer5/10_hair_black.png": "DfdJ",
	"./custom/nakagawa/female/layer5/10_hair_brown.png": "5oVF",
	"./custom/nakagawa/female/layer5/10_hair_gold.png": "7WpJ",
	"./custom/nakagawa/female/layer5/10_hair_silver.png": "XtU9",
	"./custom/nakagawa/female/layer5/11_hair_black.png": "9DMW",
	"./custom/nakagawa/female/layer5/11_hair_brown.png": "2QEl",
	"./custom/nakagawa/female/layer5/11_hair_gold.png": "v4Xz",
	"./custom/nakagawa/female/layer5/11_hair_silver.png": "1qNX",
	"./custom/nakagawa/female/layer5/12_hair_black.png": "YI6t",
	"./custom/nakagawa/female/layer5/12_hair_brown.png": "0ozH",
	"./custom/nakagawa/female/layer5/12_hair_gold.png": "1of2",
	"./custom/nakagawa/female/layer5/12_hair_silver.png": "tlls",
	"./custom/nakagawa/female/layer5/13_hair_black.png": "DdNG",
	"./custom/nakagawa/female/layer5/13_hair_brown.png": "C+UN",
	"./custom/nakagawa/female/layer5/13_hair_gold.png": "+jPI",
	"./custom/nakagawa/female/layer5/13_hair_silver.png": "kdFZ",
	"./custom/nakagawa/female/layer5/14_hair_black.png": "I9FA",
	"./custom/nakagawa/female/layer5/14_hair_brown.png": "gyX7",
	"./custom/nakagawa/female/layer5/14_hair_gold.png": "unuz",
	"./custom/nakagawa/female/layer5/14_hair_silver.png": "2rkP",
	"./custom/nakagawa/female/layer5/15_hair_black.png": "+xor",
	"./custom/nakagawa/female/layer5/15_hair_brown.png": "NbO2",
	"./custom/nakagawa/female/layer5/15_hair_gold.png": "O+tv",
	"./custom/nakagawa/female/layer5/15_hair_silver.png": "Fo0S",
	"./custom/nakagawa/female/layer5/16_hair_black.png": "PaTb",
	"./custom/nakagawa/female/layer5/16_hair_brown.png": "UGEz",
	"./custom/nakagawa/female/layer5/16_hair_gold.png": "J4TK",
	"./custom/nakagawa/female/layer5/16_hair_silver.png": "UXn4",
	"./custom/nakagawa/female/layer5/17_hair_black.png": "nM9W",
	"./custom/nakagawa/female/layer5/17_hair_brown.png": "vQMj",
	"./custom/nakagawa/female/layer5/17_hair_gold.png": "/FVA",
	"./custom/nakagawa/female/layer5/17_hair_silver.png": "80lW",
	"./custom/nakagawa/female/layer5/18_hair_black.png": "b9Uz",
	"./custom/nakagawa/female/layer5/18_hair_brown.png": "FPyX",
	"./custom/nakagawa/female/layer5/18_hair_gold.png": "9kyd",
	"./custom/nakagawa/female/layer5/18_hair_silver.png": "kdpq",
	"./custom/nakagawa/girl/layer1/01_face.png": "VyHP",
	"./custom/nakagawa/girl/layer1/02_face.png": "1iV+",
	"./custom/nakagawa/girl/layer1/03_face.png": "Mbhs",
	"./custom/nakagawa/girl/layer1/04_face.png": "oR18",
	"./custom/nakagawa/girl/layer1/05_face.png": "+xsf",
	"./custom/nakagawa/girl/layer1/06_face.png": "w5+5",
	"./custom/nakagawa/girl/layer1/07_face.png": "6gQN",
	"./custom/nakagawa/girl/layer1/08_face.png": "C0KD",
	"./custom/nakagawa/girl/layer1/09_face.png": "8Vtb",
	"./custom/nakagawa/girl/layer2/00_mole.png": "+3YE",
	"./custom/nakagawa/girl/layer2/01_mole.png": "p8PY",
	"./custom/nakagawa/girl/layer2/02_mole.png": "pGq8",
	"./custom/nakagawa/girl/layer2/03_mole.png": "lfcT",
	"./custom/nakagawa/girl/layer2/04_mole.png": "jD1Q",
	"./custom/nakagawa/girl/layer2/05_mole.png": "5tNk",
	"./custom/nakagawa/girl/layer2/06_mole.png": "lMk/",
	"./custom/nakagawa/girl/layer2/07_mole.png": "1nSW",
	"./custom/nakagawa/girl/layer2/08_mole.png": "D+Lm",
	"./custom/nakagawa/girl/layer2/09_mole.png": "x3ID",
	"./custom/nakagawa/girl/layer2/10_mole.png": "YVJI",
	"./custom/nakagawa/girl/layer3/00_cheek.png": "SNFh",
	"./custom/nakagawa/girl/layer3/01_cheek.png": "pxZ2",
	"./custom/nakagawa/girl/layer3/02_sobakasu.png": "cKnP",
	"./custom/nakagawa/girl/layer4/00_glasses.png": "0LID",
	"./custom/nakagawa/girl/layer4/01_glasses_black.png": "uhTU",
	"./custom/nakagawa/girl/layer4/01_glasses_blue.png": "2yiV",
	"./custom/nakagawa/girl/layer4/01_glasses_red.png": "jsng",
	"./custom/nakagawa/girl/layer4/02_glasses_black.png": "8WZn",
	"./custom/nakagawa/girl/layer4/02_glasses_blue.png": "gxSF",
	"./custom/nakagawa/girl/layer4/02_glasses_red.png": "Ijq4",
	"./custom/nakagawa/girl/layer4/03_glasses_black.png": "o7e0",
	"./custom/nakagawa/girl/layer4/03_glasses_blue.png": "Z0ec",
	"./custom/nakagawa/girl/layer4/03_glasses_red.png": "cPYL",
	"./custom/nakagawa/girl/layer4/04_glasses_black.png": "eLMB",
	"./custom/nakagawa/girl/layer4/04_glasses_blue.png": "ElhN",
	"./custom/nakagawa/girl/layer4/04_glasses_red.png": "1a9t",
	"./custom/nakagawa/girl/layer5/00_hair.png": "jj7z",
	"./custom/nakagawa/girl/layer5/01_baby.png": "Mlos",
	"./custom/nakagawa/girl/layer5/01_bob_black.png": "QDx8",
	"./custom/nakagawa/girl/layer5/01_bob_brown.png": "Sbz9",
	"./custom/nakagawa/girl/layer5/01_bob_yellow.png": "MtvY",
	"./custom/nakagawa/girl/layer5/01_long_black.png": "toCt",
	"./custom/nakagawa/girl/layer5/01_long_brown.png": "aIG7",
	"./custom/nakagawa/girl/layer5/01_long_yellow.png": "902G",
	"./custom/nakagawa/girl/layer5/01_short_black.png": "Nee3",
	"./custom/nakagawa/girl/layer5/01_short_brown.png": "4y9E",
	"./custom/nakagawa/girl/layer5/01_short_yellow.png": "VMA+",
	"./custom/nakagawa/girl/layer5/02_bob_black.png": "5jjE",
	"./custom/nakagawa/girl/layer5/02_bob_brown.png": "ExZ+",
	"./custom/nakagawa/girl/layer5/02_bob_yellow.png": "bUq2",
	"./custom/nakagawa/girl/layer5/02_long_black.png": "ZsTJ",
	"./custom/nakagawa/girl/layer5/02_long_brown.png": "cYyE",
	"./custom/nakagawa/girl/layer5/02_long_yellow.png": "egJV",
	"./custom/nakagawa/girl/layer5/02_short_black.png": "l7TS",
	"./custom/nakagawa/girl/layer5/02_short_brown.png": "EUQK",
	"./custom/nakagawa/girl/layer5/02_short_yellow.png": "/5jk",
	"./custom/nakagawa/girl/layer5/03_bob_black.png": "UTpK",
	"./custom/nakagawa/girl/layer5/03_bob_brown.png": "A4f6",
	"./custom/nakagawa/girl/layer5/03_bob_yellow.png": "x6j9",
	"./custom/nakagawa/girl/layer5/03_long_black.png": "zrdT",
	"./custom/nakagawa/girl/layer5/03_long_brown.png": "4mIT",
	"./custom/nakagawa/girl/layer5/03_long_yellow.png": "Qfqe",
	"./custom/nakagawa/girl/layer5/03_short_black.png": "ov60",
	"./custom/nakagawa/girl/layer5/03_short_brown.png": "LYCb",
	"./custom/nakagawa/girl/layer5/03_short_yellow.png": "wtdR",
	"./custom/nakagawa/girl/layer5/04_long_black.png": "mCHr",
	"./custom/nakagawa/girl/layer5/04_long_brown.png": "Up7z",
	"./custom/nakagawa/girl/layer5/04_long_yellow.png": "dgxW",
	"./custom/nakagawa/girl/layer5/04_short_black.png": "4Vm0",
	"./custom/nakagawa/girl/layer5/04_short_brown.png": "C4dR",
	"./custom/nakagawa/girl/layer5/04_short_yellow.png": "EIeT",
	"./custom/nakagawa/girl/layer5/05_long_black.png": "INFp",
	"./custom/nakagawa/girl/layer5/05_long_brown.png": "rD82",
	"./custom/nakagawa/girl/layer5/05_long_yellow.png": "3ygX",
	"./custom/nakagawa/girl/layer5/06_long_black.png": "YMFk",
	"./custom/nakagawa/girl/layer5/06_long_brown.png": "5pVm",
	"./custom/nakagawa/girl/layer5/06_long_yellow.png": "/ez+",
	"./custom/nakagawa/girl/layer5/07_long_black.png": "ag6t",
	"./custom/nakagawa/girl/layer5/07_long_brown.png": "Evvn",
	"./custom/nakagawa/girl/layer5/07_long_yellow.png": "qSGV",
	"./custom/nakagawa/girl/layer5/08_long_black.png": "6wbx",
	"./custom/nakagawa/girl/layer5/08_long_brown.png": "R2o7",
	"./custom/nakagawa/girl/layer5/08_long_yellow.png": "vngP",
	"./custom/nakagawa/girl/layer5/09_long_black.png": "ZjJ1",
	"./custom/nakagawa/girl/layer5/09_long_brown.png": "1ziL",
	"./custom/nakagawa/girl/layer5/09_long_yellow.png": "TQOg",
	"./custom/nakagawa/male/layer1/01_face.png": "DPFq",
	"./custom/nakagawa/male/layer1/02_face.png": "FnEw",
	"./custom/nakagawa/male/layer1/03_face.png": "V3+x",
	"./custom/nakagawa/male/layer1/04_face.png": "+pQy",
	"./custom/nakagawa/male/layer1/05_face.png": "bBuh",
	"./custom/nakagawa/male/layer1/06_face.png": "2VzA",
	"./custom/nakagawa/male/layer1/07_face.png": "cRym",
	"./custom/nakagawa/male/layer1/08_face.png": "VIvb",
	"./custom/nakagawa/male/layer1/09_face.png": "G8wg",
	"./custom/nakagawa/male/layer2/00_mole.png": "R3p4",
	"./custom/nakagawa/male/layer2/01_mole.png": "wlno",
	"./custom/nakagawa/male/layer2/02_mole.png": "Z4a5",
	"./custom/nakagawa/male/layer2/03_mole.png": "QaBw",
	"./custom/nakagawa/male/layer2/04_mole.png": "X0Jw",
	"./custom/nakagawa/male/layer2/05_mole.png": "qOMv",
	"./custom/nakagawa/male/layer2/06_mole.png": "F9SS",
	"./custom/nakagawa/male/layer2/07_mole.png": "/1bp",
	"./custom/nakagawa/male/layer2/08_mole.png": "w0tC",
	"./custom/nakagawa/male/layer2/09_mole.png": "dx7U",
	"./custom/nakagawa/male/layer2/10_mole.png": "/Wby",
	"./custom/nakagawa/male/layer3/01_cheeks.png": "cuP2",
	"./custom/nakagawa/male/layer3/01_mustache_brown.png": "SNMt",
	"./custom/nakagawa/male/layer3/01_mustache_silver.png": "oLjl",
	"./custom/nakagawa/male/layer3/02_mustache_brown.png": "6Oxg",
	"./custom/nakagawa/male/layer3/02_mustache_silver.png": "Np1n",
	"./custom/nakagawa/male/layer3/03_mustache_brown.png": "gJY+",
	"./custom/nakagawa/male/layer3/03_mustache_silver.png": "kE+L",
	"./custom/nakagawa/male/layer3/04_mustache_brown.png": "lOaC",
	"./custom/nakagawa/male/layer3/04_mustache_silver.png": "AMXr",
	"./custom/nakagawa/male/layer3/05_mustache_brown.png": "QdBR",
	"./custom/nakagawa/male/layer3/05_mustache_silver.png": "OFeH",
	"./custom/nakagawa/male/layer3/06_mustache_brown.png": "QBFB",
	"./custom/nakagawa/male/layer3/06_mustache_silver.png": "nBwb",
	"./custom/nakagawa/male/layer3/07_mustache_brown.png": "57Os",
	"./custom/nakagawa/male/layer3/07_mustache_silver.png": "lAl4",
	"./custom/nakagawa/male/layer3/08_mustache_brown.png": "D57F",
	"./custom/nakagawa/male/layer3/08_mustache_silver.png": "9Jv0",
	"./custom/nakagawa/male/layer3/09_mustache_brown.png": "V0rB",
	"./custom/nakagawa/male/layer3/09_mustache_silver.png": "Z6Nx",
	"./custom/nakagawa/male/layer3/10_mustache_brown.png": "e3rW",
	"./custom/nakagawa/male/layer3/10_mustache_silver.png": "dfLT",
	"./custom/nakagawa/male/layer3/11_mustache_brown.png": "tPqF",
	"./custom/nakagawa/male/layer3/11_mustache_silver.png": "Ah89",
	"./custom/nakagawa/male/layer4/00_glasses.png": "GSuM",
	"./custom/nakagawa/male/layer4/01_glasses_black.png": "e17U",
	"./custom/nakagawa/male/layer4/01_glasses_blue.png": "rj/e",
	"./custom/nakagawa/male/layer4/01_glasses_red.png": "R8H2",
	"./custom/nakagawa/male/layer4/02_glasses_black.png": "B6MO",
	"./custom/nakagawa/male/layer4/02_glasses_blue.png": "M5o/",
	"./custom/nakagawa/male/layer4/02_glasses_red.png": "pstz",
	"./custom/nakagawa/male/layer4/03_glasses_black.png": "ME2c",
	"./custom/nakagawa/male/layer4/03_glasses_blue.png": "Lyie",
	"./custom/nakagawa/male/layer4/03_glasses_red.png": "m5mn",
	"./custom/nakagawa/male/layer4/04_glasses_black.png": "mbog",
	"./custom/nakagawa/male/layer4/04_glasses_blue.png": "NmqW",
	"./custom/nakagawa/male/layer4/04_glasses_red.png": "DTB5",
	"./custom/nakagawa/male/layer4/05_glasses_black.png": "nv+1",
	"./custom/nakagawa/male/layer4/05_glasses_blue.png": "KnFI",
	"./custom/nakagawa/male/layer4/05_glasses_red.png": "PGLb",
	"./custom/nakagawa/male/layer5/00_hair.png": "dwtp",
	"./custom/nakagawa/male/layer5/01_hair_black.png": "VUAC",
	"./custom/nakagawa/male/layer5/01_hair_brown.png": "3b28",
	"./custom/nakagawa/male/layer5/01_hair_gold.png": "aJZ3",
	"./custom/nakagawa/male/layer5/01_hair_silver.png": "3ur7",
	"./custom/nakagawa/male/layer5/02_hair_black.png": "wycx",
	"./custom/nakagawa/male/layer5/02_hair_brown.png": "sWIr",
	"./custom/nakagawa/male/layer5/02_hair_gold.png": "TeGc",
	"./custom/nakagawa/male/layer5/02_hair_silver.png": "2IYk",
	"./custom/nakagawa/male/layer5/03_hair_black.png": "l89Y",
	"./custom/nakagawa/male/layer5/03_hair_brown.png": "TiMh",
	"./custom/nakagawa/male/layer5/03_hair_gold.png": "tzJy",
	"./custom/nakagawa/male/layer5/03_hair_silver.png": "NPC6",
	"./custom/nakagawa/male/layer5/04_hair_black.png": "7vE0",
	"./custom/nakagawa/male/layer5/04_hair_brown.png": "HbUZ",
	"./custom/nakagawa/male/layer5/04_hair_gold.png": "e8a6",
	"./custom/nakagawa/male/layer5/04_hair_silver.png": "5wmr",
	"./custom/nakagawa/male/layer5/05_hair_black.png": "Maxw",
	"./custom/nakagawa/male/layer5/05_hair_brown.png": "iUog",
	"./custom/nakagawa/male/layer5/05_hair_gold.png": "nmt9",
	"./custom/nakagawa/male/layer5/05_hair_silver.png": "mQTJ",
	"./custom/nakagawa/male/layer5/06_hair_black.png": "dW6y",
	"./custom/nakagawa/male/layer5/06_hair_brown.png": "c1FK",
	"./custom/nakagawa/male/layer5/06_hair_gold.png": "ftSR",
	"./custom/nakagawa/male/layer5/06_hair_silver.png": "4Olm",
	"./custom/nakagawa/male/layer5/07_hair_black.png": "/aqf",
	"./custom/nakagawa/male/layer5/07_hair_brown.png": "gCJH",
	"./custom/nakagawa/male/layer5/07_hair_gold.png": "I8EI",
	"./custom/nakagawa/male/layer5/07_hair_silver.png": "HcGp",
	"./custom/nakagawa/male/layer5/08_hair_black.png": "hOsp",
	"./custom/nakagawa/male/layer5/08_hair_brown.png": "+Er1",
	"./custom/nakagawa/male/layer5/08_hair_gold.png": "B8M3",
	"./custom/nakagawa/male/layer5/08_hair_silver.png": "EETk",
	"./custom/nakagawa/male/layer5/09_hair_black.png": "j/XM",
	"./custom/nakagawa/male/layer5/09_hair_brown.png": "2vTV",
	"./custom/nakagawa/male/layer5/09_hair_gold.png": "NAgV",
	"./custom/nakagawa/male/layer5/09_hair_silver.png": "hqQh",
	"./custom/nakagawa/male/layer5/10_hair_black.png": "v2Kb",
	"./custom/nakagawa/male/layer5/10_hair_brown.png": "SSIL",
	"./custom/nakagawa/male/layer5/10_hair_gold.png": "pzg/",
	"./custom/nakagawa/male/layer5/10_hair_silver.png": "x5Xr",
	"./custom/nakagawa/male/layer5/11_hair_black.png": "NRyu",
	"./custom/nakagawa/male/layer5/11_hair_brown.png": "Ez+b",
	"./custom/nakagawa/male/layer5/11_hair_gold.png": "tdtB",
	"./custom/nakagawa/male/layer5/11_hair_silver.png": "QTDD",
	"./custom/nakagawa/male/layer5/12_hair_black.png": "X/NW",
	"./custom/nakagawa/male/layer5/12_hair_brown.png": "xcJA",
	"./custom/nakagawa/male/layer5/12_hair_gold.png": "X+0y",
	"./custom/nakagawa/male/layer5/12_hair_silver.png": "uLuE",
	"./custom/nakagawa/male/layer5/13_hair_black.png": "/3KD",
	"./custom/nakagawa/male/layer5/13_hair_brown.png": "96Dv",
	"./custom/nakagawa/male/layer5/13_hair_gold.png": "up8A",
	"./custom/nakagawa/male/layer5/13_hair_silver.png": "cBUa",
	"./custom/nakagawa/male/layer5/14_hair_black.png": "61zg",
	"./custom/nakagawa/male/layer5/14_hair_brown.png": "Nbrd",
	"./custom/nakagawa/male/layer5/14_hair_gold.png": "pHoS",
	"./custom/nakagawa/male/layer5/14_hair_silver.png": "peYg",
	"./custom/nakagawa/male/layer5/15_hair_black.png": "Mb+S",
	"./custom/nakagawa/male/layer5/15_hair_brown.png": "H92d",
	"./custom/nakagawa/male/layer5/15_hair_gold.png": "Bx6W",
	"./custom/nakagawa/male/layer5/15_hair_silver.png": "9AEf",
	"./custom/nakagawa/male/layer5/16_hair_black.png": "f8ND",
	"./custom/nakagawa/male/layer5/16_hair_brown.png": "hSsO",
	"./custom/nakagawa/male/layer5/16_hair_gold.png": "mij0",
	"./custom/nakagawa/male/layer5/16_hair_silver.png": "U1sW",
	"./custom/nakagawa/male/layer5/17_hair_black.png": "BjT7",
	"./custom/nakagawa/male/layer5/17_hair_brown.png": "0O5t",
	"./custom/nakagawa/male/layer5/17_hair_gold.png": "dgPj",
	"./custom/nakagawa/male/layer5/17_hair_silver.png": "kSvA",
	"./custom/nakagawa/mama/layer1/01_face.png": "nTom",
	"./custom/nakagawa/mama/layer1/02_face.png": "Yq3q",
	"./custom/nakagawa/mama/layer1/03_face.png": "Bb3m",
	"./custom/nakagawa/mama/layer1/04_face.png": "j6Qb",
	"./custom/nakagawa/mama/layer1/05_face.png": "0TQP",
	"./custom/nakagawa/mama/layer1/06_face.png": "ZOly",
	"./custom/nakagawa/mama/layer1/07_face.png": "bR4s",
	"./custom/nakagawa/mama/layer1/08_face.png": "ht52",
	"./custom/nakagawa/mama/layer1/09_face.png": "KWde",
	"./custom/nakagawa/mama/layer2/00_mole.png": "Y2Wu",
	"./custom/nakagawa/mama/layer2/01_mole.png": "vDS3",
	"./custom/nakagawa/mama/layer2/02_mole.png": "FEmY",
	"./custom/nakagawa/mama/layer2/03_mole.png": "J9NJ",
	"./custom/nakagawa/mama/layer2/04_mole.png": "pOkf",
	"./custom/nakagawa/mama/layer2/05_mole.png": "Xv1z",
	"./custom/nakagawa/mama/layer2/06_mole.png": "E/rr",
	"./custom/nakagawa/mama/layer2/07_mole.png": "h1xG",
	"./custom/nakagawa/mama/layer2/08_mole.png": "tA3s",
	"./custom/nakagawa/mama/layer2/09_mole.png": "m1aZ",
	"./custom/nakagawa/mama/layer2/10_mole.png": "gOCR",
	"./custom/nakagawa/mama/layer3/00_cheek.png": "lw0T",
	"./custom/nakagawa/mama/layer3/01_cheek.png": "1EpJ",
	"./custom/nakagawa/mama/layer3/02_sobakasu.png": "lOlG",
	"./custom/nakagawa/mama/layer4/00_glasses.png": "7Hee",
	"./custom/nakagawa/mama/layer4/01_glasses_black.png": "mwhN",
	"./custom/nakagawa/mama/layer4/01_glasses_blue.png": "/l+u",
	"./custom/nakagawa/mama/layer4/01_glasses_red.png": "DXrQ",
	"./custom/nakagawa/mama/layer4/02_glasses_black.png": "JJrj",
	"./custom/nakagawa/mama/layer4/02_glasses_blue.png": "vjaa",
	"./custom/nakagawa/mama/layer4/02_glasses_red.png": "9C7A",
	"./custom/nakagawa/mama/layer4/03_glasses_black.png": "k+Mv",
	"./custom/nakagawa/mama/layer4/03_glasses_blue.png": "wV45",
	"./custom/nakagawa/mama/layer4/03_glasses_red.png": "8II7",
	"./custom/nakagawa/mama/layer4/04_glasses_black.png": "Orlf",
	"./custom/nakagawa/mama/layer4/04_glasses_blue.png": "/ioj",
	"./custom/nakagawa/mama/layer4/04_glasses_red.png": "syRw",
	"./custom/nakagawa/mama/layer4/05_glasses_black.png": "D115",
	"./custom/nakagawa/mama/layer4/05_glasses_blue.png": "CmiO",
	"./custom/nakagawa/mama/layer4/05_glasses_red.png": "FFZ3",
	"./custom/nakagawa/mama/layer5/00_hair.png": "7bGv",
	"./custom/nakagawa/mama/layer5/01_long_black.png": "2JKt",
	"./custom/nakagawa/mama/layer5/01_long_brown.png": "fctm",
	"./custom/nakagawa/mama/layer5/01_long_gold.png": "MODu",
	"./custom/nakagawa/mama/layer5/01_long_grey.png": "8oVZ",
	"./custom/nakagawa/mama/layer5/01_medium_black.png": "dXN5",
	"./custom/nakagawa/mama/layer5/01_medium_brown.png": "rLLF",
	"./custom/nakagawa/mama/layer5/01_medium_gold.png": "O8VV",
	"./custom/nakagawa/mama/layer5/01_medium_grey.png": "DL4U",
	"./custom/nakagawa/mama/layer5/01_short_black.png": "7z+7",
	"./custom/nakagawa/mama/layer5/01_short_brown.png": "NHb7",
	"./custom/nakagawa/mama/layer5/01_short_gold.png": "3w8S",
	"./custom/nakagawa/mama/layer5/01_short_grey.png": "8Wcu",
	"./custom/nakagawa/mama/layer5/01_very_short_black.png": "W12Y",
	"./custom/nakagawa/mama/layer5/01_very_short_brown.png": "SA/5",
	"./custom/nakagawa/mama/layer5/01_very_short_gold.png": "bQLL",
	"./custom/nakagawa/mama/layer5/01_very_short_grey.png": "Rnzf",
	"./custom/nakagawa/mama/layer5/02_long_black.png": "PIr8",
	"./custom/nakagawa/mama/layer5/02_long_brown.png": "K5L/",
	"./custom/nakagawa/mama/layer5/02_long_gold.png": "GAm4",
	"./custom/nakagawa/mama/layer5/02_long_grey.png": "wruw",
	"./custom/nakagawa/mama/layer5/02_medium_black.png": "8/WB",
	"./custom/nakagawa/mama/layer5/02_medium_brown.png": "xSEf",
	"./custom/nakagawa/mama/layer5/02_medium_gold.png": "Kl3z",
	"./custom/nakagawa/mama/layer5/02_medium_grey.png": "MVRT",
	"./custom/nakagawa/mama/layer5/02_short_black.png": "uIWQ",
	"./custom/nakagawa/mama/layer5/02_short_brown.png": "X8wR",
	"./custom/nakagawa/mama/layer5/02_short_gold.png": "OJ60",
	"./custom/nakagawa/mama/layer5/02_short_grey.png": "E2mh",
	"./custom/nakagawa/mama/layer5/02_very_short_black.png": "8vil",
	"./custom/nakagawa/mama/layer5/02_very_short_brown.png": "Bca0",
	"./custom/nakagawa/mama/layer5/02_very_short_gold.png": "4m1k",
	"./custom/nakagawa/mama/layer5/02_very_short_grey.png": "SpIn",
	"./custom/nakagawa/mama/layer5/03_long_black.png": "uKih",
	"./custom/nakagawa/mama/layer5/03_long_brown.png": "nQw8",
	"./custom/nakagawa/mama/layer5/03_long_gold.png": "aJNe",
	"./custom/nakagawa/mama/layer5/03_long_grey.png": "Gm8F",
	"./custom/nakagawa/mama/layer5/03_medium_black.png": "o2KR",
	"./custom/nakagawa/mama/layer5/03_medium_brown.png": "S8O7",
	"./custom/nakagawa/mama/layer5/03_medium_gold.png": "8Hbz",
	"./custom/nakagawa/mama/layer5/03_medium_grey.png": "8znI",
	"./custom/nakagawa/mama/layer5/03_short_black.png": "UH1H",
	"./custom/nakagawa/mama/layer5/03_short_brown.png": "GgZs",
	"./custom/nakagawa/mama/layer5/03_short_gold.png": "RNtw",
	"./custom/nakagawa/mama/layer5/03_short_grey.png": "mcSc",
	"./custom/nakagawa/mama/layer5/04_long_black.png": "VNUk",
	"./custom/nakagawa/mama/layer5/04_long_brown.png": "FkxW",
	"./custom/nakagawa/mama/layer5/04_long_gold.png": "IxKy",
	"./custom/nakagawa/mama/layer5/04_long_grey.png": "z7Pp",
	"./custom/nakagawa/mama/layer5/04_medium_black.png": "H62f",
	"./custom/nakagawa/mama/layer5/04_medium_brown.png": "UjKI",
	"./custom/nakagawa/mama/layer5/04_medium_gold.png": "IvoO",
	"./custom/nakagawa/mama/layer5/04_medium_grey.png": "OGmH",
	"./custom/nakagawa/mama/layer5/05_long_black.png": "h+QQ",
	"./custom/nakagawa/mama/layer5/05_long_brown.png": "fLZr",
	"./custom/nakagawa/mama/layer5/05_long_gold.png": "zysV",
	"./custom/nakagawa/mama/layer5/05_long_grey.png": "jdTJ",
	"./custom/nakagawa/mama/layer5/05_medium_black.png": "0Jz+",
	"./custom/nakagawa/mama/layer5/05_medium_brown.png": "MdHh",
	"./custom/nakagawa/mama/layer5/05_medium_gold.png": "zhSO",
	"./custom/nakagawa/mama/layer5/05_medium_grey.png": "zZXW",
	"./custom/nakagawa/mama/layer5/06_long_black.png": "dftd",
	"./custom/nakagawa/mama/layer5/06_long_brown.png": "a6H1",
	"./custom/nakagawa/mama/layer5/06_long_gold.png": "98QJ",
	"./custom/nakagawa/mama/layer5/06_long_grey.png": "x364",
	"./custom/nakagawa/mama/layer5/06_medium_black.png": "fbRa",
	"./custom/nakagawa/mama/layer5/06_medium_brown.png": "lT7J",
	"./custom/nakagawa/mama/layer5/06_medium_gold.png": "cFEx",
	"./custom/nakagawa/mama/layer5/06_medium_grey.png": "hZn8",
	"./custom/nakagawa/mama/layer5/07_medium_black.png": "vgQk",
	"./custom/nakagawa/mama/layer5/07_medium_brown.png": "FPX9",
	"./custom/nakagawa/mama/layer5/07_medium_gold.png": "2Va9",
	"./custom/nakagawa/mama/layer5/07_medium_grey.png": "Quw1",
	"./custom/nakagawa/papa/layer1/01_face.png": "Cpg2",
	"./custom/nakagawa/papa/layer1/02_face.png": "QMl8",
	"./custom/nakagawa/papa/layer1/03_face.png": "/nKf",
	"./custom/nakagawa/papa/layer1/04_face.png": "Wn1f",
	"./custom/nakagawa/papa/layer1/05_face.png": "A++e",
	"./custom/nakagawa/papa/layer1/06_face.png": "4213",
	"./custom/nakagawa/papa/layer1/07_face.png": "OND2",
	"./custom/nakagawa/papa/layer1/08_face.png": "JNSV",
	"./custom/nakagawa/papa/layer1/09_face.png": "wOSZ",
	"./custom/nakagawa/papa/layer2/00_mole.png": "r5E0",
	"./custom/nakagawa/papa/layer2/01_mole.png": "DUIH",
	"./custom/nakagawa/papa/layer2/02_mole.png": "PXVH",
	"./custom/nakagawa/papa/layer2/03_mole.png": "Hk6V",
	"./custom/nakagawa/papa/layer2/04_mole.png": "nWgb",
	"./custom/nakagawa/papa/layer2/05_mole.png": "GYDW",
	"./custom/nakagawa/papa/layer2/06_mole.png": "fFVG",
	"./custom/nakagawa/papa/layer2/07_mole.png": "6tmJ",
	"./custom/nakagawa/papa/layer2/08_mole.png": "AtD4",
	"./custom/nakagawa/papa/layer2/09_mole.png": "8QoL",
	"./custom/nakagawa/papa/layer2/10_mole.png": "ATq1",
	"./custom/nakagawa/papa/layer3/00_cheek.png": "7Qzy",
	"./custom/nakagawa/papa/layer3/01_mustache_brown.png": "GcEJ",
	"./custom/nakagawa/papa/layer3/01_mustache_grey.png": "vzFV",
	"./custom/nakagawa/papa/layer3/02_mustache_brown.png": "dbql",
	"./custom/nakagawa/papa/layer3/02_mustache_grey.png": "23aY",
	"./custom/nakagawa/papa/layer3/03_mustache_brown.png": "wO2C",
	"./custom/nakagawa/papa/layer3/03_mustache_grey.png": "NTE8",
	"./custom/nakagawa/papa/layer3/04_mustache_brown.png": "TBu3",
	"./custom/nakagawa/papa/layer3/04_mustache_grey.png": "K8UE",
	"./custom/nakagawa/papa/layer3/05_mustache_brown.png": "PGXp",
	"./custom/nakagawa/papa/layer3/05_mustache_grey.png": "p8aK",
	"./custom/nakagawa/papa/layer3/06_mustache_brown.png": "8btL",
	"./custom/nakagawa/papa/layer3/06_mustache_grey.png": "2P2E",
	"./custom/nakagawa/papa/layer3/07_mustache_brown.png": "OVV6",
	"./custom/nakagawa/papa/layer3/07_mustache_grey.png": "Wk32",
	"./custom/nakagawa/papa/layer3/08_mustache_brown.png": "AcYh",
	"./custom/nakagawa/papa/layer3/08_mustache_grey.png": "aqes",
	"./custom/nakagawa/papa/layer3/09_mustache_brown.png": "1N9x",
	"./custom/nakagawa/papa/layer3/09_mustache_grey.png": "DQHC",
	"./custom/nakagawa/papa/layer3/10_mustache_brown.png": "jTTj",
	"./custom/nakagawa/papa/layer3/10_mustache_grey.png": "XwbS",
	"./custom/nakagawa/papa/layer3/11_mustache_brown.png": "4xCI",
	"./custom/nakagawa/papa/layer3/11_mustache_grey.png": "NFtG",
	"./custom/nakagawa/papa/layer4/00_glasses.png": "oI3p",
	"./custom/nakagawa/papa/layer4/01_glasses_black.png": "258s",
	"./custom/nakagawa/papa/layer4/01_glasses_blue.png": "foZb",
	"./custom/nakagawa/papa/layer4/01_glasses_red.png": "l8DW",
	"./custom/nakagawa/papa/layer4/02_glasses_black.png": "eM0c",
	"./custom/nakagawa/papa/layer4/02_glasses_blue.png": "nPk5",
	"./custom/nakagawa/papa/layer4/02_glasses_red.png": "ESRn",
	"./custom/nakagawa/papa/layer4/03_glasses_black.png": "Dmgh",
	"./custom/nakagawa/papa/layer4/03_glasses_blue.png": "YCtB",
	"./custom/nakagawa/papa/layer4/03_glasses_red.png": "a85V",
	"./custom/nakagawa/papa/layer4/04_glasses_black.png": "CMzQ",
	"./custom/nakagawa/papa/layer4/04_glasses_blue.png": "DrBf",
	"./custom/nakagawa/papa/layer4/04_glasses_red.png": "+DMJ",
	"./custom/nakagawa/papa/layer4/05_glasses_black.png": "PoMO",
	"./custom/nakagawa/papa/layer4/05_glasses_blue.png": "HJ97",
	"./custom/nakagawa/papa/layer4/05_glasses_red.png": "ztbL",
	"./custom/nakagawa/papa/layer5/00_hair.png": "Uf4t",
	"./custom/nakagawa/papa/layer5/01_long_black.png": "ac2V",
	"./custom/nakagawa/papa/layer5/01_long_brown.png": "KgNm",
	"./custom/nakagawa/papa/layer5/01_long_gold.png": "yBxe",
	"./custom/nakagawa/papa/layer5/01_long_grey.png": "Q2GF",
	"./custom/nakagawa/papa/layer5/01_medium_black.png": "g9S6",
	"./custom/nakagawa/papa/layer5/01_medium_brown.png": "9nQd",
	"./custom/nakagawa/papa/layer5/01_medium_gold.png": "vxtb",
	"./custom/nakagawa/papa/layer5/01_medium_grey.png": "cN8K",
	"./custom/nakagawa/papa/layer5/01_short_black.png": "RkO9",
	"./custom/nakagawa/papa/layer5/01_short_brown.png": "t8Ae",
	"./custom/nakagawa/papa/layer5/01_short_gold.png": "0Oa6",
	"./custom/nakagawa/papa/layer5/01_short_grey.png": "BaRr",
	"./custom/nakagawa/papa/layer5/01_very_short_black.png": "d7LC",
	"./custom/nakagawa/papa/layer5/01_very_short_brown.png": "0U5X",
	"./custom/nakagawa/papa/layer5/01_very_short_gold.png": "lAlN",
	"./custom/nakagawa/papa/layer5/01_very_short_grey.png": "Qs9N",
	"./custom/nakagawa/papa/layer5/02_long_black.png": "CHsu",
	"./custom/nakagawa/papa/layer5/02_long_brown.png": "Viu2",
	"./custom/nakagawa/papa/layer5/02_long_gold.png": "hNxT",
	"./custom/nakagawa/papa/layer5/02_long_grey.png": "KmzR",
	"./custom/nakagawa/papa/layer5/02_medium_black.png": "Y2js",
	"./custom/nakagawa/papa/layer5/02_medium_brown.png": "0ZIy",
	"./custom/nakagawa/papa/layer5/02_medium_gold.png": "ftjI",
	"./custom/nakagawa/papa/layer5/02_medium_grey.png": "c18D",
	"./custom/nakagawa/papa/layer5/02_short_black.png": "7QM9",
	"./custom/nakagawa/papa/layer5/02_short_brown.png": "NcEo",
	"./custom/nakagawa/papa/layer5/02_short_gold.png": "Cb53",
	"./custom/nakagawa/papa/layer5/02_short_grey.png": "CYTr",
	"./custom/nakagawa/papa/layer5/02_very_short_black.png": "f7YU",
	"./custom/nakagawa/papa/layer5/02_very_short_brown.png": "xQWn",
	"./custom/nakagawa/papa/layer5/02_very_short_gold.png": "3DVN",
	"./custom/nakagawa/papa/layer5/02_very_short_grey.png": "Yy3Z",
	"./custom/nakagawa/papa/layer5/03_long_black.png": "ihMX",
	"./custom/nakagawa/papa/layer5/03_long_brown.png": "ZaPi",
	"./custom/nakagawa/papa/layer5/03_long_gold.png": "gBFU",
	"./custom/nakagawa/papa/layer5/03_long_grey.png": "xrdA",
	"./custom/nakagawa/papa/layer5/03_medium_black.png": "d0U6",
	"./custom/nakagawa/papa/layer5/03_medium_brown.png": "mHno",
	"./custom/nakagawa/papa/layer5/03_medium_gold.png": "LfJc",
	"./custom/nakagawa/papa/layer5/03_medium_grey.png": "yPd7",
	"./custom/nakagawa/papa/layer5/03_short_black.png": "LiAm",
	"./custom/nakagawa/papa/layer5/03_short_brown.png": "rDDT",
	"./custom/nakagawa/papa/layer5/03_short_gold.png": "J30l",
	"./custom/nakagawa/papa/layer5/03_short_grey.png": "oCzz",
	"./custom/nakagawa/papa/layer5/03_very_short_black.png": "K69c",
	"./custom/nakagawa/papa/layer5/03_very_short_brown.png": "GaHT",
	"./custom/nakagawa/papa/layer5/03_very_short_gold.png": "lXst",
	"./custom/nakagawa/papa/layer5/03_very_short_grey.png": "hC0A",
	"./custom/nakagawa/papa/layer5/04_long_black.png": "RzQF",
	"./custom/nakagawa/papa/layer5/04_long_brown.png": "WNnl",
	"./custom/nakagawa/papa/layer5/04_long_gold.png": "OMUA",
	"./custom/nakagawa/papa/layer5/04_long_grey.png": "EomH",
	"./custom/nakagawa/papa/layer5/04_medium_black.png": "OLII",
	"./custom/nakagawa/papa/layer5/04_medium_brown.png": "tgK+",
	"./custom/nakagawa/papa/layer5/04_medium_gold.png": "1Qis",
	"./custom/nakagawa/papa/layer5/04_medium_grey.png": "IJb9",
	"./custom/nakagawa/papa/layer5/04_short_black.png": "lg9F",
	"./custom/nakagawa/papa/layer5/04_short_brown.png": "u8+C",
	"./custom/nakagawa/papa/layer5/04_short_gold.png": "1F6A",
	"./custom/nakagawa/papa/layer5/04_short_grey.png": "5BaX",
	"./custom/nakagawa/papa/layer5/04_very_short_black.png": "iahk",
	"./custom/nakagawa/papa/layer5/04_very_short_brown.png": "/dGw",
	"./custom/nakagawa/papa/layer5/04_very_short_gold.png": "BKR9",
	"./custom/nakagawa/papa/layer5/04_very_short_grey.png": "dCXs",
	"./custom/nakagawa/papa/layer5/05_short_black.png": "znAT",
	"./custom/nakagawa/papa/layer5/05_short_brown.png": "sc/g",
	"./custom/nakagawa/papa/layer5/05_short_gold.png": "76tD",
	"./custom/nakagawa/papa/layer5/05_short_grey.png": "W2PL",
	"./custom/okuta/dad/layer1/01_face.png": "y10w",
	"./custom/okuta/dad/layer1/02_face.png": "Bvs+",
	"./custom/okuta/dad/layer2/00_mole.png": "ZSzX",
	"./custom/okuta/dad/layer2/01_mole.png": "XUVB",
	"./custom/okuta/dad/layer2/02_mole.png": "xjwR",
	"./custom/okuta/dad/layer2/03_mole.png": "h0lT",
	"./custom/okuta/dad/layer2/04_mole.png": "x8qH",
	"./custom/okuta/dad/layer2/05_mole.png": "KQEm",
	"./custom/okuta/dad/layer2/06_mole.png": "OiWJ",
	"./custom/okuta/dad/layer2/07_mole.png": "LQ5W",
	"./custom/okuta/dad/layer2/08_mole.png": "iAEH",
	"./custom/okuta/dad/layer2/09_mole.png": "qlm/",
	"./custom/okuta/dad/layer2/10_mole.png": "NONd",
	"./custom/okuta/dad/layer3/00_hige.png": "WkR8",
	"./custom/okuta/dad/layer3/01_hige_black.png": "Ohso",
	"./custom/okuta/dad/layer3/01_hige_gray.png": "Lg38",
	"./custom/okuta/dad/layer3/02_hige_black.png": "M6Vu",
	"./custom/okuta/dad/layer3/02_hige_gray.png": "bEjW",
	"./custom/okuta/dad/layer3/03_hige_black.png": "vCus",
	"./custom/okuta/dad/layer3/03_hige_gray.png": "yd/i",
	"./custom/okuta/dad/layer3/04_hige_black.png": "FtZH",
	"./custom/okuta/dad/layer3/04_hige_gray.png": "6PWl",
	"./custom/okuta/dad/layer3/05_hige_black.png": "IsXX",
	"./custom/okuta/dad/layer3/05_hige_gray.png": "CFDI",
	"./custom/okuta/dad/layer3/06_hige_black.png": "vlXd",
	"./custom/okuta/dad/layer3/06_hige_gray.png": "muGq",
	"./custom/okuta/dad/layer3/07_hige_black.png": "nkjf",
	"./custom/okuta/dad/layer3/07_hige_gray.png": "tMQJ",
	"./custom/okuta/dad/layer3/08_hige_black.png": "aAHq",
	"./custom/okuta/dad/layer3/08_hige_gray.png": "yQKU",
	"./custom/okuta/dad/layer3/09_hige_black.png": "0tSy",
	"./custom/okuta/dad/layer3/09_hige_gray.png": "YOP7",
	"./custom/okuta/dad/layer3/10_hige_black.png": "jpwU",
	"./custom/okuta/dad/layer3/10_hige_gray.png": "qd/H",
	"./custom/okuta/dad/layer3/11_hige_black.png": "ktPM",
	"./custom/okuta/dad/layer3/11_hige_gray.png": "7HLw",
	"./custom/okuta/dad/layer4/00_glasses.png": "zSWd",
	"./custom/okuta/dad/layer4/01_glasses_black.png": "eShy",
	"./custom/okuta/dad/layer4/01_glasses_brown.png": "fe1N",
	"./custom/okuta/dad/layer4/01_glasses_red.png": "5Hun",
	"./custom/okuta/dad/layer4/02_glasses_black.png": "LjYH",
	"./custom/okuta/dad/layer4/02_glasses_brown.png": "RljY",
	"./custom/okuta/dad/layer4/02_glasses_red.png": "P0se",
	"./custom/okuta/dad/layer4/03_glasses_black.png": "AyyB",
	"./custom/okuta/dad/layer4/03_glasses_brown.png": "+hZR",
	"./custom/okuta/dad/layer4/03_glasses_red.png": "4eJE",
	"./custom/okuta/dad/layer4/04_glasses_black.png": "LTbd",
	"./custom/okuta/dad/layer4/04_glasses_brown.png": "DUc3",
	"./custom/okuta/dad/layer4/04_glasses_red.png": "PkdS",
	"./custom/okuta/dad/layer4/05_glasses_black.png": "2Qoh",
	"./custom/okuta/dad/layer4/05_glasses_brown.png": "zzAN",
	"./custom/okuta/dad/layer4/05_glasses_red.png": "d9P1",
	"./custom/okuta/dad/layer5/00_hair.png": "3gKU",
	"./custom/okuta/dad/layer5/01_long_black.png": "fhGp",
	"./custom/okuta/dad/layer5/01_long_brown.png": "MaKZ",
	"./custom/okuta/dad/layer5/01_long_gold.png": "S7hm",
	"./custom/okuta/dad/layer5/01_long_gray.png": "oO4P",
	"./custom/okuta/dad/layer5/01_medium_black.png": "2NL5",
	"./custom/okuta/dad/layer5/01_medium_brown.png": "8YzM",
	"./custom/okuta/dad/layer5/01_medium_gold.png": "jHL7",
	"./custom/okuta/dad/layer5/01_medium_gray.png": "mC73",
	"./custom/okuta/dad/layer5/01_short_black.png": "69rn",
	"./custom/okuta/dad/layer5/01_short_brown.png": "PRSD",
	"./custom/okuta/dad/layer5/01_short_gold.png": "zaQ3",
	"./custom/okuta/dad/layer5/01_short_gray.png": "TWLp",
	"./custom/okuta/dad/layer5/01_veryshort_black.png": "0H4b",
	"./custom/okuta/dad/layer5/01_veryshort_brown.png": "vTJW",
	"./custom/okuta/dad/layer5/01_veryshort_gold.png": "Wo5R",
	"./custom/okuta/dad/layer5/01_veryshort_gray.png": "hkl4",
	"./custom/okuta/dad/layer5/02_long_black.png": "obWI",
	"./custom/okuta/dad/layer5/02_long_brown.png": "rwRO",
	"./custom/okuta/dad/layer5/02_long_gold.png": "+YAX",
	"./custom/okuta/dad/layer5/02_long_gray.png": "RRjc",
	"./custom/okuta/dad/layer5/02_medium_black.png": "ZH4x",
	"./custom/okuta/dad/layer5/02_medium_brown.png": "PFvD",
	"./custom/okuta/dad/layer5/02_medium_gold.png": "JYOr",
	"./custom/okuta/dad/layer5/02_medium_gray.png": "oZcE",
	"./custom/okuta/dad/layer5/02_short_black.png": "x3m9",
	"./custom/okuta/dad/layer5/02_short_brown.png": "kpXc",
	"./custom/okuta/dad/layer5/02_short_gold.png": "YGzo",
	"./custom/okuta/dad/layer5/02_short_gray.png": "3wNq",
	"./custom/okuta/dad/layer5/02_veryshort_black.png": "3t9J",
	"./custom/okuta/dad/layer5/02_veryshort_brown.png": "Yp8p",
	"./custom/okuta/dad/layer5/02_veryshort_gold.png": "246J",
	"./custom/okuta/dad/layer5/02_veryshort_gray.png": "6GLH",
	"./custom/okuta/dad/layer5/03_long_black.png": "/tsN",
	"./custom/okuta/dad/layer5/03_long_brown.png": "WGtE",
	"./custom/okuta/dad/layer5/03_long_gold.png": "XlYP",
	"./custom/okuta/dad/layer5/03_long_gray.png": "M3br",
	"./custom/okuta/dad/layer5/03_medium_black.png": "t2ZR",
	"./custom/okuta/dad/layer5/03_medium_brown.png": "XXyO",
	"./custom/okuta/dad/layer5/03_medium_gold.png": "0DHj",
	"./custom/okuta/dad/layer5/03_medium_gray.png": "tDv8",
	"./custom/okuta/dad/layer5/03_short_black.png": "b7r4",
	"./custom/okuta/dad/layer5/03_short_brown.png": "DDBx",
	"./custom/okuta/dad/layer5/03_short_gold.png": "H4vX",
	"./custom/okuta/dad/layer5/03_short_gray.png": "HRmg",
	"./custom/okuta/dad/layer5/03_veryshort_black.png": "4rhq",
	"./custom/okuta/dad/layer5/03_veryshort_brown.png": "s7XG",
	"./custom/okuta/dad/layer5/03_veryshort_gold.png": "5J3Z",
	"./custom/okuta/dad/layer5/03_veryshort_gray.png": "gFHU",
	"./custom/okuta/dad/layer5/04_long_black.png": "DRrT",
	"./custom/okuta/dad/layer5/04_long_brown.png": "qrPq",
	"./custom/okuta/dad/layer5/04_long_gold.png": "ThJv",
	"./custom/okuta/dad/layer5/04_long_gray.png": "I1AJ",
	"./custom/okuta/dad/layer5/04_medium_black.png": "IRsi",
	"./custom/okuta/dad/layer5/04_medium_brown.png": "ywuL",
	"./custom/okuta/dad/layer5/04_medium_gold.png": "tVmE",
	"./custom/okuta/dad/layer5/04_medium_gray.png": "aWkj",
	"./custom/okuta/dad/layer5/04_short_black.png": "JAqu",
	"./custom/okuta/dad/layer5/04_short_brown.png": "uB7W",
	"./custom/okuta/dad/layer5/04_short_gold.png": "AyY5",
	"./custom/okuta/dad/layer5/04_short_gray.png": "DVp0",
	"./custom/okuta/dad/layer5/04_veryshort_black.png": "OoTV",
	"./custom/okuta/dad/layer5/04_veryshort_brown.png": "+uhC",
	"./custom/okuta/dad/layer5/04_veryshort_gold.png": "C/Pf",
	"./custom/okuta/dad/layer5/04_veryshort_gray.png": "oNJv",
	"./custom/okuta/dad/layer5/05_medium_black.png": "Yawd",
	"./custom/okuta/dad/layer5/05_medium_brown.png": "PxFY",
	"./custom/okuta/dad/layer5/05_medium_gold.png": "+jA2",
	"./custom/okuta/dad/layer5/05_medium_gray.png": "oBYR",
	"./custom/okuta/dad/layer5/05_short_black.png": "rwsS",
	"./custom/okuta/dad/layer5/05_short_brown.png": "twHN",
	"./custom/okuta/dad/layer5/05_short_gold.png": "7Ve5",
	"./custom/okuta/dad/layer5/05_short_gray.png": "/OH3",
	"./custom/okuta/dad/layer5/05_veryshort_black.png": "halq",
	"./custom/okuta/dad/layer5/05_veryshort_brown.png": "mxj4",
	"./custom/okuta/dad/layer5/05_veryshort_gold.png": "dk7Q",
	"./custom/okuta/dad/layer5/05_veryshort_gray.png": "Vo0M",
	"./custom/okuta/dad/layer5/06_medium_black.png": "cyqZ",
	"./custom/okuta/dad/layer5/06_medium_brown.png": "qOBq",
	"./custom/okuta/dad/layer5/06_medium_gold.png": "BV/V",
	"./custom/okuta/dad/layer5/06_medium_gray.png": "SN0R",
	"./custom/okuta/dad/layer5/06_short_black.png": "xZTS",
	"./custom/okuta/dad/layer5/06_short_brown.png": "c/tf",
	"./custom/okuta/dad/layer5/06_short_gold.png": "O2YA",
	"./custom/okuta/dad/layer5/06_short_gray.png": "SUUx",
	"./custom/okuta/mom/layer1/01_face.png": "DNyN",
	"./custom/okuta/mom/layer1/02_face.png": "Tbq6",
	"./custom/okuta/mom/layer2/00_mole.png": "PUwW",
	"./custom/okuta/mom/layer2/01_mole.png": "Xz9A",
	"./custom/okuta/mom/layer2/02_mole.png": "wT0r",
	"./custom/okuta/mom/layer2/03_mole.png": "vOQg",
	"./custom/okuta/mom/layer2/04_mole.png": "7Ssm",
	"./custom/okuta/mom/layer2/05_mole.png": "vXTT",
	"./custom/okuta/mom/layer2/06_mole.png": "VX/i",
	"./custom/okuta/mom/layer2/07_mole.png": "z4ud",
	"./custom/okuta/mom/layer2/08_mole.png": "aLpO",
	"./custom/okuta/mom/layer2/09_mole.png": "lPTX",
	"./custom/okuta/mom/layer2/10_mole.png": "Cr06",
	"./custom/okuta/mom/layer3/00_cheeks.png": "EDof",
	"./custom/okuta/mom/layer3/01_cheeks.png": "K4Vd",
	"./custom/okuta/mom/layer4/00_glasses.png": "OABX",
	"./custom/okuta/mom/layer4/01_glasses_black.png": "HtZi",
	"./custom/okuta/mom/layer4/01_glasses_brown.png": "znTC",
	"./custom/okuta/mom/layer4/01_glasses_red.png": "IWxU",
	"./custom/okuta/mom/layer4/02_glasses_black.png": "fh1r",
	"./custom/okuta/mom/layer4/02_glasses_brown.png": "oEi8",
	"./custom/okuta/mom/layer4/02_glasses_red.png": "XOTo",
	"./custom/okuta/mom/layer4/03_glasses_black.png": "DOtz",
	"./custom/okuta/mom/layer4/03_glasses_brown.png": "S+7c",
	"./custom/okuta/mom/layer4/03_glasses_red.png": "aOrq",
	"./custom/okuta/mom/layer4/04_glasses_black.png": "Enx5",
	"./custom/okuta/mom/layer4/04_glasses_brown.png": "fZ7G",
	"./custom/okuta/mom/layer4/04_glasses_red.png": "8bvi",
	"./custom/okuta/mom/layer4/05_glasses_black.png": "yUnk",
	"./custom/okuta/mom/layer4/05_glasses_brown.png": "KrEU",
	"./custom/okuta/mom/layer4/05_glasses_red.png": "gGpG",
	"./custom/okuta/mom/layer5/00_hair.png": "B4Xs",
	"./custom/okuta/mom/layer5/01_long_black.png": "oAsz",
	"./custom/okuta/mom/layer5/01_long_brown.png": "ieqQ",
	"./custom/okuta/mom/layer5/01_long_gold.png": "vjul",
	"./custom/okuta/mom/layer5/01_long_gray.png": "RBwu",
	"./custom/okuta/mom/layer5/01_medium_black.png": "bOLv",
	"./custom/okuta/mom/layer5/01_medium_brown.png": "Wkfk",
	"./custom/okuta/mom/layer5/01_medium_gold.png": "PXZ7",
	"./custom/okuta/mom/layer5/01_medium_gray.png": "W+RP",
	"./custom/okuta/mom/layer5/01_short_black.png": "7i1a",
	"./custom/okuta/mom/layer5/01_short_brown.png": "v9dM",
	"./custom/okuta/mom/layer5/01_short_gold.png": "tooc",
	"./custom/okuta/mom/layer5/01_short_gray.png": "86je",
	"./custom/okuta/mom/layer5/02_long_black.png": "NS37",
	"./custom/okuta/mom/layer5/02_long_brown.png": "3MA5",
	"./custom/okuta/mom/layer5/02_long_gold.png": "/06H",
	"./custom/okuta/mom/layer5/02_long_gray.png": "/C4E",
	"./custom/okuta/mom/layer5/02_medium_black.png": "4c9u",
	"./custom/okuta/mom/layer5/02_medium_brown.png": "GJ/B",
	"./custom/okuta/mom/layer5/02_medium_gold.png": "CHJR",
	"./custom/okuta/mom/layer5/02_medium_gray.png": "oOSz",
	"./custom/okuta/mom/layer5/02_short_black.png": "Rijs",
	"./custom/okuta/mom/layer5/02_short_brown.png": "y4dq",
	"./custom/okuta/mom/layer5/02_short_gold.png": "Y3iG",
	"./custom/okuta/mom/layer5/02_short_gray.png": "QUn9",
	"./custom/okuta/mom/layer5/03_long_black.png": "fM1S",
	"./custom/okuta/mom/layer5/03_long_brown.png": "6u19",
	"./custom/okuta/mom/layer5/03_long_gold.png": "P2oK",
	"./custom/okuta/mom/layer5/03_long_gray.png": "M2xc",
	"./custom/okuta/mom/layer5/03_medium_black.png": "ybxO",
	"./custom/okuta/mom/layer5/03_medium_brown.png": "71cH",
	"./custom/okuta/mom/layer5/03_medium_gold.png": "3t3z",
	"./custom/okuta/mom/layer5/03_medium_gray.png": "P3v3",
	"./custom/okuta/mom/layer5/03_short_black.png": "sIui",
	"./custom/okuta/mom/layer5/03_short_brown.png": "AS94",
	"./custom/okuta/mom/layer5/03_short_gold.png": "3BhY",
	"./custom/okuta/mom/layer5/03_short_gray.png": "9ypk",
	"./custom/okuta/mom/layer5/04_long_black.png": "GZpp",
	"./custom/okuta/mom/layer5/04_long_brown.png": "o7B2",
	"./custom/okuta/mom/layer5/04_long_gold.png": "TMBL",
	"./custom/okuta/mom/layer5/04_long_gray.png": "nF9l",
	"./custom/okuta/mom/layer5/04_medium_black.png": "oetc",
	"./custom/okuta/mom/layer5/04_medium_brown.png": "rnYW",
	"./custom/okuta/mom/layer5/04_medium_gold.png": "Vaxy",
	"./custom/okuta/mom/layer5/04_medium_gray.png": "R6xr",
	"./custom/okuta/mom/layer5/04_short_black.png": "SC9C",
	"./custom/okuta/mom/layer5/04_short_brown.png": "hY1O",
	"./custom/okuta/mom/layer5/04_short_gold.png": "CidD",
	"./custom/okuta/mom/layer5/04_short_gray.png": "ckPT",
	"./custom/okuta/mom/layer5/05_long_black.png": "k7+M",
	"./custom/okuta/mom/layer5/05_long_brown.png": "eJum",
	"./custom/okuta/mom/layer5/05_long_gold.png": "uIkE",
	"./custom/okuta/mom/layer5/05_long_gray.png": "y4M8",
	"./custom/okuta/mom/layer5/05_medium_black.png": "RGrA",
	"./custom/okuta/mom/layer5/05_medium_brown.png": "y3DH",
	"./custom/okuta/mom/layer5/05_medium_gold.png": "xW9M",
	"./custom/okuta/mom/layer5/05_medium_gray.png": "zrDK",
	"./custom/okuta/mom/layer5/05_short_black.png": "XlUd",
	"./custom/okuta/mom/layer5/05_short_brown.png": "2llq",
	"./custom/okuta/mom/layer5/05_short_gold.png": "Te9e",
	"./custom/okuta/mom/layer5/05_short_gray.png": "foc4",
	"./custom/okuta/mom/layer5/06_long_black.png": "k6Zu",
	"./custom/okuta/mom/layer5/06_long_brown.png": "qg86",
	"./custom/okuta/mom/layer5/06_long_gold.png": "rd0L",
	"./custom/okuta/mom/layer5/06_long_gray.png": "IoNT",
	"./custom/okuta/mom/layer5/06_medium_black.png": "0YKo",
	"./custom/okuta/mom/layer5/06_medium_brown.png": "Ayoo",
	"./custom/okuta/mom/layer5/06_medium_gold.png": "fOLi",
	"./custom/okuta/mom/layer5/06_medium_gray.png": "l3KI",
	"./custom/okuta/mom/layer5/06_short_black.png": "+S95",
	"./custom/okuta/mom/layer5/06_short_brown.png": "sdmw",
	"./custom/okuta/mom/layer5/06_short_gold.png": "uj+i",
	"./custom/okuta/mom/layer5/06_short_gray.png": "RnLX",
	"./custom/okuta/mom/layer5/07_long_black.png": "8BQP",
	"./custom/okuta/mom/layer5/07_long_brown.png": "bQfg",
	"./custom/okuta/mom/layer5/07_long_gold.png": "7vrE",
	"./custom/okuta/mom/layer5/07_long_gray.png": "VpVt",
	"./custom/okuta/mom/layer5/07_medium_black.png": "rxdI",
	"./custom/okuta/mom/layer5/07_medium_brown.png": "D5Fg",
	"./custom/okuta/mom/layer5/07_medium_gold.png": "+9WO",
	"./custom/okuta/mom/layer5/07_medium_gray.png": "0wY3",
	"./custom/okuta/mom/layer5/08_long_black.png": "9+13",
	"./custom/okuta/mom/layer5/08_long_brown.png": "RwCp",
	"./custom/okuta/mom/layer5/08_long_gold.png": "Dn8B",
	"./custom/okuta/mom/layer5/08_long_gray.png": "BYW7",
	"./custom/okuta/mom/layer5/08_medium_black.png": "NTv6",
	"./custom/okuta/mom/layer5/08_medium_brown.png": "z0ql",
	"./custom/okuta/mom/layer5/08_medium_gold.png": "3QmS",
	"./custom/okuta/mom/layer5/08_medium_gray.png": "21jf",
	"./custom/okuta/son/layer1/01_face.png": "jQlY",
	"./custom/okuta/son/layer1/02_face.png": "DmEA",
	"./custom/okuta/son/layer2/00_mole.png": "6Kbq",
	"./custom/okuta/son/layer2/01_mole.png": "kKnG",
	"./custom/okuta/son/layer2/02_mole.png": "RjTb",
	"./custom/okuta/son/layer2/03_mole.png": "KxdM",
	"./custom/okuta/son/layer2/04_mole.png": "Fj6r",
	"./custom/okuta/son/layer2/05_mole.png": "x3Ub",
	"./custom/okuta/son/layer2/06_mole.png": "hKia",
	"./custom/okuta/son/layer2/07_mole.png": "C44R",
	"./custom/okuta/son/layer2/08_mole.png": "wZXQ",
	"./custom/okuta/son/layer2/09_mole.png": "VaMV",
	"./custom/okuta/son/layer2/10_mole.png": "ajeb",
	"./custom/okuta/son/layer3/00_hige.png": "DozW",
	"./custom/okuta/son/layer3/01_hige_black.png": "lgxR",
	"./custom/okuta/son/layer3/01_hige_gray.png": "+69j",
	"./custom/okuta/son/layer3/02_hige_black.png": "2ayP",
	"./custom/okuta/son/layer3/02_hige_gray.png": "6V74",
	"./custom/okuta/son/layer3/03_hige_black.png": "pMTv",
	"./custom/okuta/son/layer3/03_hige_gray.png": "vPV4",
	"./custom/okuta/son/layer3/04_hige_black.png": "wvxE",
	"./custom/okuta/son/layer3/04_hige_gray.png": "BNCW",
	"./custom/okuta/son/layer3/05_hige_black.png": "7K3g",
	"./custom/okuta/son/layer3/05_hige_gray.png": "p23e",
	"./custom/okuta/son/layer3/06_hige_black.png": "JPMK",
	"./custom/okuta/son/layer3/06_hige_gray.png": "6Pga",
	"./custom/okuta/son/layer3/07_hige_black.png": "TfJW",
	"./custom/okuta/son/layer3/07_hige_gray.png": "62wx",
	"./custom/okuta/son/layer3/08_hige_black.png": "5Epf",
	"./custom/okuta/son/layer3/08_hige_gray.png": "JjLz",
	"./custom/okuta/son/layer3/09_hige_black.png": "qgpM",
	"./custom/okuta/son/layer3/09_hige_gray.png": "+lxi",
	"./custom/okuta/son/layer3/10_hige_black.png": "Txrr",
	"./custom/okuta/son/layer3/10_hige_gray.png": "t21G",
	"./custom/okuta/son/layer3/11_hige_black.png": "32wY",
	"./custom/okuta/son/layer3/11_hige_gray.png": "0e2Z",
	"./custom/okuta/son/layer4/00_glasses.png": "/ofx",
	"./custom/okuta/son/layer4/01_glasses_black.png": "cfgG",
	"./custom/okuta/son/layer4/01_glasses_brown.png": "6rWu",
	"./custom/okuta/son/layer4/01_glasses_red.png": "OUqc",
	"./custom/okuta/son/layer4/02_glasses_black.png": "0w2E",
	"./custom/okuta/son/layer4/02_glasses_brown.png": "zVUv",
	"./custom/okuta/son/layer4/02_glasses_red.png": "tkxF",
	"./custom/okuta/son/layer4/03_glasses_black.png": "+FQD",
	"./custom/okuta/son/layer4/03_glasses_brown.png": "DN0G",
	"./custom/okuta/son/layer4/03_glasses_red.png": "26pW",
	"./custom/okuta/son/layer4/04_glasses_black.png": "PJg0",
	"./custom/okuta/son/layer4/04_glasses_brown.png": "b4i9",
	"./custom/okuta/son/layer4/04_glasses_red.png": "mnCL",
	"./custom/okuta/son/layer4/05_glasses_black.png": "AFhT",
	"./custom/okuta/son/layer4/05_glasses_brown.png": "OzG6",
	"./custom/okuta/son/layer4/05_glasses_red.png": "YyJA",
	"./custom/okuta/son/layer5/00_hair.png": "nijJ",
	"./custom/okuta/son/layer5/01_long_black.png": "4pak",
	"./custom/okuta/son/layer5/01_long_brown.png": "UI0v",
	"./custom/okuta/son/layer5/01_long_gold.png": "+G//",
	"./custom/okuta/son/layer5/01_long_gray.png": "Xzhv",
	"./custom/okuta/son/layer5/01_medium_black.png": "wnZH",
	"./custom/okuta/son/layer5/01_medium_brown.png": "Gqke",
	"./custom/okuta/son/layer5/01_medium_gold.png": "uTAl",
	"./custom/okuta/son/layer5/01_medium_gray.png": "THWx",
	"./custom/okuta/son/layer5/01_short_black.png": "kTO+",
	"./custom/okuta/son/layer5/01_short_brown.png": "bO+E",
	"./custom/okuta/son/layer5/01_short_gold.png": "+lQH",
	"./custom/okuta/son/layer5/01_short_gray.png": "Qoii",
	"./custom/okuta/son/layer5/01_veryshort_black.png": "hHzw",
	"./custom/okuta/son/layer5/01_veryshort_brown.png": "i4E1",
	"./custom/okuta/son/layer5/01_veryshort_gold.png": "8eDL",
	"./custom/okuta/son/layer5/01_veryshort_gray.png": "KJNo",
	"./custom/okuta/son/layer5/02_long_black.png": "MHst",
	"./custom/okuta/son/layer5/02_long_brown.png": "mTgg",
	"./custom/okuta/son/layer5/02_long_gold.png": "A7/f",
	"./custom/okuta/son/layer5/02_long_gray.png": "WwqZ",
	"./custom/okuta/son/layer5/02_medium_black.png": "s6tc",
	"./custom/okuta/son/layer5/02_medium_brown.png": "8yor",
	"./custom/okuta/son/layer5/02_medium_gold.png": "A59a",
	"./custom/okuta/son/layer5/02_medium_gray.png": "Zdcl",
	"./custom/okuta/son/layer5/02_short_black.png": "7DTi",
	"./custom/okuta/son/layer5/02_short_brown.png": "3hLu",
	"./custom/okuta/son/layer5/02_short_gold.png": "hfgj",
	"./custom/okuta/son/layer5/02_short_gray.png": "ZQhu",
	"./custom/okuta/son/layer5/02_veryshort_black.png": "e1Jj",
	"./custom/okuta/son/layer5/02_veryshort_brown.png": "xQb2",
	"./custom/okuta/son/layer5/02_veryshort_gold.png": "3M+f",
	"./custom/okuta/son/layer5/02_veryshort_gray.png": "iTCs",
	"./custom/okuta/son/layer5/03_long_black.png": "glrn",
	"./custom/okuta/son/layer5/03_long_brown.png": "vRKq",
	"./custom/okuta/son/layer5/03_long_gold.png": "zhO1",
	"./custom/okuta/son/layer5/03_long_gray.png": "FoU4",
	"./custom/okuta/son/layer5/03_medium_black.png": "hnZA",
	"./custom/okuta/son/layer5/03_medium_brown.png": "1Zfb",
	"./custom/okuta/son/layer5/03_medium_gold.png": "xRp3",
	"./custom/okuta/son/layer5/03_medium_gray.png": "CnHU",
	"./custom/okuta/son/layer5/03_short_black.png": "cZ3T",
	"./custom/okuta/son/layer5/03_short_brown.png": "7TWm",
	"./custom/okuta/son/layer5/03_short_gold.png": "MKMv",
	"./custom/okuta/son/layer5/03_short_gray.png": "iYjV",
	"./custom/okuta/son/layer5/03_veryshort_black.png": "/2KO",
	"./custom/okuta/son/layer5/03_veryshort_brown.png": "E4h+",
	"./custom/okuta/son/layer5/03_veryshort_gold.png": "jVHR",
	"./custom/okuta/son/layer5/03_veryshort_gray.png": "DVbG",
	"./custom/okuta/son/layer5/04_long_black.png": "5QyU",
	"./custom/okuta/son/layer5/04_long_brown.png": "Yz/O",
	"./custom/okuta/son/layer5/04_long_gold.png": "v9tx",
	"./custom/okuta/son/layer5/04_long_gray.png": "qXkP",
	"./custom/okuta/son/layer5/04_medium_black.png": "Y5Ib",
	"./custom/okuta/son/layer5/04_medium_brown.png": "lCKP",
	"./custom/okuta/son/layer5/04_medium_gold.png": "OVtj",
	"./custom/okuta/son/layer5/04_medium_gray.png": "sRbq",
	"./custom/okuta/son/layer5/04_short_black.png": "z1Sh",
	"./custom/okuta/son/layer5/04_short_brown.png": "8uUw",
	"./custom/okuta/son/layer5/04_short_gold.png": "NS+q",
	"./custom/okuta/son/layer5/04_short_gray.png": "qd74",
	"./custom/okuta/son/layer5/04_veryshort_black.png": "9DdW",
	"./custom/okuta/son/layer5/04_veryshort_brown.png": "l0Wq",
	"./custom/okuta/son/layer5/04_veryshort_gold.png": "vZZh",
	"./custom/okuta/son/layer5/04_veryshort_gray.png": "b7du",
	"./custom/okuta/son/layer5/05_medium_black.png": "pILh",
	"./custom/okuta/son/layer5/05_medium_brown.png": "WO+o",
	"./custom/okuta/son/layer5/05_medium_gold.png": "Ugz6",
	"./custom/okuta/son/layer5/05_medium_gray.png": "TnDN",
	"./custom/okuta/son/layer5/05_short_black.png": "Zjv/",
	"./custom/okuta/son/layer5/05_short_brown.png": "WawP",
	"./custom/okuta/son/layer5/05_short_gold.png": "isaN",
	"./custom/okuta/son/layer5/05_short_gray.png": "Fg07",
	"./custom/okuta/son/layer5/06_medium_black.png": "ciB5",
	"./custom/okuta/son/layer5/06_medium_brown.png": "gYhZ",
	"./custom/okuta/son/layer5/06_medium_gold.png": "5Ckb",
	"./custom/okuta/son/layer5/06_medium_gray.png": "U//3",
	"./female_to_male/band_0.png": "aEPF",
	"./female_to_male/band_1.png": "EpwK",
	"./female_to_male/band_10.png": "q+iV",
	"./female_to_male/band_11.png": "vztM",
	"./female_to_male/band_12.png": "8dE2",
	"./female_to_male/band_13.png": "nYB1",
	"./female_to_male/band_14.png": "QCme",
	"./female_to_male/band_15.png": "cfb7",
	"./female_to_male/band_16.png": "3fOx",
	"./female_to_male/band_2.png": "EZLs",
	"./female_to_male/band_3.png": "1jZE",
	"./female_to_male/band_4.png": "xKHD",
	"./female_to_male/band_5.png": "Smxf",
	"./female_to_male/band_6.png": "gjq7",
	"./female_to_male/band_7.png": "nvK/",
	"./female_to_male/band_8.png": "XXZb",
	"./female_to_male/band_9.png": "rDEc",
	"./female_to_male/bg_panflet_female_to_male.png": "wSBJ",
	"./female_to_male/font_anzu.png": "PaJJ",
	"./female_to_male/font_beautiful.png": "Gpon",
	"./female_to_male/font_darts.png": "Kyp1",
	"./female_to_male/font_genshin.png": "Qzez",
	"./female_to_male/font_hui.png": "Zoog",
	"./female_to_male/font_uzura.png": "aw46",
	"./font1.png": "LfDV",
	"./font2.png": "kdoO",
	"./font3.png": "Gla2",
	"./font4.png": "SniP",
	"./font5.png": "bfR+",
	"./font6.png": "LXK4",
	"./fontmb31.png": "Lbjb",
	"./fromBrideToFather-jp-r.jpg": "rQ5Q",
	"./fromBrideToFather-jp-w.jpg": "5c0y",
	"./fromBrideToFather-we-b.jpg": "Z+aS",
	"./fromBrideToFather-we-g.jpg": "SJGZ",
	"./fromBrideToFather-we-p.jpg": "MRE3",
	"./fromBrideToFather-we-r.jpg": "Cn8f",
	"./fromBrideToFather-we-w.jpg": "0Gun",
	"./fromBrideToFather-we-y.jpg": "SWAS",
	"./fromBrideToMother-jp-r.jpg": "PO81",
	"./fromBrideToMother-jp-w.jpg": "3pWm",
	"./fromBrideToMother-we-b.jpg": "app9",
	"./fromBrideToMother-we-g.jpg": "3FYB",
	"./fromBrideToMother-we-p.jpg": "pjp6",
	"./fromBrideToMother-we-r.jpg": "iJTB",
	"./fromBrideToMother-we-w.jpg": "FfB1",
	"./fromBrideToMother-we-y.jpg": "DcXk",
	"./fromBrideToParents-jp-r.jpg": "MPiF",
	"./fromBrideToParents-jp-w.jpg": "AMEc",
	"./fromBrideToParents-we-b.jpg": "v2Aj",
	"./fromBrideToParents-we-g.jpg": "e4/2",
	"./fromBrideToParents-we-p.jpg": "HXpV",
	"./fromBrideToParents-we-r.jpg": "FXkm",
	"./fromBrideToParents-we-w.jpg": "cs1Z",
	"./fromBrideToParents-we-y.jpg": "tgLT",
	"./fromGroomToFather-jp-b.jpg": "LhdY",
	"./fromGroomToFather-jp-n.jpg": "txUT",
	"./fromGroomToFather-jp-w.jpg": "FtdW",
	"./fromGroomToFather-we-b.jpg": "i2fr",
	"./fromGroomToFather-we-g.jpg": "V+p3",
	"./fromGroomToFather-we-n.jpg": "oEev",
	"./fromGroomToFather-we-w.jpg": "kUhv",
	"./fromGroomToMother-jp-b.jpg": "OO8U",
	"./fromGroomToMother-jp-n.jpg": "u/ih",
	"./fromGroomToMother-jp-w.jpg": "HuKm",
	"./fromGroomToMother-we-b.jpg": "OiM7",
	"./fromGroomToMother-we-g.jpg": "UIHX",
	"./fromGroomToMother-we-n.jpg": "kt0f",
	"./fromGroomToMother-we-w.jpg": "Lb58",
	"./fromGroomToParents-jp-b.jpg": "C2pC",
	"./fromGroomToParents-jp-n.jpg": "ov5z",
	"./fromGroomToParents-jp-w.jpg": "JGxo",
	"./fromGroomToParents-we-b.jpg": "ncwc",
	"./fromGroomToParents-we-g.jpg": "trX4",
	"./fromGroomToParents-we-n.jpg": "bQ6+",
	"./fromGroomToParents-we-w.jpg": "jngW",
	"./logo-header.png": "86og",
	"./male_to_female/band_0.png": "UFgU",
	"./male_to_female/band_1.png": "0VJS",
	"./male_to_female/band_10.png": "aJbo",
	"./male_to_female/band_11.png": "y1mj",
	"./male_to_female/band_12.png": "ETel",
	"./male_to_female/band_13.png": "TztX",
	"./male_to_female/band_14.png": "qmh0",
	"./male_to_female/band_15.png": "5VSS",
	"./male_to_female/band_16.png": "i1/g",
	"./male_to_female/band_2.png": "G+rE",
	"./male_to_female/band_3.png": "HSwS",
	"./male_to_female/band_4.png": "qsTh",
	"./male_to_female/band_5.png": "ayPt",
	"./male_to_female/band_6.png": "/uAs",
	"./male_to_female/band_7.png": "mR1b",
	"./male_to_female/band_8.png": "RWdu",
	"./male_to_female/band_9.png": "WixY",
	"./male_to_female/bg_panflet_male_to_female.png": "AHu5",
	"./menu.jpg": "8INm",
	"./old steps/step2.png": "Sp97",
	"./old steps/step3.png": "/jj9",
	"./old steps/step4.png": "Fq9J",
	"./old steps/step5.png": "PIDA",
	"./parent_to_child/band_0.png": "4orv",
	"./parent_to_child/band_1.png": "4DPQ",
	"./parent_to_child/band_10.png": "qWo4",
	"./parent_to_child/band_11.png": "kLWE",
	"./parent_to_child/band_12.png": "GROo",
	"./parent_to_child/band_13.png": "flg2",
	"./parent_to_child/band_2.png": "WJHy",
	"./parent_to_child/band_3.png": "8xRs",
	"./parent_to_child/band_4.png": "KflN",
	"./parent_to_child/band_5.png": "KikK",
	"./parent_to_child/band_6.png": "YmUE",
	"./parent_to_child/band_7.png": "3CaD",
	"./parent_to_child/band_8.png": "OPil",
	"./parent_to_child/band_9.png": "ZUII",
	"./parent_to_child/bg_panflet_mama.png": "/KIb",
	"./parent_to_child/bg_panflet_papa.png": "l/bB",
	"./parent_to_child/font_anzu.png": "Bqpq",
	"./parent_to_child/font_banana.png": "6D5P",
	"./parent_to_child/font_beautiful.png": "Pjz/",
	"./parent_to_child/font_darts.png": "lbbI",
	"./parent_to_child/font_genshin.png": "rU2z",
	"./parent_to_child/font_hui.png": "IMpw",
	"./parent_to_child/font_kacho.png": "GjrF",
	"./parent_to_child/font_malecharacter.png": "1MFH",
	"./parent_to_child/font_uzura.png": "TRHO",
	"./reading.jpg": "Vuk+",
	"./step1.jpg": "Ftv8",
	"./step1_C2P_aoyama_bridal.jpg": "xzgm",
	"./step1_C2P_okuta_bridal.jpg": "GF++",
	"./step1_F2M_kanai_bridal.jpg": "La3S",
	"./step1_M2F_kanai_bridal.jpg": "KPK4",
	"./step1_M2F_nakagawa_bridal.jpg": "/rGg",
	"./step1_child_to_parent_daughter.jpg": "h6lp",
	"./step1_child_to_parent_son.jpg": "ksc9",
	"./step1_female_to_male.jpg": "xZiA",
	"./step1_parent_to_child.jpg": "a1z+",
	"./step2.jpg": "zY6z",
	"./step2_child_to_parent_daughter.jpg": "DGjy",
	"./step2_child_to_parent_son.jpg": "AYBQ",
	"./step2_parent_to_child.jpg": "0WEr",
	"./step3.jpg": "l3y/",
	"./step3.png": "blz1",
	"./step3_child_to_parent_daughter.jpg": "uBw7",
	"./step3_child_to_parent_son.jpg": "Fsbj",
	"./step3_female_to_male.jpg": "mgUC",
	"./step3_parent_to_child.jpg": "uXGd",
	"./step4.jpg": "pgMy",
	"./step4.png": "wobW",
	"./step4_C2P_aoyama_bridal.jpg": "DpO1",
	"./step4_C2P_okuta_bridal.jpg": "GP5V",
	"./step4_F2M_kanai_bridal.jpg": "hViz",
	"./step4_M2F_kanai_bridal.jpg": "Ebbu",
	"./step4_M2F_nakagawa_bridal.jpg": "CqsS",
	"./step4_child_to_parent_daughter.jpg": "l0Kd",
	"./step4_child_to_parent_son.jpg": "/Am9",
	"./step4_female_to_male.jpg": "Rebw",
	"./step4_parent_to_child.jpg": "8mUd",
	"./step4_parent_to_child2.jpg": "l6ju",
	"./step5.jpg": "Tb3F",
	"./step5.png": "P3RW",
	"./step5_C2P_aoyama_bridal.jpg": "8aE2",
	"./step5_C2P_okuta_bridal.jpg": "TQuq",
	"./step5_F2M_kanai_bridal.jpg": "ARra",
	"./step5_M2F_kanai_bridal.jpg": "V9Bz",
	"./step5_M2F_nakagawa_bridal.jpg": "EmJk",
	"./step5_child_to_parent_daughter.jpg": "AvJV",
	"./step5_child_to_parent_son.jpg": "FEwh",
	"./step5_female_to_male.jpg": "Wqw5",
	"./step5_parent_to_child.jpg": "891q",
	"./stories/aoyama/child_to_parent/a.no1.jpg": "y4ho",
	"./stories/aoyama/child_to_parent/a.no2.jpg": "fP7k",
	"./stories/aoyama/child_to_parent/aa.no1.jpg": "141R",
	"./stories/aoyama/child_to_parent/aa.no2.jpg": "S+V6",
	"./stories/aoyama/child_to_parent/ab.no2.jpg": "KKmO",
	"./stories/aoyama/child_to_parent/ab1.no1.jpg": "qW+w",
	"./stories/aoyama/child_to_parent/ab2.no1.jpg": "UO7C",
	"./stories/aoyama/child_to_parent/ab3.no1.jpg": "x5pl",
	"./stories/aoyama/child_to_parent/ac.no1.jpg": "Nqfc",
	"./stories/aoyama/child_to_parent/ac.no2.jpg": "UKGs",
	"./stories/aoyama/child_to_parent/ad.no1.jpg": "0ftW",
	"./stories/aoyama/child_to_parent/ad.no2.jpg": "VNGM",
	"./stories/aoyama/child_to_parent/ae.no1.jpg": "39jp",
	"./stories/aoyama/child_to_parent/ae.no2.jpg": "vhLa",
	"./stories/aoyama/child_to_parent/af.no1.jpg": "Nsyz",
	"./stories/aoyama/child_to_parent/af.no2.jpg": "pFiQ",
	"./stories/aoyama/child_to_parent/ag.no1.jpg": "UC8m",
	"./stories/aoyama/child_to_parent/ag.no2.jpg": "u7nA",
	"./stories/aoyama/child_to_parent/ah.no1.jpg": "J0pa",
	"./stories/aoyama/child_to_parent/ah.no2.jpg": "X8vJ",
	"./stories/aoyama/child_to_parent/ai.no1.jpg": "RvxE",
	"./stories/aoyama/child_to_parent/ai.no2.jpg": "5UVO",
	"./stories/aoyama/child_to_parent/aj.no1.jpg": "isff",
	"./stories/aoyama/child_to_parent/aj.no2.jpg": "pp0k",
	"./stories/aoyama/child_to_parent/ak.no1.jpg": "sWm/",
	"./stories/aoyama/child_to_parent/ak.no2.jpg": "mMv7",
	"./stories/aoyama/child_to_parent/al.no1.jpg": "Q9Ws",
	"./stories/aoyama/child_to_parent/al.no2.jpg": "zoFW",
	"./stories/aoyama/child_to_parent/am.no1.jpg": "X8pL",
	"./stories/aoyama/child_to_parent/am.no2.jpg": "UZG8",
	"./stories/aoyama/child_to_parent/an.no1.jpg": "13h7",
	"./stories/aoyama/child_to_parent/an.no2.jpg": "vO3V",
	"./stories/aoyama/child_to_parent/ao.no1.jpg": "z+qb",
	"./stories/aoyama/child_to_parent/ao.no2.jpg": "lviG",
	"./stories/aoyama/child_to_parent/ap.no1.jpg": "XZth",
	"./stories/aoyama/child_to_parent/ap.no2.jpg": "P6TK",
	"./stories/aoyama/child_to_parent/aq.no1.jpg": "7zZF",
	"./stories/aoyama/child_to_parent/aq.no2.jpg": "qVQG",
	"./stories/aoyama/child_to_parent/ar.no1.jpg": "/yTo",
	"./stories/aoyama/child_to_parent/ar.no2.jpg": "5J56",
	"./stories/aoyama/child_to_parent/as.no1.jpg": "yeoZ",
	"./stories/aoyama/child_to_parent/as.no2.jpg": "0Dey",
	"./stories/aoyama/child_to_parent/at.no1.jpg": "5NcW",
	"./stories/aoyama/child_to_parent/at.no2.jpg": "puxL",
	"./stories/aoyama/child_to_parent/au.no1.jpg": "NUsB",
	"./stories/aoyama/child_to_parent/au.no2.jpg": "Mue/",
	"./stories/aoyama/child_to_parent/av.no1.jpg": "8nJ7",
	"./stories/aoyama/child_to_parent/av.no2.jpg": "utwF",
	"./stories/aoyama/child_to_parent/aw.no1.jpg": "Zb52",
	"./stories/aoyama/child_to_parent/aw.no2.jpg": "6XsT",
	"./stories/aoyama/child_to_parent/ax.no1.jpg": "k9r7",
	"./stories/aoyama/child_to_parent/ax.no2.jpg": "IjuI",
	"./stories/aoyama/child_to_parent/ay.no1.jpg": "fi8G",
	"./stories/aoyama/child_to_parent/ay.no2.jpg": "kQnP",
	"./stories/aoyama/child_to_parent/az.no1.jpg": "qS0X",
	"./stories/aoyama/child_to_parent/az.no2.jpg": "tvnp",
	"./stories/aoyama/child_to_parent/b.no1.jpg": "OgEd",
	"./stories/aoyama/child_to_parent/b.no2.jpg": "HEke",
	"./stories/aoyama/child_to_parent/ba.no1.jpg": "Yow0",
	"./stories/aoyama/child_to_parent/ba.no2.jpg": "Uvey",
	"./stories/aoyama/child_to_parent/bb1.no1.jpg": "l4Vo",
	"./stories/aoyama/child_to_parent/bb1.no2.jpg": "r9ue",
	"./stories/aoyama/child_to_parent/bb2.no1.jpg": "Mu4g",
	"./stories/aoyama/child_to_parent/bb2.no2.jpg": "7TtW",
	"./stories/aoyama/child_to_parent/bb3.no1.jpg": "HxTF",
	"./stories/aoyama/child_to_parent/bb4.no1.jpg": "mLPh",
	"./stories/aoyama/child_to_parent/bb5.no1.jpg": "6j/5",
	"./stories/aoyama/child_to_parent/bc.no1.jpg": "TvNO",
	"./stories/aoyama/child_to_parent/bc.no2.jpg": "6CMK",
	"./stories/aoyama/child_to_parent/bd.no1.jpg": "xmVF",
	"./stories/aoyama/child_to_parent/bd.no2.jpg": "YK60",
	"./stories/aoyama/child_to_parent/be.no1.jpg": "MeDv",
	"./stories/aoyama/child_to_parent/be.no2.jpg": "AxKc",
	"./stories/aoyama/child_to_parent/bf.no2.jpg": "Ec0N",
	"./stories/aoyama/child_to_parent/bf1.no1.jpg": "fO2f",
	"./stories/aoyama/child_to_parent/bf2.no1.jpg": "yCVO",
	"./stories/aoyama/child_to_parent/bf3.no1.jpg": "GPL/",
	"./stories/aoyama/child_to_parent/bg.no1.jpg": "ronb",
	"./stories/aoyama/child_to_parent/bg.no2.jpg": "okVh",
	"./stories/aoyama/child_to_parent/bh.no1.jpg": "l3+x",
	"./stories/aoyama/child_to_parent/bh.no2.jpg": "ek1X",
	"./stories/aoyama/child_to_parent/c.no1.jpg": "LuU2",
	"./stories/aoyama/child_to_parent/c.no2.jpg": "6nNZ",
	"./stories/aoyama/child_to_parent/d.no1.jpg": "0RE7",
	"./stories/aoyama/child_to_parent/d.no2.jpg": "c71S",
	"./stories/aoyama/child_to_parent/e.no1.jpg": "peyI",
	"./stories/aoyama/child_to_parent/e.no2.jpg": "Va3o",
	"./stories/aoyama/child_to_parent/f.no1.jpg": "vMsR",
	"./stories/aoyama/child_to_parent/f.no2.jpg": "fuXN",
	"./stories/aoyama/child_to_parent/g.no1.jpg": "keJP",
	"./stories/aoyama/child_to_parent/g.no2.jpg": "xqyO",
	"./stories/aoyama/child_to_parent/h.no1.jpg": "Esp7",
	"./stories/aoyama/child_to_parent/h.no2.jpg": "VNFW",
	"./stories/aoyama/child_to_parent/i.no1.jpg": "Brnx",
	"./stories/aoyama/child_to_parent/i.no2.jpg": "/bxh",
	"./stories/aoyama/child_to_parent/j.no1.jpg": "U/ZV",
	"./stories/aoyama/child_to_parent/j.no2.jpg": "CwdU",
	"./stories/aoyama/child_to_parent/k.no1.jpg": "FNvc",
	"./stories/aoyama/child_to_parent/k.no2.jpg": "57tB",
	"./stories/aoyama/child_to_parent/l.no1.jpg": "T+Ev",
	"./stories/aoyama/child_to_parent/l.no2.jpg": "yIOW",
	"./stories/aoyama/child_to_parent/m.no1.jpg": "8EQ+",
	"./stories/aoyama/child_to_parent/m.no2.jpg": "htF6",
	"./stories/aoyama/child_to_parent/n.no1.jpg": "UXxX",
	"./stories/aoyama/child_to_parent/n.no2.jpg": "2+PI",
	"./stories/aoyama/child_to_parent/o.no1.jpg": "wcin",
	"./stories/aoyama/child_to_parent/o.no2.jpg": "VDln",
	"./stories/aoyama/child_to_parent/p.no1.jpg": "zTri",
	"./stories/aoyama/child_to_parent/p.no2.jpg": "OvM5",
	"./stories/aoyama/child_to_parent/q.no1.jpg": "78TL",
	"./stories/aoyama/child_to_parent/q.no2.jpg": "rZnr",
	"./stories/aoyama/child_to_parent/r.no1.jpg": "+V1t",
	"./stories/aoyama/child_to_parent/r.no2.jpg": "PvuK",
	"./stories/aoyama/child_to_parent/s.no1.jpg": "Eo/v",
	"./stories/aoyama/child_to_parent/s.no2.jpg": "En6R",
	"./stories/aoyama/child_to_parent/t.no1.jpg": "OLlQ",
	"./stories/aoyama/child_to_parent/t.no2.jpg": "C+z7",
	"./stories/aoyama/child_to_parent/u.no1.jpg": "gwN5",
	"./stories/aoyama/child_to_parent/u.no2.jpg": "/Cf6",
	"./stories/aoyama/child_to_parent/v.no1.jpg": "sgxf",
	"./stories/aoyama/child_to_parent/v.no2.jpg": "fFPE",
	"./stories/aoyama/child_to_parent/w.no1.jpg": "tOOL",
	"./stories/aoyama/child_to_parent/w.no2.jpg": "GCQN",
	"./stories/aoyama/child_to_parent/x1.no1.jpg": "mjIF",
	"./stories/aoyama/child_to_parent/x1.no2.jpg": "8Nh3",
	"./stories/aoyama/child_to_parent/x2.no1.jpg": "zfja",
	"./stories/aoyama/child_to_parent/x2.no2.jpg": "xZFp",
	"./stories/aoyama/child_to_parent/x3.no1.jpg": "VP9g",
	"./stories/aoyama/child_to_parent/x4.no1.jpg": "oTnR",
	"./stories/aoyama/child_to_parent/x5.no1.jpg": "y8CY",
	"./stories/aoyama/child_to_parent/y.no1.jpg": "e6c2",
	"./stories/aoyama/child_to_parent/y.no2.jpg": "L9iV",
	"./stories/aoyama/child_to_parent/z.no1.jpg": "26gG",
	"./stories/aoyama/child_to_parent/z.no2.jpg": "cSn4",
	"./stories/kanai/a.no1.jpg": "2GWH",
	"./stories/kanai/a.no2.jpg": "0Dg+",
	"./stories/kanai/b.no1.jpg": "ZfB0",
	"./stories/kanai/b.no2.jpg": "oLvR",
	"./stories/kanai/c.no1.jpg": "tc2V",
	"./stories/kanai/c.no2.jpg": "GUqW",
	"./stories/kanai/d.no1.jpg": "j2jn",
	"./stories/kanai/d.no2.jpg": "KO4u",
	"./stories/kanai/d1.no2.jpg": "Fw/F",
	"./stories/kanai/d10.no2.jpg": "sqbK",
	"./stories/kanai/d11.no2.jpg": "mfgU",
	"./stories/kanai/d12.no2.jpg": "2THQ",
	"./stories/kanai/d13.no2.jpg": "5gvU",
	"./stories/kanai/d14.no2.jpg": "36Qr",
	"./stories/kanai/d15.no2.jpg": "Vwev",
	"./stories/kanai/d16.no2.jpg": "BY7e",
	"./stories/kanai/d17.no2.jpg": "g4e6",
	"./stories/kanai/d18.no2.jpg": "5mws",
	"./stories/kanai/d19.no2.jpg": "rR08",
	"./stories/kanai/d2.no2.jpg": "N3Uq",
	"./stories/kanai/d3.no2.jpg": "zj86",
	"./stories/kanai/d4.no2.jpg": "Zq59",
	"./stories/kanai/d5.no2.jpg": "MgQU",
	"./stories/kanai/d6.no2.jpg": "zvo+",
	"./stories/kanai/d7.no2.jpg": "Belk",
	"./stories/kanai/d8.no2.jpg": "SSD6",
	"./stories/kanai/d9.no2.jpg": "+NsR",
	"./stories/kanai/e.no1.jpg": "25Cx",
	"./stories/kanai/e.no2.jpg": "ddUi",
	"./stories/kanai/e1.no2.jpg": "i59R",
	"./stories/kanai/e10.no2.jpg": "to3t",
	"./stories/kanai/e11.no2.jpg": "IaBr",
	"./stories/kanai/e12.no2.jpg": "fq0O",
	"./stories/kanai/e13.no2.jpg": "ddgT",
	"./stories/kanai/e14.no2.jpg": "B/XJ",
	"./stories/kanai/e15.no2.jpg": "LlFV",
	"./stories/kanai/e16.no2.jpg": "ELXr",
	"./stories/kanai/e17.no2.jpg": "9B6d",
	"./stories/kanai/e18.no2.jpg": "gC+s",
	"./stories/kanai/e19.no2.jpg": "NdG9",
	"./stories/kanai/e2.no2.jpg": "ffUR",
	"./stories/kanai/e3.no2.jpg": "DVJk",
	"./stories/kanai/e4.no2.jpg": "AfFL",
	"./stories/kanai/e5.no2.jpg": "GCre",
	"./stories/kanai/e6.no2.jpg": "Je2a",
	"./stories/kanai/e7.no2.jpg": "/221",
	"./stories/kanai/e8.no2.jpg": "wqLv",
	"./stories/kanai/e9.no2.jpg": "EMBq",
	"./stories/kanai/f.no1.jpg": "wT3+",
	"./stories/kanai/f.no2.jpg": "CjQN",
	"./stories/kanai/female_to_male/a.no1.jpg": "AnMQ",
	"./stories/kanai/female_to_male/a.no2.jpg": "zZfV",
	"./stories/kanai/female_to_male/aa.no1.jpg": "m9mC",
	"./stories/kanai/female_to_male/aa.no2.jpg": "B6Pq",
	"./stories/kanai/female_to_male/ab.no1.jpg": "QthW",
	"./stories/kanai/female_to_male/ab.no2.jpg": "6lKS",
	"./stories/kanai/female_to_male/ac.no1.jpg": "zuZT",
	"./stories/kanai/female_to_male/ac.no2.jpg": "gOAo",
	"./stories/kanai/female_to_male/ad.no1.jpg": "tHJp",
	"./stories/kanai/female_to_male/ad.no2.jpg": "V1I4",
	"./stories/kanai/female_to_male/ae.no1.jpg": "8ZeJ",
	"./stories/kanai/female_to_male/ae.no2.jpg": "O9T8",
	"./stories/kanai/female_to_male/b.no1.jpg": "uwrZ",
	"./stories/kanai/female_to_male/b.no2.jpg": "u/8+",
	"./stories/kanai/female_to_male/c.no1.jpg": "TF/A",
	"./stories/kanai/female_to_male/c.no2.jpg": "roXP",
	"./stories/kanai/female_to_male/d.no1.jpg": "PcUw",
	"./stories/kanai/female_to_male/d.no2.jpg": "3dS2",
	"./stories/kanai/female_to_male/e.no1.jpg": "wjtB",
	"./stories/kanai/female_to_male/e.no2.jpg": "W4o+",
	"./stories/kanai/female_to_male/f.no1.jpg": "YcLq",
	"./stories/kanai/female_to_male/f.no2.jpg": "YtJM",
	"./stories/kanai/female_to_male/g.no1.jpg": "VCqA",
	"./stories/kanai/female_to_male/g.no2.jpg": "uY1d",
	"./stories/kanai/female_to_male/h.no1.jpg": "p3Zq",
	"./stories/kanai/female_to_male/h.no2.jpg": "lCu3",
	"./stories/kanai/female_to_male/i.no1.jpg": "wQ1w",
	"./stories/kanai/female_to_male/i.no2.jpg": "c+0J",
	"./stories/kanai/female_to_male/j.no1.jpg": "CbFV",
	"./stories/kanai/female_to_male/j.no2.jpg": "oANZ",
	"./stories/kanai/female_to_male/k.no1.jpg": "qz4A",
	"./stories/kanai/female_to_male/k.no2.jpg": "VUUI",
	"./stories/kanai/female_to_male/l.no1.jpg": "/1O/",
	"./stories/kanai/female_to_male/l.no2.jpg": "omZz",
	"./stories/kanai/female_to_male/m.no1.jpg": "ewse",
	"./stories/kanai/female_to_male/m.no2.jpg": "9Wvj",
	"./stories/kanai/female_to_male/n.no1.jpg": "VfdP",
	"./stories/kanai/female_to_male/n.no2.jpg": "MGEg",
	"./stories/kanai/female_to_male/o.no1.jpg": "BjNe",
	"./stories/kanai/female_to_male/o.no2.jpg": "afY4",
	"./stories/kanai/female_to_male/p.no1.jpg": "1kNF",
	"./stories/kanai/female_to_male/p.no2.jpg": "+uaf",
	"./stories/kanai/female_to_male/q.no1.jpg": "V7KU",
	"./stories/kanai/female_to_male/q.no2.jpg": "GY07",
	"./stories/kanai/female_to_male/r.no1.jpg": "uppF",
	"./stories/kanai/female_to_male/r.no2.jpg": "CaGz",
	"./stories/kanai/female_to_male/s.no1.jpg": "U1H3",
	"./stories/kanai/female_to_male/s.no2.jpg": "3JkG",
	"./stories/kanai/female_to_male/s1.no1.jpg": "FyvE",
	"./stories/kanai/female_to_male/s1.no2.jpg": "oTWm",
	"./stories/kanai/female_to_male/s10.no1.jpg": "gGft",
	"./stories/kanai/female_to_male/s10.no2.jpg": "MjDs",
	"./stories/kanai/female_to_male/s11.no1.jpg": "nNsi",
	"./stories/kanai/female_to_male/s11.no2.jpg": "xFSO",
	"./stories/kanai/female_to_male/s12.no1.jpg": "Z4Te",
	"./stories/kanai/female_to_male/s12.no2.jpg": "I1Tx",
	"./stories/kanai/female_to_male/s13.no1.jpg": "IaFw",
	"./stories/kanai/female_to_male/s13.no2.jpg": "r1/x",
	"./stories/kanai/female_to_male/s14.no1.jpg": "xrBH",
	"./stories/kanai/female_to_male/s14.no2.jpg": "sS5W",
	"./stories/kanai/female_to_male/s15.no1.jpg": "Ygsx",
	"./stories/kanai/female_to_male/s15.no2.jpg": "CUjB",
	"./stories/kanai/female_to_male/s16.no1.jpg": "Dk8M",
	"./stories/kanai/female_to_male/s16.no2.jpg": "AVSF",
	"./stories/kanai/female_to_male/s17.no1.jpg": "/Exy",
	"./stories/kanai/female_to_male/s17.no2.jpg": "u6pf",
	"./stories/kanai/female_to_male/s18.no1.jpg": "eUYL",
	"./stories/kanai/female_to_male/s18.no2.jpg": "pOmM",
	"./stories/kanai/female_to_male/s19.no1.jpg": "35Yf",
	"./stories/kanai/female_to_male/s19.no2.jpg": "oByB",
	"./stories/kanai/female_to_male/s2.no1.jpg": "TqVq",
	"./stories/kanai/female_to_male/s2.no2.jpg": "/OHF",
	"./stories/kanai/female_to_male/s3.no1.jpg": "P30U",
	"./stories/kanai/female_to_male/s3.no2.jpg": "2NYB",
	"./stories/kanai/female_to_male/s4.no1.jpg": "mZhZ",
	"./stories/kanai/female_to_male/s4.no2.jpg": "+66/",
	"./stories/kanai/female_to_male/s5.no1.jpg": "MFnj",
	"./stories/kanai/female_to_male/s5.no2.jpg": "3EBq",
	"./stories/kanai/female_to_male/s6.no1.jpg": "//07",
	"./stories/kanai/female_to_male/s6.no2.jpg": "DuRH",
	"./stories/kanai/female_to_male/s7.no1.jpg": "17mt",
	"./stories/kanai/female_to_male/s7.no2.jpg": "LmHN",
	"./stories/kanai/female_to_male/s8.no1.jpg": "Umff",
	"./stories/kanai/female_to_male/s8.no2.jpg": "Tyb/",
	"./stories/kanai/female_to_male/s9.no1.jpg": "AmJo",
	"./stories/kanai/female_to_male/s9.no2.jpg": "nCb/",
	"./stories/kanai/female_to_male/t.no1.jpg": "kNxj",
	"./stories/kanai/female_to_male/t.no2.jpg": "8Ufm",
	"./stories/kanai/female_to_male/u.no1.jpg": "yxFZ",
	"./stories/kanai/female_to_male/u.no2.jpg": "pULr",
	"./stories/kanai/female_to_male/v.no1.jpg": "S5pH",
	"./stories/kanai/female_to_male/v.no2.jpg": "X8zW",
	"./stories/kanai/female_to_male/w.no1.jpg": "Psr6",
	"./stories/kanai/female_to_male/w.no2.jpg": "SwK8",
	"./stories/kanai/female_to_male/x.no1.jpg": "59az",
	"./stories/kanai/female_to_male/x.no2.jpg": "8NeQ",
	"./stories/kanai/female_to_male/y.no1.jpg": "OWwq",
	"./stories/kanai/female_to_male/y.no2.jpg": "SjWk",
	"./stories/kanai/female_to_male/z.no1.jpg": "fgH8",
	"./stories/kanai/female_to_male/z.no2.jpg": "DpAN",
	"./stories/kanai/g.no1.jpg": "J2xd",
	"./stories/kanai/g.no2.jpg": "wMMg",
	"./stories/kanai/h.no1.jpg": "iuD4",
	"./stories/kanai/h.no2.jpg": "zyJx",
	"./stories/kanai/i.no1.jpg": "duE1",
	"./stories/kanai/i.no2.jpg": "8A/3",
	"./stories/kanai/j.no1.jpg": "8YS3",
	"./stories/kanai/j.no2.jpg": "sWs7",
	"./stories/kanai/k.no1.jpg": "oQLP",
	"./stories/kanai/k.no2.jpg": "krVd",
	"./stories/kanai/l.no1.jpg": "2o9h",
	"./stories/kanai/l.no2.jpg": "9kIC",
	"./stories/kanai/m.no1.jpg": "8r/C",
	"./stories/kanai/m.no2.jpg": "URGJ",
	"./stories/kanai/n.no1.jpg": "xNnj",
	"./stories/kanai/n.no2.jpg": "uUcb",
	"./stories/kanai/o.no1.jpg": "MWF7",
	"./stories/kanai/o.no2.jpg": "MgIx",
	"./stories/kanai/p.no1.jpg": "Nlgu",
	"./stories/kanai/p.no2.jpg": "6fch",
	"./stories/kanai/q.no1.jpg": "uya1",
	"./stories/kanai/q.no2.jpg": "s1dl",
	"./stories/kanai/r.no1.jpg": "n9I4",
	"./stories/kanai/r.no2.jpg": "rpPi",
	"./stories/kanai/s.no1.jpg": "Yc6y",
	"./stories/kanai/s.no2.jpg": "xFqz",
	"./stories/kanai/t.no1.jpg": "/bEA",
	"./stories/kanai/t.no2.jpg": "dhJq",
	"./stories/kanai/u.no1.jpg": "G41n",
	"./stories/kanai/u.no2.jpg": "emb6",
	"./stories/kanai/u1.no2.jpg": "Gqth",
	"./stories/kanai/u10.no2.jpg": "Mfpt",
	"./stories/kanai/u11.no2.jpg": "9/hs",
	"./stories/kanai/u12.no2.jpg": "RX+T",
	"./stories/kanai/u13.no2.jpg": "K4NX",
	"./stories/kanai/u14.no2.jpg": "+iOU",
	"./stories/kanai/u15.no2.jpg": "YB8n",
	"./stories/kanai/u16.no2.jpg": "uouD",
	"./stories/kanai/u17.no2.jpg": "lNWC",
	"./stories/kanai/u18.no2.jpg": "TaSd",
	"./stories/kanai/u19.no2.jpg": "fOzp",
	"./stories/kanai/u2.no2.jpg": "JGLD",
	"./stories/kanai/u3.no2.jpg": "ehpS",
	"./stories/kanai/u4.no2.jpg": "dLAk",
	"./stories/kanai/u5.no2.jpg": "Gs/U",
	"./stories/kanai/u6.no2.jpg": "5uT/",
	"./stories/kanai/u7.no2.jpg": "JHoe",
	"./stories/kanai/u8.no2.jpg": "bVI5",
	"./stories/kanai/u9.no2.jpg": "z5Xg",
	"./stories/momoro/parent_to_child/ptc_momoro_A1.jpg": "vFq1",
	"./stories/momoro/parent_to_child/ptc_momoro_A2.jpg": "CmKN",
	"./stories/momoro/parent_to_child/ptc_momoro_B1.jpg": "eyzk",
	"./stories/momoro/parent_to_child/ptc_momoro_B2.jpg": "GEky",
	"./stories/momoro/parent_to_child/ptc_momoro_C1.jpg": "9POs",
	"./stories/momoro/parent_to_child/ptc_momoro_C2.jpg": "1Wm2",
	"./stories/momoro/parent_to_child/ptc_momoro_D1.jpg": "Y9xr",
	"./stories/momoro/parent_to_child/ptc_momoro_D2.jpg": "nxIw",
	"./stories/momoro/parent_to_child/ptc_momoro_E1.jpg": "KQkj",
	"./stories/momoro/parent_to_child/ptc_momoro_E2.jpg": "CGHv",
	"./stories/momoro/parent_to_child/ptc_momoro_F1.jpg": "ossa",
	"./stories/momoro/parent_to_child/ptc_momoro_F1_2.jpg": "Latz",
	"./stories/momoro/parent_to_child/ptc_momoro_F2.jpg": "w1XD",
	"./stories/momoro/parent_to_child/ptc_momoro_F2_2.jpg": "GdYO",
	"./stories/momoro/parent_to_child/ptc_momoro_G1.jpg": "jqki",
	"./stories/momoro/parent_to_child/ptc_momoro_G1_2.jpg": "wFOL",
	"./stories/momoro/parent_to_child/ptc_momoro_G2.jpg": "SwRw",
	"./stories/momoro/parent_to_child/ptc_momoro_G2_2.jpg": "jnUY",
	"./stories/momoro/parent_to_child/ptc_momoro_H1.jpg": "c8R7",
	"./stories/momoro/parent_to_child/ptc_momoro_H2.jpg": "2FkF",
	"./stories/momoro/parent_to_child/ptc_momoro_I1.jpg": "aohy",
	"./stories/momoro/parent_to_child/ptc_momoro_I2.jpg": "t/Cv",
	"./stories/momoro/parent_to_child/ptc_momoro_J1.jpg": "uERe",
	"./stories/momoro/parent_to_child/ptc_momoro_J2.jpg": "ZbzA",
	"./stories/momoro/parent_to_child/ptc_momoro_K1.jpg": "GBVs",
	"./stories/momoro/parent_to_child/ptc_momoro_K2.jpg": "qiS/",
	"./stories/momoro/parent_to_child/ptc_momoro_L1.jpg": "NvXT",
	"./stories/momoro/parent_to_child/ptc_momoro_L2.jpg": "izBD",
	"./stories/momoro/parent_to_child/ptc_momoro_M1.jpg": "65o9",
	"./stories/momoro/parent_to_child/ptc_momoro_M2.jpg": "/pKs",
	"./stories/momoro/parent_to_child/ptc_momoro_N1.jpg": "pWHI",
	"./stories/momoro/parent_to_child/ptc_momoro_N2.jpg": "d/h7",
	"./stories/momoro/parent_to_child/ptc_momoro_O1.jpg": "CxRs",
	"./stories/momoro/parent_to_child/ptc_momoro_O2.jpg": "y4Os",
	"./stories/momoro/parent_to_child/ptc_momoro_P1.jpg": "+AFX",
	"./stories/momoro/parent_to_child/ptc_momoro_P2.jpg": "DO6F",
	"./stories/momoro/parent_to_child/ptc_momoro_Q1.jpg": "RWZ+",
	"./stories/momoro/parent_to_child/ptc_momoro_Q2.jpg": "R2Vp",
	"./stories/momoro/parent_to_child/ptc_momoro_R1.jpg": "qz7Q",
	"./stories/momoro/parent_to_child/ptc_momoro_R2.jpg": "+FnI",
	"./stories/momoro/parent_to_child/ptc_momoro_S1.jpg": "E72e",
	"./stories/momoro/parent_to_child/ptc_momoro_S2.jpg": "qlKT",
	"./stories/momoro/parent_to_child/ptc_momoro_T1.jpg": "BlBy",
	"./stories/momoro/parent_to_child/ptc_momoro_T2.jpg": "i5Gx",
	"./stories/momoro/parent_to_child/ptc_momoro_U1.jpg": "50P6",
	"./stories/momoro/parent_to_child/ptc_momoro_U2.jpg": "zLsy",
	"./stories/momoro/parent_to_child/ptc_momoro_V1.jpg": "JPJX",
	"./stories/momoro/parent_to_child/ptc_momoro_V2.jpg": "jvDB",
	"./stories/momoro/parent_to_child/ptc_momoro_W1.jpg": "h5uP",
	"./stories/momoro/parent_to_child/ptc_momoro_W2.jpg": "na/r",
	"./stories/nakagawa/a.no1.jpg": "Xy6k",
	"./stories/nakagawa/a.no2.jpg": "L7oM",
	"./stories/nakagawa/b.no1.jpg": "2z0I",
	"./stories/nakagawa/b.no2.jpg": "dKbs",
	"./stories/nakagawa/c.no1.jpg": "TFnG",
	"./stories/nakagawa/c.no2.jpg": "0NC3",
	"./stories/nakagawa/d.no1.jpg": "bnSO",
	"./stories/nakagawa/d.no2.jpg": "oTrr",
	"./stories/nakagawa/e.no1.jpg": "xsJv",
	"./stories/nakagawa/e.no2.jpg": "aRmi",
	"./stories/nakagawa/e1.no2.jpg": "ZkqG",
	"./stories/nakagawa/e10.no2.jpg": "3Q+r",
	"./stories/nakagawa/e11.no2.jpg": "puPs",
	"./stories/nakagawa/e12.no2.jpg": "WLrS",
	"./stories/nakagawa/e13.no2.jpg": "Zlqz",
	"./stories/nakagawa/e14.no2.jpg": "KS85",
	"./stories/nakagawa/e15.no2.jpg": "owJW",
	"./stories/nakagawa/e16.no2.jpg": "8p6V",
	"./stories/nakagawa/e17.no2.jpg": "kvPD",
	"./stories/nakagawa/e18.no2.jpg": "ipAY",
	"./stories/nakagawa/e19.no2.jpg": "RREp",
	"./stories/nakagawa/e2.no2.jpg": "AXSr",
	"./stories/nakagawa/e3.no2.jpg": "VaQL",
	"./stories/nakagawa/e4.no2.jpg": "qYmH",
	"./stories/nakagawa/e5.no2.jpg": "elTK",
	"./stories/nakagawa/e6.no2.jpg": "RlX4",
	"./stories/nakagawa/e7.no2.jpg": "6Auv",
	"./stories/nakagawa/e8.no2.jpg": "8XG4",
	"./stories/nakagawa/e9.no2.jpg": "Bha8",
	"./stories/nakagawa/f.no1.jpg": "PUMl",
	"./stories/nakagawa/f.no2.jpg": "J8QA",
	"./stories/nakagawa/g.no1.jpg": "TFx4",
	"./stories/nakagawa/g.no2.jpg": "IX7k",
	"./stories/nakagawa/h.no1.jpg": "Cltf",
	"./stories/nakagawa/h.no2.jpg": "Azg5",
	"./stories/nakagawa/i.no1.jpg": "mq2W",
	"./stories/nakagawa/i.no2.jpg": "LRC4",
	"./stories/nakagawa/j.no1.jpg": "rE6k",
	"./stories/nakagawa/j.no2.jpg": "R5eB",
	"./stories/nakagawa/k.no1.jpg": "m6Bu",
	"./stories/nakagawa/k.no2.jpg": "7hID",
	"./stories/nakagawa/l.no1.jpg": "ngr9",
	"./stories/nakagawa/l.no2.jpg": "xU81",
	"./stories/nakagawa/m.no1.jpg": "em7B",
	"./stories/nakagawa/m.no2.jpg": "EbL+",
	"./stories/nakagawa/n.no1.jpg": "1Rnl",
	"./stories/nakagawa/n.no2.jpg": "9sAp",
	"./stories/nakagawa/o.no1.jpg": "ZcMs",
	"./stories/nakagawa/o.no2.jpg": "csui",
	"./stories/nakagawa/p.no1.jpg": "0nnv",
	"./stories/nakagawa/p.no2.jpg": "8on6",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_A1.jpg": "HgGS",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_A2.jpg": "DXeL",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_B1.jpg": "7pAJ",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_B2.jpg": "spXG",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_C1.jpg": "juEV",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_C2.jpg": "F1c5",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_D1.jpg": "mK2P",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_D2.jpg": "z+FP",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_E1.jpg": "N71Z",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_E2.jpg": "ueAv",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_F1.jpg": "0Gyg",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_F2.jpg": "GnHN",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_G1.jpg": "PBhZ",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_G2.jpg": "NLBw",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_H1.jpg": "FO0W",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_H1_2.jpg": "TqSR",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_H2.jpg": "5yHK",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_H2_2.jpg": "kbZ2",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_I1.jpg": "KvHJ",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_I2.jpg": "vNzd",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_J1.jpg": "w4PY",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_J2.jpg": "BPYU",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_K1.jpg": "jtzF",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_K2.jpg": "0QFp",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_L1.jpg": "jKar",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_L2.jpg": "kkhV",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_M1.jpg": "E6p3",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_M2.jpg": "8rqW",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_N1.jpg": "vIj1",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_N2.jpg": "aMnK",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_O1.jpg": "YDtQ",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_O2.jpg": "lEvm",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_P1.jpg": "pMpv",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_P2.jpg": "J7pj",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_Q1.jpg": "efbr",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_Q2.jpg": "29Qn",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_R1.jpg": "7SS5",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_R2.jpg": "FZbV",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_S1.jpg": "N5Vf",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_S2.jpg": "bR8k",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_T1.jpg": "Ha0C",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_T2.jpg": "fy1a",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_U1.jpg": "XU5P",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_U2.jpg": "hBYa",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_V1.jpg": "7jOc",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_V2.jpg": "SO6T",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_W1.jpg": "tb4H",
	"./stories/nakagawa/parent_to_child/ptc_nakagawa_W2.jpg": "Jj2X",
	"./stories/nakagawa/q.no1.jpg": "3Cyr",
	"./stories/nakagawa/q.no2.jpg": "SRc9",
	"./stories/nakagawa/r.no1.jpg": "29uj",
	"./stories/nakagawa/r.no2.jpg": "cdyz",
	"./stories/nakagawa/s.no1.jpg": "ir13",
	"./stories/nakagawa/s.no2.jpg": "sUUr",
	"./stories/nakagawa/t.no1.jpg": "Nd1C",
	"./stories/nakagawa/t.no2.jpg": "Qjcm",
	"./stories/nakagawa/u.no1.jpg": "XtZy",
	"./stories/nakagawa/u.no2.jpg": "cJe+",
	"./stories/nakagawa/u1.no2.jpg": "hoiT",
	"./stories/nakagawa/u10.no2.jpg": "AT28",
	"./stories/nakagawa/u11.no2.jpg": "8R/I",
	"./stories/nakagawa/u12.no2.jpg": "miy5",
	"./stories/nakagawa/u13.no2.jpg": "HhzS",
	"./stories/nakagawa/u14.no2.jpg": "kUan",
	"./stories/nakagawa/u15.no2.jpg": "89JA",
	"./stories/nakagawa/u16.no2.jpg": "OfwS",
	"./stories/nakagawa/u17.no2.jpg": "UYu6",
	"./stories/nakagawa/u18.no2.jpg": "6Wk8",
	"./stories/nakagawa/u19.no2.jpg": "PaNl",
	"./stories/nakagawa/u2.no2.jpg": "I+tE",
	"./stories/nakagawa/u3.no2.jpg": "03gu",
	"./stories/nakagawa/u4.no2.jpg": "MAAw",
	"./stories/nakagawa/u5.no2.jpg": "z5fp",
	"./stories/nakagawa/u6.no2.jpg": "rUjB",
	"./stories/nakagawa/u7.no2.jpg": "WNxe",
	"./stories/nakagawa/u8.no2.jpg": "nLgH",
	"./stories/nakagawa/u9.no2.jpg": "s59z",
	"./stories/okuta/child_to_parent/a.no1.jpg": "84fV",
	"./stories/okuta/child_to_parent/a.no2.jpg": "UqF/",
	"./stories/okuta/child_to_parent/aa.no1.jpg": "lr5X",
	"./stories/okuta/child_to_parent/aa.no2.jpg": "vsRW",
	"./stories/okuta/child_to_parent/ab1.no1.jpg": "8qWW",
	"./stories/okuta/child_to_parent/ab1.no2.jpg": "KufU",
	"./stories/okuta/child_to_parent/ab2.no1.jpg": "+eg2",
	"./stories/okuta/child_to_parent/ab2.no2.jpg": "SVYB",
	"./stories/okuta/child_to_parent/ab3.no1.jpg": "+up6",
	"./stories/okuta/child_to_parent/ac.no1.jpg": "lv3g",
	"./stories/okuta/child_to_parent/ac.no2.jpg": "0Zre",
	"./stories/okuta/child_to_parent/ad.no1.jpg": "WF6n",
	"./stories/okuta/child_to_parent/ad.no2.jpg": "kQkx",
	"./stories/okuta/child_to_parent/ae.no1.jpg": "OxM5",
	"./stories/okuta/child_to_parent/ae.no2.jpg": "GSEg",
	"./stories/okuta/child_to_parent/af.no1.jpg": "cX/O",
	"./stories/okuta/child_to_parent/af.no2.jpg": "xROz",
	"./stories/okuta/child_to_parent/ag.no1.jpg": "ew46",
	"./stories/okuta/child_to_parent/ag.no2.jpg": "SPI8",
	"./stories/okuta/child_to_parent/ah.no1.jpg": "fT/H",
	"./stories/okuta/child_to_parent/ah.no2.jpg": "6U1R",
	"./stories/okuta/child_to_parent/ai.no1.jpg": "wcE4",
	"./stories/okuta/child_to_parent/ai.no2.jpg": "6UHM",
	"./stories/okuta/child_to_parent/ai1.no2.jpg": "0C0e",
	"./stories/okuta/child_to_parent/ai2.no2.jpg": "qjAm",
	"./stories/okuta/child_to_parent/aj.no1.jpg": "tRFU",
	"./stories/okuta/child_to_parent/aj.no2.jpg": "k3/z",
	"./stories/okuta/child_to_parent/ak.no1.jpg": "iqtQ",
	"./stories/okuta/child_to_parent/ak.no2.jpg": "kMBn",
	"./stories/okuta/child_to_parent/al.no1.jpg": "F0O2",
	"./stories/okuta/child_to_parent/al.no2.jpg": "89sp",
	"./stories/okuta/child_to_parent/am.no1.jpg": "lpE0",
	"./stories/okuta/child_to_parent/am.no2.jpg": "B4Bo",
	"./stories/okuta/child_to_parent/an.no1.jpg": "0UPB",
	"./stories/okuta/child_to_parent/an.no2.jpg": "Qc8r",
	"./stories/okuta/child_to_parent/ao.no1.jpg": "ErfN",
	"./stories/okuta/child_to_parent/ao.no2.jpg": "coVn",
	"./stories/okuta/child_to_parent/ap.no1.jpg": "lkGN",
	"./stories/okuta/child_to_parent/ap.no2.jpg": "OJd2",
	"./stories/okuta/child_to_parent/aq.no1.jpg": "utG1",
	"./stories/okuta/child_to_parent/aq.no2.jpg": "WMoK",
	"./stories/okuta/child_to_parent/ar.no1.jpg": "cZY/",
	"./stories/okuta/child_to_parent/ar.no2.jpg": "gzTY",
	"./stories/okuta/child_to_parent/as.no1.jpg": "AVxF",
	"./stories/okuta/child_to_parent/as.no2.jpg": "CRku",
	"./stories/okuta/child_to_parent/at.no1.jpg": "U/Fn",
	"./stories/okuta/child_to_parent/at.no2.jpg": "lyGy",
	"./stories/okuta/child_to_parent/au.no1.jpg": "/hWM",
	"./stories/okuta/child_to_parent/au.no2.jpg": "NCZE",
	"./stories/okuta/child_to_parent/av.no1.jpg": "WMUD",
	"./stories/okuta/child_to_parent/av.no2.jpg": "1cy/",
	"./stories/okuta/child_to_parent/aw.no1.jpg": "+QTi",
	"./stories/okuta/child_to_parent/aw.no2.jpg": "EHdX",
	"./stories/okuta/child_to_parent/ax.no1.jpg": "wvVP",
	"./stories/okuta/child_to_parent/ax.no2.jpg": "qyjJ",
	"./stories/okuta/child_to_parent/ay.no1.jpg": "0/jl",
	"./stories/okuta/child_to_parent/ay.no2.jpg": "Gcm4",
	"./stories/okuta/child_to_parent/az.no1.jpg": "aL0E",
	"./stories/okuta/child_to_parent/az.no2.jpg": "dAbo",
	"./stories/okuta/child_to_parent/b.no1.jpg": "Y/24",
	"./stories/okuta/child_to_parent/b.no2.jpg": "Oj0Q",
	"./stories/okuta/child_to_parent/ba.no1.jpg": "puqr",
	"./stories/okuta/child_to_parent/ba.no2.jpg": "MLld",
	"./stories/okuta/child_to_parent/bb1.no1.jpg": "UR9E",
	"./stories/okuta/child_to_parent/bb1.no2.jpg": "3oNF",
	"./stories/okuta/child_to_parent/bb2.no1.jpg": "BYlE",
	"./stories/okuta/child_to_parent/bb2.no2.jpg": "sjXl",
	"./stories/okuta/child_to_parent/bb3.no1.jpg": "SHiV",
	"./stories/okuta/child_to_parent/bb3.no2.jpg": "macA",
	"./stories/okuta/child_to_parent/bb4.no1.jpg": "sJCv",
	"./stories/okuta/child_to_parent/bb4.no2.jpg": "KOz/",
	"./stories/okuta/child_to_parent/bb5.no1.jpg": "if/X",
	"./stories/okuta/child_to_parent/bb5.no2.jpg": "C646",
	"./stories/okuta/child_to_parent/bc.no1.jpg": "8AS+",
	"./stories/okuta/child_to_parent/bc.no2.jpg": "ha3S",
	"./stories/okuta/child_to_parent/bd.no1.jpg": "958U",
	"./stories/okuta/child_to_parent/bd.no2.jpg": "1glF",
	"./stories/okuta/child_to_parent/be.no1.jpg": "9icZ",
	"./stories/okuta/child_to_parent/be.no2.jpg": "OThk",
	"./stories/okuta/child_to_parent/bf1.no1.jpg": "K6tj",
	"./stories/okuta/child_to_parent/bf1.no2.jpg": "y9kM",
	"./stories/okuta/child_to_parent/bf2.no1.jpg": "Njlv",
	"./stories/okuta/child_to_parent/bf2.no2.jpg": "/zLR",
	"./stories/okuta/child_to_parent/bf3.no1.jpg": "+IGX",
	"./stories/okuta/child_to_parent/bg.no1.jpg": "Xopo",
	"./stories/okuta/child_to_parent/bg.no2.jpg": "AB5h",
	"./stories/okuta/child_to_parent/bh.no1.jpg": "Yz02",
	"./stories/okuta/child_to_parent/bh.no2.jpg": "MCBu",
	"./stories/okuta/child_to_parent/c.no1.jpg": "P7aW",
	"./stories/okuta/child_to_parent/c.no2.jpg": "FkGM",
	"./stories/okuta/child_to_parent/d.no1.jpg": "q/lc",
	"./stories/okuta/child_to_parent/d.no2.jpg": "JhHZ",
	"./stories/okuta/child_to_parent/e.no1.jpg": "Tj6l",
	"./stories/okuta/child_to_parent/e.no2.jpg": "YudL",
	"./stories/okuta/child_to_parent/e1.no2.jpg": "18+r",
	"./stories/okuta/child_to_parent/e2.no2.jpg": "4aCN",
	"./stories/okuta/child_to_parent/f.no1.jpg": "tAjX",
	"./stories/okuta/child_to_parent/f.no2.jpg": "S87O",
	"./stories/okuta/child_to_parent/g.no1.jpg": "adNE",
	"./stories/okuta/child_to_parent/g.no2.jpg": "s0DU",
	"./stories/okuta/child_to_parent/h.no1.jpg": "2Hhf",
	"./stories/okuta/child_to_parent/h.no2.jpg": "uNq0",
	"./stories/okuta/child_to_parent/i.no1.jpg": "WpI+",
	"./stories/okuta/child_to_parent/i.no2.jpg": "qPii",
	"./stories/okuta/child_to_parent/j.no1.jpg": "zuqK",
	"./stories/okuta/child_to_parent/j.no2.jpg": "7CPn",
	"./stories/okuta/child_to_parent/k.no1.jpg": "X36I",
	"./stories/okuta/child_to_parent/k.no2.jpg": "TstL",
	"./stories/okuta/child_to_parent/l.no1.jpg": "tWWS",
	"./stories/okuta/child_to_parent/l.no2.jpg": "fyvJ",
	"./stories/okuta/child_to_parent/m.no1.jpg": "R3xI",
	"./stories/okuta/child_to_parent/m.no2.jpg": "JBux",
	"./stories/okuta/child_to_parent/n.no1.jpg": "sgmq",
	"./stories/okuta/child_to_parent/n.no2.jpg": "Pm/Q",
	"./stories/okuta/child_to_parent/o.no1.jpg": "tuap",
	"./stories/okuta/child_to_parent/o.no2.jpg": "0gM/",
	"./stories/okuta/child_to_parent/p.no1.jpg": "Qqja",
	"./stories/okuta/child_to_parent/p.no2.jpg": "yLtP",
	"./stories/okuta/child_to_parent/q.no1.jpg": "Ew4i",
	"./stories/okuta/child_to_parent/q.no2.jpg": "GyqI",
	"./stories/okuta/child_to_parent/r.no1.jpg": "/niW",
	"./stories/okuta/child_to_parent/r.no2.jpg": "nBJN",
	"./stories/okuta/child_to_parent/s.no1.jpg": "oz5r",
	"./stories/okuta/child_to_parent/s.no2.jpg": "oln6",
	"./stories/okuta/child_to_parent/t.no1.jpg": "4Xzq",
	"./stories/okuta/child_to_parent/t.no2.jpg": "NFck",
	"./stories/okuta/child_to_parent/u.no1.jpg": "lfoC",
	"./stories/okuta/child_to_parent/u.no2.jpg": "SXLx",
	"./stories/okuta/child_to_parent/v.no1.jpg": "xj9z",
	"./stories/okuta/child_to_parent/v.no2.jpg": "Ur6k",
	"./stories/okuta/child_to_parent/w.no1.jpg": "QSho",
	"./stories/okuta/child_to_parent/w.no2.jpg": "1APp",
	"./stories/okuta/child_to_parent/x1.no1.jpg": "V8f4",
	"./stories/okuta/child_to_parent/x1.no2.jpg": "LeyQ",
	"./stories/okuta/child_to_parent/x2.no1.jpg": "7sLb",
	"./stories/okuta/child_to_parent/x2.no2.jpg": "ToG6",
	"./stories/okuta/child_to_parent/x3.no1.jpg": "GCOx",
	"./stories/okuta/child_to_parent/x3.no2.jpg": "JZoZ",
	"./stories/okuta/child_to_parent/x4.no1.jpg": "2Ele",
	"./stories/okuta/child_to_parent/x4.no2.jpg": "FTNI",
	"./stories/okuta/child_to_parent/x5.no1.jpg": "vRXt",
	"./stories/okuta/child_to_parent/x5.no2.jpg": "mMt7",
	"./stories/okuta/child_to_parent/y.no1.jpg": "jRbH",
	"./stories/okuta/child_to_parent/y.no2.jpg": "J/LG",
	"./stories/okuta/child_to_parent/z.no1.jpg": "wV18",
	"./stories/okuta/child_to_parent/z.no2.jpg": "dg4x",
	"./stories/teikeibun.no1.jpg": "bWm1",
	"./stories/teikeibun.no2.jpg": "7TZi",
	"./stories/teikeibun.no3.jpg": "tgaI",
	"./stories/teikeibun.no4.jpg": "aY+u",
	"./title.jpg": "zD2O",
	"./toBride1-jp-r-b.jpg": "Lj7d",
	"./toBride1-jp-r-n.jpg": "YYbT",
	"./toBride1-jp-r-w.jpg": "4Cak",
	"./toBride1-jp-w-b.jpg": "thb+",
	"./toBride1-jp-w-n.jpg": "Jo/a",
	"./toBride1-jp-w-w.jpg": "aNkr",
	"./toBride1-we-b-b.jpg": "pwtK",
	"./toBride1-we-b-g.jpg": "nJ0e",
	"./toBride1-we-b-n.jpg": "xSVu",
	"./toBride1-we-b-w.jpg": "puyf",
	"./toBride1-we-g-b.jpg": "kS3w",
	"./toBride1-we-g-g.jpg": "m6I/",
	"./toBride1-we-g-n.jpg": "6uZ5",
	"./toBride1-we-g-w.jpg": "tJ02",
	"./toBride1-we-p-b.jpg": "Yxuh",
	"./toBride1-we-p-g.jpg": "iaEx",
	"./toBride1-we-p-n.jpg": "3/Yo",
	"./toBride1-we-p-w.jpg": "910o",
	"./toBride1-we-r-b.jpg": "Ks4O",
	"./toBride1-we-r-g.jpg": "i7jP",
	"./toBride1-we-r-n.jpg": "p/NA",
	"./toBride1-we-r-w.jpg": "awWB",
	"./toBride1-we-w-b.jpg": "WSAs",
	"./toBride1-we-w-g.jpg": "l/Y9",
	"./toBride1-we-w-n.jpg": "X+cN",
	"./toBride1-we-w-w.jpg": "0sg+",
	"./toBride1-we-y-b.jpg": "E03O",
	"./toBride1-we-y-g.jpg": "Shp2",
	"./toBride1-we-y-n.jpg": "QVx7",
	"./toBride1-we-y-w.jpg": "bBz5",
	"./toBride2-jp-r-b.jpg": "ttpw",
	"./toBride2-jp-r-n.jpg": "LpB8",
	"./toBride2-jp-r-w.jpg": "4R1R",
	"./toBride2-jp-w-b.jpg": "mkPW",
	"./toBride2-jp-w-n.jpg": "glyY",
	"./toBride2-jp-w-w.jpg": "WdNr",
	"./toBride2-we-b-b.jpg": "p2Ve",
	"./toBride2-we-b-g.jpg": "falD",
	"./toBride2-we-b-n.jpg": "EQpl",
	"./toBride2-we-b-w.jpg": "KsNw",
	"./toBride2-we-g-b.jpg": "/4Va",
	"./toBride2-we-g-g.jpg": "U2uE",
	"./toBride2-we-g-n.jpg": "tg1l",
	"./toBride2-we-g-w.jpg": "wfyO",
	"./toBride2-we-p-b.jpg": "bJoV",
	"./toBride2-we-p-g.jpg": "nxU3",
	"./toBride2-we-p-n.jpg": "Lb0p",
	"./toBride2-we-p-w.jpg": "rLND",
	"./toBride2-we-r-b.jpg": "AMsk",
	"./toBride2-we-r-g.jpg": "GenI",
	"./toBride2-we-r-n.jpg": "7RfG",
	"./toBride2-we-r-w.jpg": "pElt",
	"./toBride2-we-w-b.jpg": "O5ng",
	"./toBride2-we-w-g.jpg": "73yP",
	"./toBride2-we-w-n.jpg": "zF9q",
	"./toBride2-we-w-w.jpg": "BkW9",
	"./toBride2-we-y-b.jpg": "JRhl",
	"./toBride2-we-y-g.jpg": "ZJbb",
	"./toBride2-we-y-n.jpg": "t1eP",
	"./toBride2-we-y-w.jpg": "1Hju",
	"./toGroom-jp-r-b.jpg": "ZMet",
	"./toGroom-jp-r-n.jpg": "4OD9",
	"./toGroom-jp-r-w.jpg": "JTfW",
	"./toGroom-jp-w-b.jpg": "6BuT",
	"./toGroom-jp-w-n.jpg": "3QP+",
	"./toGroom-jp-w-w.jpg": "VS2j",
	"./toGroom-we-b-b.jpg": "GzVT",
	"./toGroom-we-b-g.jpg": "GJoR",
	"./toGroom-we-b-n.jpg": "/Zvu",
	"./toGroom-we-b-w.jpg": "MKZ7",
	"./toGroom-we-g-b.jpg": "z5DV",
	"./toGroom-we-g-g.jpg": "xLjG",
	"./toGroom-we-g-n.jpg": "B0cS",
	"./toGroom-we-g-w.jpg": "AxNk",
	"./toGroom-we-p-b.jpg": "OZFN",
	"./toGroom-we-p-g.jpg": "kV4y",
	"./toGroom-we-p-n.jpg": "12hp",
	"./toGroom-we-p-w.jpg": "+tmC",
	"./toGroom-we-r-b.jpg": "vGxv",
	"./toGroom-we-r-g.jpg": "DWdE",
	"./toGroom-we-r-n.jpg": "Sn+y",
	"./toGroom-we-r-w.jpg": "FNld",
	"./toGroom-we-w-b.jpg": "XVEs",
	"./toGroom-we-w-g.jpg": "FKe6",
	"./toGroom-we-w-n.jpg": "h8P7",
	"./toGroom-we-w-w.jpg": "ZZh0",
	"./toGroom-we-y-b.jpg": "tt8x",
	"./toGroom-we-y-g.jpg": "7n4m",
	"./toGroom-we-y-n.jpg": "7n1/",
	"./toGroom-we-y-w.jpg": "rsBz",
	"./txtperso.png": "VGYv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yXLF";


//////////////////
// WEBPACK FOOTER
// ./src/imgs ^\.\/.*$
// module id = yXLF
// module chunks = 0